export const sortedMetros = [
    'Aberdeen, SD',
    'Aberdeen, WA',
    'Abilene, TX',
    'Ada, OK',
    'Adrian, MI',
    'Akron, OH',
    'Alamogordo, NM',
    'Albany, GA',
    'Albany, NY',
    'Albany, OR',
    'Albemarle, NC',
    'Albert Lea, MN',
    'Albertville, AL',
    'Albuquerque, NM',
    'Alexandria, LA',
    'Alexandria, MN',
    'Alice, TX',
    'Allentown, PA',
    'Alma, MI',
    'Alpena, MI',
    'Altoona, PA',
    'Altus, OK',
    'Amarillo, TX',
    'Americus, GA',
    'Ames, IA',
    'Amsterdam, NY',
    'Anchorage, AK',
    'Andrews, TX',
    'Angola, IN',
    'Ann Arbor, MI',
    'Anniston, AL',
    'Appleton, WI',
    'Arcadia, FL',
    'Ardmore, OK',
    'Arkadelphia, AR',
    'Asheville, NC',
    'Ashland, OH',
    'Ashtabula, OH',
    'Astoria, OR',
    'Atchison, KS',
    'Athens, GA',
    'Athens, OH',
    'Athens, TN',
    'Athens, TX',
    'Atlanta, GA',
    'Atlantic City, NJ',
    'Auburn, AL',
    'Auburn, IN',
    'Auburn, NY',
    'Augusta, GA',
    'Augusta, ME',
    'Austin, MN',
    'Austin, TX',
    'Bainbridge, GA',
    'Bakersfield, CA',
    'Baltimore, MD',
    'Bangor, ME',
    'Baraboo, WI',
    'Bardstown, KY',
    'Barnstable Town, MA',
    'Barre, VT',
    'Bartlesville, OK',
    'Batavia, NY',
    'Batesville, AR',
    'Baton Rouge, LA',
    'Battle Creek, MI',
    'Bay City, MI',
    'Bay City, TX',
    'Beatrice, NE',
    'Beaumont, TX',
    'Beaver Dam, WI',
    'Beckley, WV',
    'Bedford, IN',
    'Bellefontaine, OH',
    'Bellingham, WA',
    'Bemidji, MN',
    'Bend, OR',
    'Bennettsville, SC',
    'Bennington, VT',
    'Berlin, NH',
    'Big Rapids, MI',
    'Big Spring, TX',
    'Big Stone Gap, VA',
    'Billings, MT',
    'Binghamton, NY',
    'Birmingham, AL',
    'Bismarck, ND',
    'Blackfoot, ID',
    'Blacksburg, VA',
    'Bloomington, IL',
    'Bloomington, IN',
    'Bloomsburg, PA',
    'Bluefield, WV',
    'Blytheville, AR',
    'Bogalusa, LA',
    'Boise City, ID',
    'Boone, NC',
    'Borger, TX',
    'Boston, MA',
    'Boulder, CO',
    'Bowling Green, KY',
    'Bozeman, MT',
    'Bradford, PA',
    'Brainerd, MN',
    'Branson, MO',
    'Breckenridge, CO',
    'Bremerton, WA',
    'Brenham, TX',
    'Brevard, NC',
    'Bridgeport, CT',
    'Brookhaven, MS',
    'Brookings, OR',
    'Brookings, SD',
    'Brownsville, TX',
    'Brownwood, TX',
    'Brunswick, GA',
    'Bucyrus, OH',
    'Buffalo, NY',
    'Burley, ID',
    'Burlington, IA',
    'Burlington, NC',
    'Burlington, VT',
    'Butte, MT',
    'Cadillac, MI',
    'Calhoun, GA',
    'California, MD',
    'Cambridge, MD',
    'Cambridge, OH',
    'Camden, AR',
    'Campbellsville, KY',
    'Canton, OH',
    'Cape Coral, FL',
    'Cape Girardeau, MO',
    'Carbondale, IL',
    'Carlsbad, NM',
    'Carson City, NV',
    'Casper, WY',
    'Cañon City, CO',
    'Cedar City, UT',
    'Cedar Rapids, IA',
    'Cedartown, GA',
    'Celina, OH',
    'Centralia, IL',
    'Centralia, WA',
    'Chambersburg, PA',
    'Champaign, IL',
    'Charleston, IL',
    'Charleston, SC',
    'Charleston, WV',
    'Charlotte, NC',
    'Charlottesville, VA',
    'Chattanooga, TN',
    'Cheyenne, WY',
    'Chicago, IL',
    'Chico, CA',
    'Chillicothe, OH',
    'Cincinnati, OH',
    'Clarksburg, WV',
    'Clarksdale, MS',
    'Clarksville, TN',
    'Clearlake, CA',
    'Cleveland, MS',
    'Cleveland, OH',
    'Cleveland, TN',
    'Clewiston, FL',
    'Clinton, IA',
    'Clovis, NM',
    "Coeur d'Alene, ID",
    'Coffeyville, KS',
    'Coldwater, MI',
    'College Station, TX',
    'Colorado Springs, CO',
    'Columbia, MO',
    'Columbia, SC',
    'Columbus, GA',
    'Columbus, IN',
    'Columbus, MS',
    'Columbus, NE',
    'Columbus, OH',
    'Concord, NH',
    'Connersville, IN',
    'Cookeville, TN',
    'Coos Bay, OR',
    'Cordele, GA',
    'Corinth, MS',
    'Cornelia, GA',
    'Corning, NY',
    'Corpus Christi, TX',
    'Corsicana, TX',
    'Cortland, NY',
    'Corvallis, OR',
    'Coshocton, OH',
    'Craig, CO',
    'Crawfordsville, IN',
    'Crescent City, CA',
    'Crestview, FL',
    'Crossville, TN',
    'Cullman, AL',
    'Cullowhee, NC',
    'Cumberland, MD',
    'Dallas, TX',
    'Dalton, GA',
    'Danville, IL',
    'Danville, KY',
    'Danville, VA',
    'Daphne, AL',
    'Davenport, IA',
    'Dayton, TN',
    'DeRidder, LA',
    'Decatur, AL',
    'Decatur, IL',
    'Decatur, IN',
    'Defiance, OH',
    'Del Rio, TX',
    'Deltona, FL',
    'Deming, NM',
    'Denver, CO',
    'Des Moines, IA',
    'Detroit, MI',
    'Dickinson, ND',
    'Dixon, IL',
    'Dodge City, KS',
    'Dothan, AL',
    'Douglas, GA',
    'Dover, DE',
    'DuBois, PA',
    'Dublin, GA',
    'Dubuque, IA',
    'Duluth, MN',
    'Dumas, TX',
    'Duncan, OK',
    'Durango, CO',
    'Durant, OK',
    'Durham, NC',
    'Dyersburg, TN',
    'Eagle Pass, TX',
    'East Stroudsburg, PA',
    'Easton, MD',
    'Eau Claire, WI',
    'Edwards, CO',
    'Effingham, IL',
    'El Campo, TX',
    'El Centro, CA',
    'El Dorado, AR',
    'El Paso, TX',
    'Elizabeth City, NC',
    'Elizabethtown, KY',
    'Elk City, OK',
    'Elkhart, IN',
    'Elkins, WV',
    'Elko, NV',
    'Ellensburg, WA',
    'Elmira, NY',
    'Emporia, KS',
    'Enid, OK',
    'Enterprise, AL',
    'Erie, PA',
    'Escanaba, MI',
    'Espa-¦ola, NM',
    'Eugene, OR',
    'Eureka, CA',
    'Evanston, WY',
    'Evansville, IN',
    'Fairbanks, AK',
    'Fairfield, IA',
    'Fairmont, WV',
    'Fallon, NV',
    'Fargo, ND',
    'Faribault, MN',
    'Farmington, MO',
    'Farmington, NM',
    'Fayetteville, AR',
    'Fayetteville, NC',
    'Fergus Falls, MN',
    'Fernley, NV',
    'Findlay, OH',
    'Fitzgerald, GA',
    'Flagstaff, AZ',
    'Flint, MI',
    'Florence, AL',
    'Florence, SC',
    'Fond du Lac, WI',
    'Forest City, NC',
    'Forrest City, AR',
    'Fort Collins, CO',
    'Fort Leonard Wood, MO',
    'Fort Madison, IA',
    'Fort Morgan, CO',
    'Fort Polk South, LA',
    'Fort Smith, AR',
    'Fort Wayne, IN',
    'Frankfort, IN',
    'Frankfort, KY',
    'Fredericksburg, TX',
    'Freeport, IL',
    'Fremont, NE',
    'Fremont, OH',
    'Fresno, CA',
    'Gadsden, AL',
    'Gaffney, SC',
    'Gainesville, FL',
    'Gainesville, GA',
    'Gainesville, TX',
    'Galesburg, IL',
    'Gallup, NM',
    'Garden City, KS',
    'Gardnerville Ranchos, NV',
    'Georgetown, SC',
    'Gettysburg, PA',
    'Gillette, WY',
    'Glasgow, KY',
    'Glens Falls, NY',
    'Glenwood Springs, CO',
    'Gloversville, NY',
    'Goldsboro, NC',
    'Grand Forks, ND',
    'Grand Island, NE',
    'Grand Junction, CO',
    'Grand Rapids, MI',
    'Grants Pass, OR',
    'Grants, NM',
    'Great Bend, KS',
    'Great Falls, MT',
    'Greeley, CO',
    'Green Bay, WI',
    'Greeneville, TN',
    'Greensboro, NC',
    'Greensburg, IN',
    'Greenville, MS',
    'Greenville, NC',
    'Greenville, OH',
    'Greenville, SC',
    'Greenwood, MS',
    'Greenwood, SC',
    'Grenada, MS',
    'Gulfport, MS',
    'Guymon, OK',
    'Hagerstown, MD',
    'Hailey, ID',
    'Hammond, LA',
    'Hanford, CA',
    'Hannibal, MO',
    'Harrisburg, PA',
    'Harrison, AR',
    'Harrisonburg, VA',
    'Hartford, CT',
    'Hastings, NE',
    'Hattiesburg, MS',
    'Hays, KS',
    'Heber, UT',
    'Helena, MT',
    'Henderson, NC',
    'Hereford, TX',
    'Hermiston, OR',
    'Hickory, NC',
    'Hillsdale, MI',
    'Hilo, HI',
    'Hilton Head Island, SC',
    'Hinesville, GA',
    'Hobbs, NM',
    'Holland, MI',
    'Homosassa Springs, FL',
    'Hood River, OR',
    'Hot Springs, AR',
    'Houghton, MI',
    'Houma, LA',
    'Houston, TX',
    'Hudson, NY',
    'Huntingdon, PA',
    'Huntington, IN',
    'Huntington, WV',
    'Huntsville, AL',
    'Huntsville, TX',
    'Huron, SD',
    'Hutchinson, KS',
    'Hutchinson, MN',
    'Idaho Falls, ID',
    'Indiana, PA',
    'Indianapolis, IN',
    'Indianola, MS',
    'Iowa City, IA',
    'Iron Mountain, MI',
    'Ithaca, NY',
    'Jackson, MI',
    'Jackson, MS',
    'Jackson, OH',
    'Jackson, TN',
    'Jackson, WY',
    'Jacksonville, FL',
    'Jacksonville, IL',
    'Jacksonville, NC',
    'Jacksonville, TX',
    'Jamestown, ND',
    'Jamestown, NY',
    'Janesville, WI',
    'Jasper, IN',
    'Jefferson City, MO',
    'Jefferson, GA',
    'Jesup, GA',
    'Johnson City, TN',
    'Johnstown, PA',
    'Jonesboro, AR',
    'Joplin, MO',
    'Juneau, AK',
    'Kahului, HI',
    'Kalamazoo, MI',
    'Kalispell, MT',
    'Kankakee, IL',
    'Kansas City, MO',
    'Kapaa, HI',
    'Kearney, NE',
    'Keene, NH',
    'Kendallville, IN',
    'Kennett, MO',
    'Kennewick, WA',
    'Kerrville, TX',
    'Ketchikan, AK',
    'Key West, FL',
    'Kill Devil Hills, NC',
    'Killeen, TX',
    'Kingsport, TN',
    'Kingston, NY',
    'Kingsville, TX',
    'Kinston, NC',
    'Kirksville, MO',
    'Klamath Falls, OR',
    'Knoxville, TN',
    'Kokomo, IN',
    'La Crosse, WI',
    'La Grande, OR',
    'LaGrange, GA',
    'Laconia, NH',
    'Lafayette, IN',
    'Lafayette, LA',
    'Lake Charles, LA',
    'Lake City, FL',
    'Lake Havasu City, AZ',
    'Lakeland, FL',
    'Lancaster, PA',
    'Lansing, MI',
    'Laramie, WY',
    'Laredo, TX',
    'Las Cruces, NM',
    'Las Vegas, NM',
    'Las Vegas, NV',
    'Laurel, MS',
    'Laurinburg, NC',
    'Lawrence, KS',
    'Lawrenceburg, TN',
    'Lawton, OK',
    'Lebanon, MO',
    'Lebanon, PA',
    'Lewisburg, PA',
    'Lewisburg, TN',
    'Lewiston, ID',
    'Lewiston, ME',
    'Lewistown, PA',
    'Lexington, KY',
    'Lexington, NE',
    'Liberal, KS',
    'Lima, OH',
    'Lincoln, IL',
    'Lincoln, NE',
    'Little Rock, AR',
    'Lock Haven, PA',
    'Logan, UT',
    'Logansport, IN',
    'London, KY',
    'Longview, TX',
    'Longview, WA',
    'Los Alamos, NM',
    'Los Angeles, CA',
    'Louisville, KY',
    'Lubbock, TX',
    'Ludington, MI',
    'Lufkin, TX',
    'Lumberton, NC',
    'Lynchburg, VA',
    'Macomb, IL',
    'Macon, GA',
    'Madera, CA',
    'Madison, IN',
    'Madison, WI',
    'Madisonville, KY',
    'Magnolia, AR',
    'Malone, NY',
    'Malvern, AR',
    'Manchester, NH',
    'Manhattan, KS',
    'Manitowoc, WI',
    'Mankato, MN',
    'Mansfield, OH',
    'Marietta, OH',
    'Marinette, WI',
    'Marion, IN',
    'Marion, NC',
    'Marion, OH',
    'Marquette, MI',
    'Marshall, MN',
    'Marshall, MO',
    'Marshalltown, IA',
    'Martin, TN',
    'Martinsville, VA',
    'Maryville, MO',
    'Mason City, IA',
    'Mayfield, KY',
    'Maysville, KY',
    'McAlester, OK',
    'McAllen, TX',
    'McComb, MS',
    'McMinnville, TN',
    'McPherson, KS',
    'Meadville, PA',
    'Medford, OR',
    'Memphis, TN',
    'Menomonie, WI',
    'Merced, CA',
    'Meridian, MS',
    'Mexico, MO',
    'Miami, FL',
    'Miami, OK',
    'Michigan City, IN',
    'Middlesborough, KY',
    'Midland, MI',
    'Midland, TX',
    'Milledgeville, GA',
    'Milwaukee, WI',
    'Mineral Wells, TX',
    'Minneapolis, MN',
    'Minot, ND',
    'Missoula, MT',
    'Mitchell, SD',
    'Moberly, MO',
    'Mobile, AL',
    'Modesto, CA',
    'Monroe, LA',
    'Monroe, MI',
    'Montgomery, AL',
    'Montrose, CO',
    'Morehead City, NC',
    'Morgan City, LA',
    'Morgantown, WV',
    'Morristown, TN',
    'Moscow, ID',
    'Moses Lake, WA',
    'Moultrie, GA',
    'Mount Airy, NC',
    'Mount Pleasant, MI',
    'Mount Pleasant, TX',
    'Mount Sterling, KY',
    'Mount Vernon, OH',
    'Mount Vernon, WA',
    'Mountain Home, AR',
    'Mountain Home, ID',
    'Muncie, IN',
    'Murray, KY',
    'Muscatine, IA',
    'Muskegon, MI',
    'Muskogee, OK',
    'Myrtle Beach, SC',
    'Nacogdoches, TX',
    'Napa, CA',
    'Naples, FL',
    'Nashville, TN',
    'Natchez, MS',
    'Natchitoches, LA',
    'New Bern, NC',
    'New Castle, IN',
    'New Castle, PA',
    'New Haven, CT',
    'New Orleans, LA',
    'New Philadelphia, OH',
    'New Ulm, MN',
    'New York, NY',
    'Newberry, SC',
    'Newport, OR',
    'Newport, TN',
    'Niles, MI',
    'Nogales, AZ',
    'Norfolk, NE',
    'North Platte, NE',
    'North Port, FL',
    'North Vernon, IN',
    'North Wilkesboro, NC',
    'Norwalk, OH',
    'Norwich, CT',
    'Oak Harbor, WA',
    'Ocala, FL',
    'Ocean City, NJ',
    'Odessa, TX',
    'Ogden, UT',
    'Ogdensburg, NY',
    'Oil City, PA',
    'Okeechobee, FL',
    'Oklahoma City, OK',
    'Olean, NY',
    'Olympia, WA',
    'Omaha, NE',
    'Oneonta, NY',
    'Ontario, OR',
    'Opelousas, LA',
    'Orangeburg, SC',
    'Orlando, FL',
    'Oshkosh, WI',
    'Oskaloosa, IA',
    'Othello, WA',
    'Ottawa, KS',
    'Ottumwa, IA',
    'Owatonna, MN',
    'Owensboro, KY',
    'Oxford, MS',
    'Oxnard, CA',
    'Ozark, AL',
    'Paducah, KY',
    'Pahrump, NV',
    'Palatka, FL',
    'Palestine, TX',
    'Palm Bay, FL',
    'Pampa, TX',
    'Panama City, FL',
    'Paragould, AR',
    'Paris, TN',
    'Paris, TX',
    'Parkersburg, WV',
    'Parsons, KS',
    'Payson, AZ',
    'Pensacola, FL',
    'Peoria, IL',
    'Peru, IN',
    'Philadelphia, PA',
    'Phoenix, AZ',
    'Picayune, MS',
    'Pierre, SD',
    'Pine Bluff, AR',
    'Pinehurst, NC',
    'Pittsburg, KS',
    'Pittsburgh, PA',
    'Pittsfield, MA',
    'Plainview, TX',
    'Platteville, WI',
    'Plattsburgh, NY',
    'Plymouth, IN',
    'Pocatello, ID',
    'Point Pleasant, WV',
    'Ponca City, OK',
    'Pontiac, IL',
    'Poplar Bluff, MO',
    'Port Angeles, WA',
    'Port Lavaca, TX',
    'Port St. Lucie, FL',
    'Portales, NM',
    'Portland, ME',
    'Portland, OR',
    'Portsmouth, OH',
    'Pottsville, PA',
    'Price, UT',
    'Prineville, OR',
    'Providence, RI',
    'Provo, UT',
    'Pueblo, CO',
    'Pullman, WA',
    'Punta Gorda, FL',
    'Quincy, IL',
    'Racine, WI',
    'Raleigh, NC',
    'Rapid City, SD',
    'Reading, PA',
    'Red Bluff, CA',
    'Red Wing, MN',
    'Redding, CA',
    'Reno, NV',
    'Rexburg, ID',
    'Richmond, IN',
    'Richmond, KY',
    'Richmond, VA',
    'Rio Grande City, TX',
    'Riverside, CA',
    'Riverton, WY',
    'Roanoke Rapids, NC',
    'Roanoke, VA',
    'Rochelle, IL',
    'Rochester, MN',
    'Rochester, NY',
    'Rock Springs, WY',
    'Rockford, IL',
    'Rockingham, NC',
    'Rocky Mount, NC',
    'Rolla, MO',
    'Rome, GA',
    'Roseburg, OR',
    'Roswell, NM',
    'Russellville, AR',
    'Ruston, LA',
    'Rutland, VT',
    'Sacramento, CA',
    'Safford, AZ',
    'Saginaw, MI',
    'Salem, OH',
    'Salem, OR',
    'Salina, KS',
    'Salinas, CA',
    'Salisbury, MD',
    'Salt Lake City, UT',
    'San Angelo, TX',
    'San Antonio, TX',
    'San Diego, CA',
    'San Francisco, CA',
    'San Jose, CA',
    'San Luis Obispo, CA',
    'Sandpoint, ID',
    'Sandusky, OH',
    'Sanford, NC',
    'Santa Cruz, CA',
    'Santa Fe, NM',
    'Santa Maria, CA',
    'Santa Rosa, CA',
    'Sault Ste. Marie, MI',
    'Savannah, GA',
    'Sayre, PA',
    'Scottsbluff, NE',
    'Scottsboro, AL',
    'Scranton, PA',
    'Searcy, AR',
    'Seattle, WA',
    'Sebastian, FL',
    'Sebring, FL',
    'Sedalia, MO',
    'Selinsgrove, PA',
    'Selma, AL',
    'Seneca Falls, NY',
    'Seneca, SC',
    'Sevierville, TN',
    'Seymour, IN',
    'Shawano, WI',
    'Shawnee, OK',
    'Sheboygan, WI',
    'Shelby, NC',
    'Shelbyville, TN',
    'Shelton, WA',
    'Sheridan, WY',
    'Sherman, TX',
    'Show Low, AZ',
    'Shreveport, LA',
    'Sidney, OH',
    'Sierra Vista, AZ',
    'Sikeston, MO',
    'Silver City, NM',
    'Sioux City, IA',
    'Sioux Falls, SD',
    'Snyder, TX',
    'Somerset, KY',
    'Somerset, PA',
    'Sonora, CA',
    'South Bend, IN',
    'Spartanburg, SC',
    'Spearfish, SD',
    'Spencer, IA',
    'Spirit Lake, IA',
    'Spokane, WA',
    'Springfield, IL',
    'Springfield, MA',
    'Springfield, MO',
    'Springfield, OH',
    'St. Cloud, MN',
    'St. George, UT',
    'St. Joseph, MO',
    'St. Louis, MO',
    'St. Marys, GA',
    'Starkville, MS',
    'State College, PA',
    'Statesboro, GA',
    'Staunton, VA',
    'Steamboat Springs, CO',
    'Stephenville, TX',
    'Sterling, CO',
    'Sterling, IL',
    'Stevens Point, WI',
    'Stillwater, OK',
    'Stockton, CA',
    'Storm Lake, IA',
    'Sturgis, MI',
    'Sulphur Springs, TX',
    'Summerville, GA',
    'Sumter, SC',
    'Sunbury, PA',
    'Susanville, CA',
    'Sweetwater, TX',
    'Syracuse, NY',
    'Tahlequah, OK',
    'Talladega, AL',
    'Tallahassee, FL',
    'Tampa, FL',
    'Taos, NM',
    'Taylorville, IL',
    'Terre Haute, IN',
    'Texarkana, TX',
    'The Dalles, OR',
    'The Villages, FL',
    'Thomaston, GA',
    'Thomasville, GA',
    'Tiffin, OH',
    'Tifton, GA',
    'Toccoa, GA',
    'Toledo, OH',
    'Topeka, KS',
    'Torrington, CT',
    'Traverse City, MI',
    'Trenton, NJ',
    'Troy, AL',
    'Truckee, CA',
    'Tucson, AZ',
    'Tullahoma, TN',
    'Tulsa, OK',
    'Tupelo, MS',
    'Tuscaloosa, AL',
    'Twin Falls, ID',
    'Tyler, TX',
    'Ukiah, CA',
    'Union City, TN',
    'Urban Honolulu, HI',
    'Urbana, OH',
    'Utica, NY',
    'Uvalde, TX',
    'Valdosta, GA',
    'Vallejo, CA',
    'Van Wert, OH',
    'Vermillion, SD',
    'Vernal, UT',
    'Vicksburg, MS',
    'Victoria, TX',
    'Vidalia, GA',
    'Vincennes, IN',
    'Vineland, NJ',
    'Vineyard Haven, MA',
    'Virginia Beach, VA',
    'Visalia, CA',
    'Wabash, IN',
    'Waco, TX',
    'Wahpeton, ND',
    'Walla Walla, WA',
    'Wapakoneta, OH',
    'Warner Robins, GA',
    'Warren, PA',
    'Warrensburg, MO',
    'Warsaw, IN',
    'Washington Court House, OH',
    'Washington, DC',
    'Washington, IN',
    'Washington, NC',
    'Waterloo, IA',
    'Watertown, NY',
    'Watertown, WI',
    'Wauchula, FL',
    'Wausau, WI',
    'Waycross, GA',
    'Weatherford, OK',
    'Weirton, WV',
    'Wenatchee, WA',
    'West Plains, MO',
    'Wheeling, WV',
    'Whitewater, WI',
    'Wichita Falls, TX',
    'Wichita, KS',
    'Williamsport, PA',
    'Williston, ND',
    'Willmar, MN',
    'Wilmington, NC',
    'Wilmington, OH',
    'Wilson, NC',
    'Winchester, VA',
    'Winnemucca, NV',
    'Winona, MN',
    'Winston, NC',
    'Wisconsin Rapids, WI',
    'Woodward, OK',
    'Wooster, OH',
    'Worcester, MA',
    'Worthington, MN',
    'Yakima, WA',
    'York, PA',
    'Youngstown, OH',
    'Yuba City, CA',
    'Yuma, AZ',
    'Zanesville, OH',
];

export const zhviByMetroByHomeSize = {
    CONDO: {
        'New York, NY': 437119,
        'Los Angeles, CA': 670236,
        'Chicago, IL': 223110,
        'Dallas, TX': 248280,
        'Houston, TX': 181900,
        'Washington, DC': 338214,
        'Miami, FL': 290589,
        'Philadelphia, PA': 259077,
        'Atlanta, GA': 291291,
        'Phoenix, AZ': 304479,
        'Boston, MA': 505942,
        'San Francisco, CA': 797182,
        'Riverside, CA': 477858,
        'Detroit, MI': 234627,
        'Seattle, WA': 466398,
        'Minneapolis, MN': 218254,
        'San Diego, CA': 619609,
        'Tampa, FL': 251132,
        'Denver, CO': 356353,
        'St. Louis, MO': 193407,
        'Baltimore, MD': 258992,
        'Charlotte, NC': 307566,
        'Orlando, FL': 219831,
        'San Antonio, TX': 213600,
        'Portland, OR': 346215,
        'Sacramento, CA': 383531,
        'Las Vegas, NV': 242101,
        'Pittsburgh, PA': 191927,
        'Austin, TX': 453236,
        'Cincinnati, OH': 197910,
        'Kansas City, MO': 205053,
        'Columbus, OH': 224809,
        'Indianapolis, IN': 225414,
        'Cleveland, OH': 161695,
        'San Jose, CA': 859142,
        'Nashville, TN': 360840,
        'Virginia Beach, VA': 277239,
        'Providence, RI': 322796,
        'Jacksonville, FL': 276151,
        'Milwaukee, WI': 237624,
        'Oklahoma City, OK': 132767,
        'Raleigh, NC': 309116,
        'Memphis, TN': 247899,
        'Richmond, VA': 304697,
        'New Orleans, LA': 236290,
        'Louisville, KY': 200541,
        'Salt Lake City, UT': 420722,
        'Hartford, CT': 207231,
        'Buffalo, NY': 238434,
        'Birmingham, AL': 204942,
        'Grand Rapids, MI': 301683,
        'Rochester, NY': 196958,
        'Tucson, AZ': 228760,
        'Tulsa, OK': 124391,
        'Fresno, CA': 256082,
        'Urban Honolulu, HI': 523180,
        'Omaha, NE': 218559,
        'Worcester, MA': 313838,
        'Bridgeport, CT': 329753,
        'Greenville, SC': 270201,
        'Albuquerque, NM': 219985,
        'Bakersfield, CA': 219821,
        'Albany, NY': 253423,
        'Knoxville, TN': 293372,
        'McAllen, TX': 140793,
        'Baton Rouge, LA': 148031,
        'North Port, FL': 371906,
        'New Haven, CT': 211053,
        'Columbia, SC': 145237,
        'Allentown, PA': 273867,
        'El Paso, TX': 164682,
        'Oxnard, CA': 571054,
        'Charleston, SC': 362265,
        'Cape Coral, FL': 347944,
        'Greensboro, NC': 161741,
        'Boise City, ID': 374358,
        'Stockton, CA': 296045,
        'Colorado Springs, CO': 293517,
        'Little Rock, AR': 189900,
        'Lakeland, FL': 177585,
        'Des Moines, IA': 200742,
        'Akron, OH': 200834,
        'Springfield, MA': 231688,
        'Ogden, UT': 357260,
        'Deltona, FL': 360517,
        'Winston, NC': 151804,
        'Madison, WI': 284085,
        'Provo, UT': 343183,
        'Durham, NC': 275858,
        'Syracuse, NY': 200771,
        'Wichita, KS': 143352,
        'Toledo, OH': 168342,
        'Augusta, GA': 189132,
        'Palm Bay, FL': 276318,
        'Jackson, MS': 168656,
        'Harrisburg, PA': 204052,
        'Spokane, WA': 282847,
        'Chattanooga, TN': 307286,
        'Scranton, PA': 217888,
        'Modesto, CA': 303441,
        'Fayetteville, AR': 245536,
        'Lansing, MI': 215013,
        'Lancaster, PA': 259064,
        'Portland, ME': 400644,
        'Youngstown, OH': 192984,
        'Fayetteville, NC': 173375,
        'Lexington, KY': 205511,
        'Myrtle Beach, SC': 249148,
        'Pensacola, FL': 503515,
        'Port St. Lucie, FL': 276590,
        'Santa Rosa, CA': 506565,
        'Lafayette, LA': 129655,
        'Huntsville, AL': 186113,
        'Reno, NV': 353082,
        'Springfield, MO': 211811,
        'Visalia, CA': 259273,
        'Killeen, TX': 219722,
        'Asheville, NC': 321269,
        'York, PA': 208441,
        'Vallejo, CA': 380281,
        'Santa Maria, CA': 788011,
        'Salem, OR': 305276,
        'Salinas, CA': 622305,
        'Corpus Christi, TX': 257879,
        'Mobile, AL': 158010,
        'Brownsville, TX': 292375,
        'Salisbury, MD': 422415,
        'Reading, PA': 190296,
        'Gulfport, MS': 189652,
        'Manchester, NH': 326200,
        'Fort Wayne, IN': 192527,
        'Flint, MI': 205501,
        'Anchorage, AK': 237856,
        'Peoria, IL': 146316,
        'Canton, OH': 205184,
        'Savannah, GA': 278066,
        'Naples, FL': 467036,
        'Shreveport, LA': 111499,
        'Beaumont, TX': 106487,
        'Tallahassee, FL': 159581,
        'Eugene, OR': 293137,
        'Davenport, IA': 158896,
        'Ocala, FL': 145961,
        'Montgomery, AL': 137431,
        'Hickory, NC': 204332,
        'Trenton, NJ': 265205,
        'Ann Arbor, MI': 305275,
        'Fort Collins, CO': 369398,
        'Huntington, WV': 184702,
        'Lincoln, NE': 216427,
        'Rockford, IL': 153816,
        'Greeley, CO': 381398,
        'Gainesville, FL': 189894,
        'Boulder, CO': 445184,
        'Lubbock, TX': 163576,
        'Spartanburg, SC': 177173,
        'Green Bay, WI': 232479,
        'South Bend, IN': 213000,
        'Columbus, GA': 169761,
        'Evansville, IN': 202743,
        'Clarksville, TN': 224476,
        'Roanoke, VA': 211794,
        'Kingsport, TN': 182526,
        'Kennewick, WA': 310559,
        'Wilmington, NC': 341144,
        'Olympia, WA': 333382,
        'Hagerstown, MD': 204731,
        'Crestview, FL': 592223,
        'Duluth, MN': 267950,
        'Longview, TX': 146192,
        'San Luis Obispo, CA': 595111,
        'Merced, CA': 327227,
        'Laredo, TX': 161109,
        'Waco, TX': 193946,
        'Cedar Rapids, IA': 145319,
        'Sioux Falls, SD': 212099,
        'Bremerton, WA': 390184,
        'Santa Cruz, CA': 762109,
        'Erie, PA': 209584,
        'College Station, TX': 187859,
        'Kalamazoo, MI': 242550,
        'Amarillo, TX': 159949,
        'Norwich, CT': 208677,
        'Lynchburg, VA': 223549,
        'Atlantic City, NJ': 187974,
        'Charleston, WV': 133476,
        'Tuscaloosa, AL': 180708,
        'Yakima, WA': 280863,
        'Fort Smith, AR': 192708,
        'Fargo, ND': 168260,
        'Appleton, WI': 246324,
        'Tyler, TX': 257515,
        'Lafayette, IN': 213711,
        'Bellingham, WA': 370855,
        'Topeka, KS': 119194,
        'Macon, GA': 164016,
        'Daphne, AL': 506882,
        'Hilton Head Island, SC': 438365,
        'Champaign, IL': 153290,
        'Rochester, MN': 192981,
        'Medford, OR': 299312,
        'Las Cruces, NM': 196849,
        'Burlington, VT': 326898,
        'Charlottesville, VA': 243909,
        'Yuma, AZ': 213810,
        'Lake Havasu City, AZ': 259184,
        'Athens, GA': 221310,
        'Barnstable Town, MA': 452797,
        'Chico, CA': 263637,
        'Columbia, MO': 174203,
        'Gainesville, GA': 265055,
        'Elkhart, IN': 199883,
        'Springfield, IL': 141050,
        'Johnson City, TN': 198101,
        'Florence, SC': 145379,
        'Jacksonville, NC': 274740,
        'Hilo, HI': 517138,
        'St. Cloud, MN': 163952,
        'Bend, OR': 551268,
        'Monroe, LA': 147946,
        'Racine, WI': 203144,
        'Punta Gorda, FL': 284007,
        'Saginaw, MI': 162498,
        'Warner Robins, GA': 116675,
        'Terre Haute, IN': 174550,
        'St. George, UT': 344430,
        'Billings, MT': 285796,
        'Dover, DE': 182317,
        'Greenville, NC': 149694,
        'Bowling Green, KY': 269899,
        'El Centro, CA': 234939,
        'Torrington, CT': 187369,
        'Redding, CA': 274812,
        'Kingston, NY': 252363,
        'Yuba City, CA': 239222,
        'Iowa City, IA': 205709,
        'Muskegon, MI': 261170,
        'Abilene, TX': 132113,
        'Oshkosh, WI': 226239,
        'Burlington, NC': 209918,
        'Panama City, FL': 434846,
        'Bloomington, IL': 161964,
        "Coeur d'Alene, ID": 435003,
        'East Stroudsburg, PA': 182038,
        'Eau Claire, WI': 229393,
        'Pueblo, CO': 239525,
        'Bloomington, IN': 216061,
        'Waterloo, IA': 121130,
        'Kahului, HI': 835230,
        'Blacksburg, VA': 248929,
        'Auburn, AL': 234618,
        'Wausau, WI': 178948,
        'Janesville, WI': 215305,
        'Sebastian, FL': 278077,
        'State College, PA': 298722,
        'Jackson, MI': 231743,
        'Grand Junction, CO': 244480,
        'Idaho Falls, ID': 305143,
        'Elizabethtown, KY': 213701,
        'Niles, MI': 292150,
        'Homosassa Springs, FL': 201623,
        'Concord, NH': 295678,
        'Santa Fe, NM': 389385,
        'Bangor, ME': 210195,
        'Traverse City, MI': 315497,
        'Alexandria, LA': 182815,
        'Monroe, MI': 246636,
        'Dothan, AL': 258209,
        'Jefferson City, MO': 229712,
        'Florence, AL': 212550,
        'Valdosta, GA': 136620,
        'Vineland, NJ': 211468,
        'Albany, GA': 139512,
        'Rapid City, SD': 318189,
        'Logan, UT': 289772,
        'Morristown, TN': 322092,
        'Dalton, GA': 224096,
        'Flagstaff, AZ': 384350,
        'Winchester, VA': 220761,
        'Lebanon, PA': 244393,
        'Morgantown, WV': 186839,
        'Sumter, SC': 121904,
        'The Villages, FL': 281906,
        'Wheeling, WV': 146646,
        'La Crosse, WI': 262856,
        'Hammond, LA': 141272,
        'Napa, CA': 673347,
        'Harrisonburg, VA': 223706,
        'Jonesboro, AR': 166397,
        'Springfield, OH': 163292,
        'Battle Creek, MI': 227514,
        'Albany, OR': 268433,
        'Mount Vernon, WA': 410010,
        'Manhattan, KS': 181736,
        'Bismarck, ND': 201142,
        'Sierra Vista, AZ': 161642,
        'Lawton, OK': 87869,
        'Jamestown, NY': 221550,
        'Cleveland, TN': 250225,
        'Pittsfield, MA': 347072,
        'Ames, IA': 160111,
        'Staunton, VA': 257202,
        'Goldsboro, NC': 177558,
        'Farmington, NM': 170315,
        'New Bern, NC': 215247,
        'Augusta, ME': 212005,
        'Lawrence, KS': 164130,
        'Missoula, MT': 346175,
        'Wenatchee, WA': 286412,
        'Altoona, PA': 152709,
        'Mansfield, OH': 199806,
        'Owensboro, KY': 185618,
        'Brunswick, GA': 369983,
        'Holland, MI': 292350,
        'Bozeman, MT': 477717,
        'Wooster, OH': 318123,
        'Cookeville, TN': 206055,
        'Sheboygan, WI': 237401,
        'Weirton, WV': 159282,
        'California, MD': 214264,
        'Muncie, IN': 153054,
        'Twin Falls, ID': 270931,
        'Show Low, AZ': 289016,
        'Longview, WA': 320539,
        'Roseburg, OR': 216808,
        'Michigan City, IN': 253758,
        'Kankakee, IL': 196085,
        'Lewiston, ME': 241858,
        'Richmond, KY': 240210,
        'Sebring, FL': 148926,
        'Tullahoma, TN': 289235,
        'Kalispell, MT': 547677,
        'Bluefield, WV': 169419,
        'Whitewater, WI': 264674,
        'Pinehurst, NC': 271117,
        'Decatur, IL': 103162,
        'Fond du Lac, WI': 214211,
        'Gettysburg, PA': 214036,
        'Mankato, MN': 218086,
        'Bay City, MI': 211466,
        'Lima, OH': 130197,
        'Salem, OH': 175341,
        'Ithaca, NY': 227022,
        'Cheyenne, WY': 199943,
        'Grand Forks, ND': 127535,
        'Hot Springs, AR': 246274,
        'Truckee, CA': 586261,
        'Moses Lake, WA': 282866,
        'Sevierville, TN': 359431,
        'Rome, GA': 202614,
        'Adrian, MI': 207464,
        'Dubuque, IA': 230899,
        'Cape Girardeau, MO': 230059,
        'Ashtabula, OH': 178650,
        'Pocatello, ID': 266281,
        'Paducah, KY': 246459,
        'Fairbanks, AK': 168561,
        'Brainerd, MN': 250519,
        'Corvallis, OR': 301242,
        'Clarksburg, WV': 246896,
        'New Philadelphia, OH': 238607,
        'Ocean City, NJ': 629314,
        'Hermiston, OR': 213544,
        'Parkersburg, WV': 241831,
        'Beaver Dam, WI': 190059,
        'Zanesville, OH': 191438,
        'Oak Harbor, WA': 332325,
        'New Castle, PA': 243324,
        'Columbus, IN': 229144,
        'Meadville, PA': 215617,
        'Indiana, PA': 193367,
        'Midland, MI': 222307,
        'Hinesville, GA': 126934,
        'Bloomsburg, PA': 176905,
        'Kokomo, IN': 194173,
        'Helena, MT': 358885,
        'Great Falls, MT': 289152,
        'Statesboro, GA': 129311,
        'Casper, WY': 127335,
        'Seneca, SC': 242791,
        'Warsaw, IN': 212330,
        'Manitowoc, WI': 192417,
        'Glenwood Springs, CO': 776179,
        'Port Angeles, WA': 380939,
        'Heber, UT': 543990,
        'Minot, ND': 174479,
        'Chillicothe, OH': 202482,
        'Keene, NH': 249884,
        'Aberdeen, WA': 197100,
        'Findlay, OH': 214093,
        'Grand Island, NE': 219178,
        'Danville, IL': 125676,
        'Palatka, FL': 263074,
        'Portsmouth, OH': 169974,
        'Frankfort, KY': 165987,
        'Key West, FL': 713260,
        'Sandusky, OH': 238404,
        'Somerset, PA': 268221,
        'Kapaa, HI': 713695,
        'Mount Airy, NC': 227038,
        'Greenwood, SC': 190333,
        'Stevens Point, WI': 225377,
        'Greeneville, TN': 252825,
        'Morehead City, NC': 410425,
        'Mount Pleasant, MI': 196323,
        'Klamath Falls, OR': 222231,
        'Roanoke Rapids, NC': 137478,
        'North Wilkesboro, NC': 206540,
        'Faribault, MN': 212743,
        'Forest City, NC': 263451,
        'Farmington, MO': 186397,
        'Richmond, IN': 160039,
        'Somerset, KY': 227402,
        'Athens, OH': 134107,
        'Marion, IN': 168731,
        'Marion, OH': 218022,
        'Coos Bay, OR': 261604,
        'Clearlake, CA': 314588,
        'Baraboo, WI': 254864,
        'Lewiston, ID': 307207,
        'Georgetown, SC': 297516,
        'Mount Vernon, OH': 235524,
        'Sanford, NC': 226314,
        'Crossville, TN': 195667,
        'Laconia, NH': 344754,
        'Walla Walla, WA': 269976,
        'Marietta, OH': 235596,
        'Starkville, MS': 182797,
        'Calhoun, GA': 182124,
        'Fremont, OH': 178768,
        'Barre, VT': 268243,
        'Cullowhee, NC': 337483,
        'Norwalk, OH': 196907,
        'Rutland, VT': 276968,
        'Fort Madison, IA': 163508,
        'Cedar City, UT': 276012,
        'Kearney, NE': 289880,
        'Durango, CO': 365193,
        'Boone, NC': 356702,
        'Branson, MO': 211294,
        'Carson City, NV': 304871,
        'St. Marys, GA': 261882,
        'Tiffin, OH': 180090,
        'Edwards, CO': 916817,
        'Jasper, IN': 228816,
        'Danville, KY': 274218,
        'Sterling, IL': 165359,
        'Oxford, MS': 247707,
        'Payson, AZ': 289652,
        'Milledgeville, GA': 270840,
        'Rexburg, ID': 281050,
        'Ashland, OH': 188800,
        'Kerrville, TX': 286687,
        'Bartlesville, OK': 119612,
        'Greenville, OH': 163050,
        'Newport, OR': 413930,
        'Rochelle, IL': 158793,
        'Shelbyville, TN': 237701,
        'Pullman, WA': 271722,
        'Mason City, IA': 263932,
        'Ellensburg, WA': 388581,
        'Gardnerville Ranchos, NV': 544084,
        'Cadillac, MI': 244839,
        'Sidney, OH': 157621,
        'Montrose, CO': 354727,
        'Pahrump, NV': 242651,
        'Kendallville, IN': 145031,
        'Sandpoint, ID': 512916,
        'Nogales, AZ': 226486,
        'Bardstown, KY': 195262,
        'Clinton, IA': 237323,
        'Red Wing, MN': 231756,
        'Plymouth, IN': 248658,
        'Wapakoneta, OH': 182700,
        'Hillsdale, MI': 37164,
        'Menomonie, WI': 226275,
        'Shawano, WI': 209548,
        'Bellefontaine, OH': 202574,
        'Burlington, IA': 205618,
        'Seymour, IN': 179970,
        'Freeport, IL': 140517,
        'Clewiston, FL': 178931,
        'Muscatine, IA': 129097,
        'Bucyrus, OH': 194344,
        'Celina, OH': 198667,
        'Moscow, ID': 250034,
        'Astoria, OR': 396178,
        'Marshalltown, IA': 139625,
        'Urbana, OH': 190126,
        'Laramie, WY': 203551,
        'Hannibal, MO': 107422,
        'Williston, ND': 208453,
        'Arcadia, FL': 215720,
        'Crawfordsville, IN': 189406,
        'Alexandria, MN': 237701,
        'Defiance, OH': 152964,
        'Kill Devil Hills, NC': 407249,
        'Easton, MD': 328839,
        'Vincennes, IN': 222496,
        'Jackson, WY': 835933,
        'Hutchinson, MN': 172840,
        'Pontiac, IL': 131288,
        'Bennington, VT': 332294,
        'Ottumwa, IA': 74379,
        'Angola, IN': 249778,
        'Brevard, NC': 318446,
        'Dickinson, ND': 182982,
        'Taos, NM': 302955,
        'Frankfort, IN': 196733,
        'Cambridge, MD': 307774,
        'Juneau, AK': 276004,
        'Berlin, NH': 600257,
        'Wabash, IN': 184623,
        'Breckenridge, CO': 703500,
        'Mineral Wells, TX': 389376,
        'Ludington, MI': 337123,
        'Washington Court House, OH': 243707,
        'Steamboat Springs, CO': 707400,
        'Hailey, ID': 642457,
        'Brookings, OR': 382013,
        'Hood River, OR': 418683,
        'Storm Lake, IA': 153274,
        'Los Alamos, NM': 273523,
        'Fairfield, IA': 127550,
        'Spirit Lake, IA': 387492,
        'Vineyard Haven, MA': 859343,
        'Spencer, IA': 159929,
        'Ketchikan, AK': 142678,
    },
    '1_BED': {
        'New York, NY': 446071,
        'Los Angeles, CA': 548142,
        'Chicago, IL': 188982,
        'Dallas, TX': 194797,
        'Houston, TX': 154394,
        'Washington, DC': 318775,
        'Miami, FL': 226371,
        'Philadelphia, PA': 230040,
        'Atlanta, GA': 260694,
        'Phoenix, AZ': 259438,
        'Boston, MA': 416475,
        'San Francisco, CA': 638562,
        'Riverside, CA': 301119,
        'Detroit, MI': 178633,
        'Seattle, WA': 420998,
        'Minneapolis, MN': 184212,
        'San Diego, CA': 490186,
        'Tampa, FL': 195376,
        'Denver, CO': 318897,
        'St. Louis, MO': 120762,
        'Baltimore, MD': 196036,
        'Charlotte, NC': 245247,
        'Orlando, FL': 167871,
        'San Antonio, TX': 142259,
        'Portland, OR': 334816,
        'Sacramento, CA': 378826,
        'Las Vegas, NV': 197436,
        'Pittsburgh, PA': 109483,
        'Austin, TX': 394014,
        'Cincinnati, OH': 134904,
        'Kansas City, MO': 145036,
        'Columbus, OH': 160796,
        'Indianapolis, IN': 150386,
        'Cleveland, OH': 102031,
        'San Jose, CA': 645273,
        'Nashville, TN': 316251,
        'Virginia Beach, VA': 197488,
        'Providence, RI': 279755,
        'Jacksonville, FL': 201187,
        'Milwaukee, WI': 161020,
        'Oklahoma City, OK': 105591,
        'Raleigh, NC': 262514,
        'Memphis, TN': 144244,
        'Richmond, VA': 231085,
        'New Orleans, LA': 216884,
        'Louisville, KY': 126401,
        'Salt Lake City, UT': 335829,
        'Hartford, CT': 136709,
        'Buffalo, NY': 155455,
        'Birmingham, AL': 128650,
        'Grand Rapids, MI': 221139,
        'Rochester, NY': 136797,
        'Tucson, AZ': 193528,
        'Tulsa, OK': 107435,
        'Fresno, CA': 201610,
        'Urban Honolulu, HI': 429147,
        'Omaha, NE': 150376,
        'Worcester, MA': 237732,
        'Bridgeport, CT': 226770,
        'Greenville, SC': 166998,
        'Albuquerque, NM': 197429,
        'Bakersfield, CA': 162201,
        'Albany, NY': 183440,
        'Knoxville, TN': 194744,
        'McAllen, TX': 83750,
        'Baton Rouge, LA': 120771,
        'North Port, FL': 235973,
        'New Haven, CT': 173996,
        'Columbia, SC': 126159,
        'Allentown, PA': 196667,
        'El Paso, TX': 128571,
        'Oxnard, CA': 493939,
        'Charleston, SC': 324377,
        'Cape Coral, FL': 231404,
        'Greensboro, NC': 131473,
        'Boise City, ID': 335648,
        'Stockton, CA': 280408,
        'Colorado Springs, CO': 287488,
        'Little Rock, AR': 126614,
        'Lakeland, FL': 129537,
        'Akron, OH': 92683,
        'Springfield, MA': 182965,
        'Ogden, UT': 293427,
        'Deltona, FL': 213152,
        'Winston, NC': 131260,
        'Madison, WI': 216353,
        'Provo, UT': 430156,
        'Durham, NC': 255845,
        'Syracuse, NY': 124106,
        'Wichita, KS': 88684,
        'Toledo, OH': 76556,
        'Augusta, GA': 142546,
        'Palm Bay, FL': 181521,
        'Jackson, MS': 115841,
        'Harrisburg, PA': 140983,
        'Spokane, WA': 280132,
        'Chattanooga, TN': 223802,
        'Scranton, PA': 123939,
        'Modesto, CA': 287258,
        'Fayetteville, AR': 220978,
        'Lansing, MI': 111163,
        'Lancaster, PA': 209134,
        'Portland, ME': 323077,
        'Youngstown, OH': 65824,
        'Fayetteville, NC': 130276,
        'Lexington, KY': 145273,
        'Myrtle Beach, SC': 184106,
        'Pensacola, FL': 236877,
        'Port St. Lucie, FL': 187321,
        'Santa Rosa, CA': 560361,
        'Lafayette, LA': 118857,
        'Huntsville, AL': 148789,
        'Reno, NV': 289904,
        'Springfield, MO': 109693,
        'Visalia, CA': 206961,
        'Killeen, TX': 155370,
        'Asheville, NC': 282270,
        'York, PA': 145269,
        'Vallejo, CA': 364373,
        'Santa Maria, CA': 778072,
        'Salem, OR': 291457,
        'Salinas, CA': 639687,
        'Corpus Christi, TX': 165058,
        'Mobile, AL': 112543,
        'Brownsville, TX': 156312,
        'Salisbury, MD': 267322,
        'Reading, PA': 166957,
        'Gulfport, MS': 126747,
        'Manchester, NH': 223297,
        'Fort Wayne, IN': 99720,
        'Flint, MI': 63489,
        'Anchorage, AK': 171020,
        'Peoria, IL': 52334,
        'Canton, OH': 93743,
        'Savannah, GA': 274988,
        'Naples, FL': 327347,
        'Shreveport, LA': 74617,
        'Beaumont, TX': 108539,
        'Tallahassee, FL': 142514,
        'Eugene, OR': 331173,
        'Ocala, FL': 119294,
        'Montgomery, AL': 118314,
        'Hickory, NC': 148288,
        'Trenton, NJ': 186090,
        'Ann Arbor, MI': 230186,
        'Fort Collins, CO': 348706,
        'Huntington, WV': 70665,
        'Lincoln, NE': 222644,
        'Rockford, IL': 75054,
        'Greeley, CO': 318089,
        'Gainesville, FL': 147535,
        'Boulder, CO': 367213,
        'Lubbock, TX': 112963,
        'Spartanburg, SC': 125637,
        'Green Bay, WI': 147827,
        'South Bend, IN': 104948,
        'Columbus, GA': 75062,
        'Evansville, IN': 79671,
        'Clarksville, TN': 136602,
        'Roanoke, VA': 136251,
        'Kingsport, TN': 114540,
        'Kennewick, WA': 242858,
        'Wilmington, NC': 317967,
        'Olympia, WA': 384082,
        'Hagerstown, MD': 168159,
        'Crestview, FL': 401447,
        'Duluth, MN': 154322,
        'Utica, NY': 127805,
        'Longview, TX': 150048,
        'San Luis Obispo, CA': 623655,
        'Merced, CA': 289947,
        'Waco, TX': 132523,
        'Cedar Rapids, IA': 93577,
        'Sioux Falls, SD': 149660,
        'Bremerton, WA': 409610,
        'Santa Cruz, CA': 734072,
        'Erie, PA': 113674,
        'College Station, TX': 159848,
        'Kalamazoo, MI': 134525,
        'Amarillo, TX': 86676,
        'Norwich, CT': 179589,
        'Lynchburg, VA': 164618,
        'Atlantic City, NJ': 180550,
        'Charleston, WV': 86191,
        'Tuscaloosa, AL': 142994,
        'Yakima, WA': 187862,
        'Fort Smith, AR': 110831,
        'Appleton, WI': 129868,
        'Binghamton, NY': 102113,
        'Tyler, TX': 190363,
        'Lafayette, IN': 125966,
        'Bellingham, WA': 347069,
        'Topeka, KS': 78549,
        'Macon, GA': 87161,
        'Daphne, AL': 345558,
        'Hilton Head Island, SC': 415812,
        'Champaign, IL': 129760,
        'Rochester, MN': 183272,
        'Medford, OR': 350973,
        'Las Cruces, NM': 151885,
        'Burlington, VT': 284272,
        'Charlottesville, VA': 227868,
        'Yuma, AZ': 191078,
        'Lake Havasu City, AZ': 181766,
        'Athens, GA': 232022,
        'Barnstable Town, MA': 375462,
        'Chico, CA': 231671,
        'Lake Charles, LA': 108794,
        'Columbia, MO': 159078,
        'Gainesville, GA': 264939,
        'Elkhart, IN': 120490,
        'Johnson City, TN': 159429,
        'Florence, SC': 52806,
        'Jacksonville, NC': 187132,
        'Hilo, HI': 353066,
        'St. Cloud, MN': 190299,
        'Bend, OR': 421618,
        'Monroe, LA': 71728,
        'Racine, WI': 137341,
        'Punta Gorda, FL': 181555,
        'Saginaw, MI': 62311,
        'Warner Robins, GA': 123186,
        'Terre Haute, IN': 74256,
        'St. George, UT': 259746,
        'Billings, MT': 245566,
        'Dover, DE': 185535,
        'Greenville, NC': 107314,
        'Bowling Green, KY': 118167,
        'Joplin, MO': 103675,
        'Torrington, CT': 186039,
        'Redding, CA': 217727,
        'Kingston, NY': 280167,
        'Yuba City, CA': 255133,
        'Iowa City, IA': 195369,
        'Muskegon, MI': 129123,
        'Abilene, TX': 116733,
        'Oshkosh, WI': 132978,
        'Burlington, NC': 142016,
        'Panama City, FL': 341396,
        'Bloomington, IL': 113762,
        "Coeur d'Alene, ID": 481337,
        'East Stroudsburg, PA': 151856,
        'Eau Claire, WI': 183641,
        'Pueblo, CO': 152840,
        'Hattiesburg, MS': 128527,
        'Bloomington, IN': 159027,
        'Kahului, HI': 804592,
        'Blacksburg, VA': 171581,
        'Auburn, AL': 188355,
        'Wausau, WI': 104114,
        'Janesville, WI': 115526,
        'Sebastian, FL': 154591,
        'State College, PA': 191004,
        'Madera, CA': 258508,
        'Jackson, MI': 109132,
        'Chambersburg, PA': 169231,
        'Grand Junction, CO': 258467,
        'Idaho Falls, ID': 236348,
        'Elizabethtown, KY': 109802,
        'Niles, MI': 150427,
        'Homosassa Springs, FL': 148930,
        'Hanford, CA': 164198,
        'Concord, NH': 238200,
        'Wichita Falls, TX': 69525,
        'Santa Fe, NM': 358486,
        'Bangor, ME': 159933,
        'Traverse City, MI': 262726,
        'Alexandria, LA': 97788,
        'Monroe, MI': 120582,
        'Jefferson City, MO': 125634,
        'Valdosta, GA': 135167,
        'London, KY': 79135,
        'Vineland, NJ': 138665,
        'Rocky Mount, NC': 117476,
        'Albany, GA': 105517,
        'Sioux City, IA': 92015,
        'Rapid City, SD': 220491,
        'Logan, UT': 303665,
        'Flagstaff, AZ': 321509,
        'Winchester, VA': 184584,
        'Pottsville, PA': 82483,
        'Morgantown, WV': 124211,
        'Sumter, SC': 90751,
        'The Villages, FL': 212016,
        'Sherman, TX': 163322,
        'Wheeling, WV': 57325,
        'La Crosse, WI': 138437,
        'Napa, CA': 703055,
        'Harrisonburg, VA': 204079,
        'Eureka, CA': 358075,
        'Springfield, OH': 81053,
        'Battle Creek, MI': 84744,
        'Albany, OR': 265497,
        'Mount Vernon, WA': 397935,
        'Manhattan, KS': 116729,
        'Lumberton, NC': 49543,
        'Bismarck, ND': 146150,
        'Sierra Vista, AZ': 169678,
        'Lawton, OK': 58825,
        'Jamestown, NY': 126816,
        'Cleveland, TN': 185428,
        'Pittsfield, MA': 195418,
        'Ames, IA': 122167,
        'Staunton, VA': 185819,
        'Glens Falls, NY': 164352,
        'Goldsboro, NC': 102709,
        'Farmington, NM': 172793,
        'New Bern, NC': 182711,
        'Augusta, ME': 216884,
        'St. Joseph, MO': 69641,
        'Lawrence, KS': 168928,
        'Missoula, MT': 373388,
        'Wenatchee, WA': 357312,
        'Mansfield, OH': 89317,
        'Owensboro, KY': 79691,
        'Brunswick, GA': 251269,
        'Holland, MI': 207092,
        'Bozeman, MT': 526838,
        'Wooster, OH': 289869,
        'Cookeville, TN': 183495,
        'Sheboygan, WI': 140546,
        'Weirton, WV': 57228,
        'Beckley, WV': 67997,
        'California, MD': 222883,
        'Anniston, AL': 75929,
        'Muncie, IN': 61516,
        'Williamsport, PA': 123500,
        'Twin Falls, ID': 189890,
        'Show Low, AZ': 217132,
        'Longview, WA': 258376,
        'Roseburg, OR': 274784,
        'Michigan City, IN': 136717,
        'Kankakee, IL': 92836,
        'Lewiston, ME': 211634,
        'Richmond, KY': 112928,
        'Watertown, NY': 133565,
        'Ogdensburg, NY': 96185,
        'Sebring, FL': 116953,
        'Kalispell, MT': 471764,
        'Bluefield, WV': 61779,
        'Whitewater, WI': 187483,
        'Pinehurst, NC': 204288,
        'LaGrange, GA': 58573,
        'Decatur, IL': 44630,
        'Fond du Lac, WI': 111607,
        'Gettysburg, PA': 197047,
        'Mankato, MN': 160406,
        'Bay City, MI': 72631,
        'Lima, OH': 65643,
        'Salem, OH': 72788,
        'Ithaca, NY': 192391,
        'Grand Forks, ND': 123765,
        'Hot Springs, AR': 149273,
        'Danville, VA': 58752,
        'Truckee, CA': 397209,
        'Victoria, TX': 115722,
        'Moses Lake, WA': 209598,
        'Sevierville, TN': 454152,
        'Rome, GA': 144789,
        'Meridian, MS': 68459,
        'Adrian, MI': 142468,
        'Dubuque, IA': 122141,
        'Cape Girardeau, MO': 134660,
        'Cumberland, MD': 87741,
        'Ashtabula, OH': 96746,
        'Pocatello, ID': 215334,
        'Paducah, KY': 89170,
        'Fairbanks, AK': 166039,
        'Brainerd, MN': 233343,
        'Corning, NY': 116966,
        'Corvallis, OR': 362792,
        'Clarksburg, WV': 75412,
        'New Philadelphia, OH': 118301,
        'Ocean City, NJ': 296436,
        'Hermiston, OR': 175700,
        'Parkersburg, WV': 84942,
        'Grants Pass, OR': 279913,
        'Ukiah, CA': 475395,
        'Zanesville, OH': 101033,
        'Oak Harbor, WA': 537771,
        'New Castle, PA': 77599,
        'Columbus, IN': 120832,
        'Athens, TX': 157232,
        'Indiana, PA': 103671,
        'Midland, MI': 115911,
        'Hinesville, GA': 152427,
        'Bloomsburg, PA': 131255,
        'Kokomo, IN': 62992,
        'Elmira, NY': 83524,
        'Helena, MT': 306588,
        'Centralia, WA': 305526,
        'Wilson, NC': 52910,
        'Stillwater, OK': 113442,
        'Great Falls, MT': 185814,
        'Statesboro, GA': 164327,
        'Casper, WY': 155962,
        'Seneca, SC': 153808,
        'Plattsburgh, NY': 124196,
        'Warsaw, IN': 143913,
        'Manitowoc, WI': 109104,
        'Glenwood Springs, CO': 613653,
        'Port Angeles, WA': 350691,
        'Chillicothe, OH': 120596,
        'Keene, NH': 227194,
        'Auburn, NY': 136202,
        'Aberdeen, WA': 193630,
        'Olean, NY': 112148,
        'Findlay, OH': 126126,
        'Grand Island, NE': 119494,
        'Palatka, FL': 154957,
        'Quincy, IL': 78136,
        'Portsmouth, OH': 57957,
        'Frankfort, KY': 92540,
        'Key West, FL': 538083,
        'Sandusky, OH': 124700,
        'Shawnee, OK': 84783,
        'Somerset, PA': 112177,
        'Lake City, FL': 145887,
        'Huntsville, TX': 171759,
        'Kapaa, HI': 781681,
        'Mount Airy, NC': 104898,
        'Greenwood, SC': 101286,
        'Morehead City, NC': 236334,
        'Mount Pleasant, MI': 111589,
        'Klamath Falls, OR': 163627,
        'Roanoke Rapids, NC': 49800,
        'Shelton, WA': 343789,
        'North Wilkesboro, NC': 145228,
        'Alamogordo, NM': 148646,
        'Muskogee, OK': 61528,
        'Faribault, MN': 221506,
        'Forest City, NC': 149079,
        'Farmington, MO': 80542,
        'Marquette, MI': 157383,
        'Richmond, IN': 63641,
        'Athens, OH': 101710,
        'Marion, OH': 82732,
        'Roswell, NM': 136054,
        'Coos Bay, OR': 312334,
        'Red Bluff, CA': 204331,
        'Clearlake, CA': 190150,
        'Baraboo, WI': 137857,
        'Lewiston, ID': 212977,
        'Georgetown, SC': 235823,
        'Albemarle, NC': 123396,
        'Mount Vernon, OH': 158268,
        'Sanford, NC': 165666,
        'Hutchinson, KS': 53820,
        'Crossville, TN': 160870,
        'Laconia, NH': 249806,
        'Walla Walla, WA': 225033,
        'Gillette, WY': 235173,
        'Enid, OK': 36259,
        'Sturgis, MI': 126159,
        'Sayre, PA': 147511,
        'Marietta, OH': 92212,
        'Salina, KS': 84141,
        'Hudson, NY': 301428,
        'Starkville, MS': 163569,
        'Calhoun, GA': 160763,
        'Fergus Falls, MN': 185327,
        'Oneonta, NY': 144094,
        'Ardmore, OK': 101672,
        'Fremont, OH': 97117,
        'Barre, VT': 184391,
        'Fernley, NV': 238022,
        'Cullowhee, NC': 238011,
        'Norwalk, OH': 106733,
        'Rutland, VT': 191471,
        'Fort Madison, IA': 54737,
        'Batavia, NY': 114759,
        'Cedar City, UT': 251679,
        'Durango, CO': 345743,
        'Boone, NC': 233884,
        'Point Pleasant, WV': 81704,
        'Branson, MO': 143293,
        'Carson City, NV': 280618,
        'Fairmont, WV': 79294,
        'Ontario, OR': 179951,
        'Kinston, NC': 58127,
        'St. Marys, GA': 192095,
        'Elko, NV': 135153,
        'Tiffin, OH': 73995,
        'Edwards, CO': 557394,
        'Jasper, IN': 116244,
        'Danville, KY': 104976,
        'Sterling, IL': 68218,
        'Sonora, CA': 282472,
        'Oxford, MS': 219106,
        'Glasgow, KY': 113247,
        'Payson, AZ': 267828,
        'Elizabeth City, NC': 141255,
        'Milledgeville, GA': 143565,
        'Rexburg, ID': 327126,
        'Ashland, OH': 128928,
        'Jacksonville, TX': 127797,
        'Kerrville, TX': 290388,
        'Gloversville, NY': 121190,
        'Bartlesville, OK': 78165,
        'Greenville, OH': 94106,
        'Newport, OR': 316359,
        'Winona, MN': 129098,
        'Oil City, PA': 62446,
        'Rochelle, IL': 90103,
        'Malone, NY': 120031,
        'Pullman, WA': 208830,
        'Mason City, IA': 98064,
        'Ellensburg, WA': 421181,
        'Amsterdam, NY': 117820,
        'Gardnerville Ranchos, NV': 425427,
        'Galesburg, IL': 81470,
        'Tahlequah, OK': 106770,
        'Durant, OK': 128921,
        'Cadillac, MI': 142350,
        'Clovis, NM': 100499,
        'Sidney, OH': 101929,
        'Montrose, CO': 392081,
        'New Castle, IN': 77562,
        'Norfolk, NE': 102177,
        'Cañon City, CO': 243991,
        'Kendallville, IN': 136191,
        'Bemidji, MN': 186043,
        'Cortland, NY': 119085,
        'Mount Sterling, KY': 107611,
        'Sandpoint, ID': 427991,
        'Nogales, AZ': 239223,
        'Bardstown, KY': 151238,
        'Clinton, IA': 78267,
        'Red Wing, MN': 220694,
        'Plymouth, IN': 141172,
        'Lewistown, PA': 108243,
        'Cornelia, GA': 186102,
        'Marion, NC': 160331,
        'Wapakoneta, OH': 96248,
        'Hillsdale, MI': 121342,
        'Bedford, IN': 98327,
        'Burley, ID': 175234,
        'Shawano, WI': 124782,
        'Bellefontaine, OH': 97715,
        'Burlington, IA': 62099,
        'Huntingdon, PA': 119289,
        'Rolla, MO': 115556,
        'Lewisburg, PA': 183174,
        'Seymour, IN': 119050,
        'Big Rapids, MI': 125139,
        'Freeport, IL': 70966,
        'McAlester, OK': 70489,
        'Auburn, IN': 121901,
        'Ponca City, OK': 39230,
        'Duncan, OK': 50151,
        'Cedartown, GA': 135791,
        'Clewiston, FL': 153740,
        'Rock Springs, WY': 134561,
        'Sedalia, MO': 84841,
        'Muscatine, IA': 87303,
        'Okeechobee, FL': 136407,
        'Wilmington, OH': 104067,
        'El Campo, TX': 83276,
        'Bucyrus, OH': 65335,
        'Celina, OH': 151891,
        'Big Stone Gap, VA': 52179,
        'Astoria, OR': 331533,
        'Austin, MN': 82466,
        'Garden City, KS': 128967,
        'Marshalltown, IA': 60499,
        'Riverton, WY': 222283,
        'Murray, KY': 112717,
        'Urbana, OH': 112265,
        'Laramie, WY': 229293,
        'Warren, PA': 72603,
        'Pittsburg, KS': 51802,
        'Hannibal, MO': 88171,
        'Arcadia, FL': 243549,
        'Ada, OK': 83252,
        'Crawfordsville, IN': 98901,
        'Sikeston, MO': 84251,
        'Lock Haven, PA': 81846,
        'Defiance, OH': 103479,
        'Brownwood, TX': 134061,
        'Greenwood, MS': 51635,
        'Kill Devil Hills, NC': 282965,
        'Logansport, IN': 70207,
        'Scottsbluff, NE': 85360,
        'Houghton, MI': 157259,
        'Mayfield, KY': 85801,
        'Bay City, TX': 180142,
        'Vincennes, IN': 58074,
        'Coshocton, OH': 113390,
        'Huntington, IN': 81111,
        'Fremont, NE': 114987,
        'Jackson, WY': 701301,
        'Decatur, IN': 263456,
        'Brenham, TX': 455788,
        'Hutchinson, MN': 162725,
        'Emporia, KS': 89991,
        'Escanaba, MI': 93396,
        'Brookings, SD': 139559,
        'North Platte, NE': 84855,
        'Pontiac, IL': 65845,
        'Peru, IN': 79029,
        'Butte, MT': 157039,
        'Ottumwa, IA': 51235,
        'Angola, IN': 157463,
        'Laurinburg, NC': 33066,
        'Brevard, NC': 282976,
        'Americus, GA': 133425,
        'Effingham, IL': 192914,
        'Seneca Falls, NY': 148447,
        'Washington, IN': 84455,
        'Columbus, NE': 139604,
        'Dodge City, KS': 96292,
        'Dickinson, ND': 108761,
        'Taos, NM': 311796,
        'Jackson, OH': 82550,
        'Frankfort, IN': 96926,
        'Madison, IN': 113370,
        'Taylorville, IL': 45576,
        'Juneau, AK': 234284,
        'Coffeyville, KS': 44739,
        'Hastings, NE': 104752,
        'Berlin, NH': 139794,
        'Miami, OK': 44809,
        'Sheridan, WY': 269602,
        'Wabash, IN': 79261,
        'Breckenridge, CO': 549156,
        'Albert Lea, MN': 68577,
        'Susanville, CA': 132263,
        'Kirksville, MO': 105097,
        'Iron Mountain, MI': 98123,
        'Macomb, IL': 38186,
        'Ludington, MI': 143031,
        'Fort Morgan, CO': 197319,
        'Hays, KS': 86198,
        'Weatherford, OK': 58981,
        'Washington Court House, OH': 92071,
        'McPherson, KS': 97398,
        'Elkins, WV': 59745,
        'Van Wert, OH': 80563,
        'North Vernon, IN': 113290,
        'Mountain Home, ID': 251420,
        'Silver City, NM': 163661,
        'Greensburg, IN': 118015,
        'La Grande, OR': 175953,
        'Thomaston, GA': 74322,
        'The Dalles, OR': 300040,
        'Toccoa, GA': 146060,
        'Ottawa, KS': 111779,
        'Great Bend, KS': 45648,
        'Steamboat Springs, CO': 457671,
        'Lexington, NE': 116527,
        'Fallon, NV': 212433,
        'Prineville, OR': 302764,
        'New Ulm, MN': 124444,
        'Indianola, MS': 85314,
        'Hailey, ID': 493335,
        'Moberly, MO': 75107,
        'Altus, OK': 36922,
        'Woodward, OK': 50019,
        'Brookings, OR': 420042,
        'Mitchell, SD': 84293,
        'Hood River, OR': 468959,
        'Connersville, IN': 69926,
        'Oskaloosa, IA': 77990,
        'Sterling, CO': 124303,
        'Clarksdale, MS': 41254,
        'Beatrice, NE': 80347,
        'Liberal, KS': 73974,
        'Port Lavaca, TX': 148437,
        'Guymon, OK': 74268,
        'Storm Lake, IA': 85463,
        'Parsons, KS': 45762,
        'Los Alamos, NM': 285182,
        'Portales, NM': 99294,
        'Fairfield, IA': 99478,
        'Spirit Lake, IA': 189566,
        'Vineyard Haven, MA': 859001,
        'Atchison, KS': 63613,
        'Spencer, IA': 70028,
        'Vermillion, SD': 140652,
        'Ketchikan, AK': 147079,
    },
    '2_BED': {
        'New York, NY': 444621,
        'Los Angeles, CA': 690620,
        'Chicago, IL': 225200,
        'Dallas, TX': 234078,
        'Houston, TX': 188208,
        'Washington, DC': 378169,
        'Miami, FL': 316251,
        'Philadelphia, PA': 260235,
        'Atlanta, GA': 265244,
        'Phoenix, AZ': 354515,
        'Boston, MA': 481171,
        'San Francisco, CA': 877156,
        'Riverside, CA': 408295,
        'Detroit, MI': 173756,
        'Seattle, WA': 533046,
        'Minneapolis, MN': 264803,
        'San Diego, CA': 641704,
        'Tampa, FL': 272429,
        'Denver, CO': 435525,
        'St. Louis, MO': 152060,
        'Baltimore, MD': 246769,
        'Charlotte, NC': 249505,
        'Orlando, FL': 245865,
        'San Antonio, TX': 169246,
        'Portland, OR': 411635,
        'Sacramento, CA': 434535,
        'Las Vegas, NV': 295092,
        'Pittsburgh, PA': 133060,
        'Austin, TX': 433382,
        'Cincinnati, OH': 168797,
        'Kansas City, MO': 163732,
        'Columbus, OH': 195439,
        'Indianapolis, IN': 173302,
        'Cleveland, OH': 143500,
        'San Jose, CA': 915036,
        'Nashville, TN': 323382,
        'Virginia Beach, VA': 212987,
        'Providence, RI': 345130,
        'Jacksonville, FL': 238399,
        'Milwaukee, WI': 204664,
        'Oklahoma City, OK': 122495,
        'Raleigh, NC': 282268,
        'Memphis, TN': 105058,
        'Richmond, VA': 253707,
        'New Orleans, LA': 215290,
        'Louisville, KY': 180657,
        'Salt Lake City, UT': 396679,
        'Hartford, CT': 231533,
        'Buffalo, NY': 188067,
        'Birmingham, AL': 108516,
        'Grand Rapids, MI': 231632,
        'Rochester, NY': 168851,
        'Tucson, AZ': 278884,
        'Tulsa, OK': 124460,
        'Fresno, CA': 252895,
        'Urban Honolulu, HI': 576660,
        'Omaha, NE': 179620,
        'Worcester, MA': 317250,
        'Bridgeport, CT': 364496,
        'Greenville, SC': 173980,
        'Albuquerque, NM': 231886,
        'Bakersfield, CA': 212358,
        'Albany, NY': 221110,
        'Knoxville, TN': 212174,
        'McAllen, TX': 102246,
        'Baton Rouge, LA': 158720,
        'North Port, FL': 352759,
        'New Haven, CT': 239356,
        'Columbia, SC': 154261,
        'Allentown, PA': 227198,
        'El Paso, TX': 140867,
        'Oxnard, CA': 579823,
        'Charleston, SC': 310419,
        'Cape Coral, FL': 318583,
        'Greensboro, NC': 145570,
        'Boise City, ID': 357482,
        'Stockton, CA': 345909,
        'Colorado Springs, CO': 330016,
        'Little Rock, AR': 136970,
        'Lakeland, FL': 210676,
        'Des Moines, IA': 169892,
        'Akron, OH': 130256,
        'Springfield, MA': 253991,
        'Ogden, UT': 337748,
        'Deltona, FL': 269741,
        'Winston, NC': 148400,
        'Madison, WI': 267139,
        'Provo, UT': 369863,
        'Durham, NC': 285026,
        'Syracuse, NY': 149055,
        'Wichita, KS': 118707,
        'Toledo, OH': 105520,
        'Augusta, GA': 146219,
        'Palm Bay, FL': 243703,
        'Jackson, MS': 99682,
        'Harrisburg, PA': 191787,
        'Spokane, WA': 306086,
        'Chattanooga, TN': 211269,
        'Scranton, PA': 142570,
        'Modesto, CA': 334431,
        'Fayetteville, AR': 225128,
        'Lansing, MI': 140882,
        'Lancaster, PA': 247901,
        'Portland, ME': 375872,
        'Youngstown, OH': 93959,
        'Fayetteville, NC': 135876,
        'Lexington, KY': 176744,
        'Myrtle Beach, SC': 244661,
        'Pensacola, FL': 210692,
        'Port St. Lucie, FL': 291199,
        'Santa Rosa, CA': 648104,
        'Lafayette, LA': 139308,
        'Huntsville, AL': 200848,
        'Reno, NV': 388881,
        'Springfield, MO': 140324,
        'Visalia, CA': 229373,
        'Killeen, TX': 157633,
        'Asheville, NC': 315216,
        'York, PA': 191598,
        'Vallejo, CA': 449144,
        'Santa Maria, CA': 847774,
        'Salem, OR': 322768,
        'Salinas, CA': 730069,
        'Corpus Christi, TX': 164713,
        'Mobile, AL': 110239,
        'Brownsville, TX': 163978,
        'Salisbury, MD': 331408,
        'Reading, PA': 194111,
        'Gulfport, MS': 146818,
        'Manchester, NH': 327637,
        'Fort Wayne, IN': 128053,
        'Flint, MI': 76782,
        'Anchorage, AK': 237053,
        'Peoria, IL': 81670,
        'Canton, OH': 123868,
        'Savannah, GA': 205356,
        'Naples, FL': 440128,
        'Shreveport, LA': 55411,
        'Beaumont, TX': 121718,
        'Tallahassee, FL': 162971,
        'Eugene, OR': 351054,
        'Davenport, IA': 117089,
        'Ocala, FL': 221577,
        'Montgomery, AL': 105050,
        'Hickory, NC': 159939,
        'Trenton, NJ': 270016,
        'Ann Arbor, MI': 256859,
        'Fort Collins, CO': 411116,
        'Huntington, WV': 82338,
        'Lincoln, NE': 207478,
        'Rockford, IL': 111734,
        'Greeley, CO': 372302,
        'Gainesville, FL': 189573,
        'Boulder, CO': 507022,
        'Lubbock, TX': 106858,
        'Spartanburg, SC': 141697,
        'Green Bay, WI': 183660,
        'South Bend, IN': 121883,
        'Columbus, GA': 80641,
        'Evansville, IN': 114344,
        'Clarksville, TN': 163087,
        'Roanoke, VA': 168333,
        'Kingsport, TN': 134176,
        'Kennewick, WA': 276420,
        'Wilmington, NC': 269233,
        'Olympia, WA': 415361,
        'Hagerstown, MD': 204189,
        'Crestview, FL': 364038,
        'Duluth, MN': 177050,
        'Utica, NY': 151622,
        'Longview, TX': 152400,
        'San Luis Obispo, CA': 684836,
        'Merced, CA': 291865,
        'Laredo, TX': 149941,
        'Waco, TX': 139457,
        'Cedar Rapids, IA': 140405,
        'Sioux Falls, SD': 228571,
        'Bremerton, WA': 442639,
        'Santa Cruz, CA': 899603,
        'Erie, PA': 134316,
        'College Station, TX': 186212,
        'Kalamazoo, MI': 159494,
        'Amarillo, TX': 104239,
        'Norwich, CT': 249946,
        'Lynchburg, VA': 176514,
        'Atlantic City, NJ': 235683,
        'Charleston, WV': 90145,
        'Tuscaloosa, AL': 161583,
        'Yakima, WA': 227479,
        'Fort Smith, AR': 110913,
        'Fargo, ND': 184447,
        'Appleton, WI': 181751,
        'Binghamton, NY': 121527,
        'Tyler, TX': 199569,
        'Lafayette, IN': 143766,
        'Bellingham, WA': 462916,
        'Topeka, KS': 106585,
        'Macon, GA': 64219,
        'Daphne, AL': 355415,
        'Hilton Head Island, SC': 418017,
        'Champaign, IL': 137801,
        'Rochester, MN': 228483,
        'Medford, OR': 340112,
        'Las Cruces, NM': 180148,
        'Burlington, VT': 323645,
        'Charlottesville, VA': 281687,
        'Yuma, AZ': 214479,
        'Lake Havasu City, AZ': 289450,
        'Athens, GA': 221183,
        'Barnstable Town, MA': 497687,
        'Chico, CA': 285287,
        'Lake Charles, LA': 125994,
        'Columbia, MO': 148971,
        'Houma, LA': 128967,
        'Gainesville, GA': 242201,
        'Elkhart, IN': 156246,
        'Springfield, IL': 97576,
        'Johnson City, TN': 169218,
        'Florence, SC': 91625,
        'Jacksonville, NC': 159160,
        'Hilo, HI': 494607,
        'St. Cloud, MN': 227027,
        'Bend, OR': 523905,
        'Monroe, LA': 70229,
        'Racine, WI': 169628,
        'Punta Gorda, FL': 264307,
        'Saginaw, MI': 81332,
        'Warner Robins, GA': 114573,
        'Terre Haute, IN': 96077,
        'St. George, UT': 360936,
        'Billings, MT': 275764,
        'Midland, TX': 190205,
        'Dover, DE': 224585,
        'Greenville, NC': 134858,
        'Bowling Green, KY': 142149,
        'El Centro, CA': 223087,
        'Joplin, MO': 117437,
        'Torrington, CT': 246271,
        'Jackson, TN': 98625,
        'Redding, CA': 262673,
        'Kingston, NY': 297745,
        'Yuba City, CA': 282587,
        'Iowa City, IA': 176832,
        'Muskegon, MI': 146670,
        'Abilene, TX': 116617,
        'Oshkosh, WI': 170257,
        'Burlington, NC': 161072,
        'Panama City, FL': 342814,
        'Bloomington, IL': 136250,
        "Coeur d'Alene, ID": 442327,
        'East Stroudsburg, PA': 200699,
        'Eau Claire, WI': 205464,
        'Pueblo, CO': 209019,
        'Hattiesburg, MS': 125834,
        'Bloomington, IN': 198872,
        'Waterloo, IA': 121343,
        'Kahului, HI': 946987,
        'Odessa, TX': 139890,
        'Blacksburg, VA': 179917,
        'Auburn, AL': 215403,
        'Tupelo, MS': 131598,
        'Wausau, WI': 140649,
        'Janesville, WI': 157140,
        'Sebastian, FL': 265527,
        'State College, PA': 226369,
        'Madera, CA': 282569,
        'Jackson, MI': 132747,
        'Chambersburg, PA': 198325,
        'Grand Junction, CO': 278196,
        'Idaho Falls, ID': 267713,
        'Elizabethtown, KY': 138053,
        'Niles, MI': 175587,
        'Homosassa Springs, FL': 207536,
        'Decatur, AL': 159987,
        'Hanford, CA': 216752,
        'Concord, NH': 312424,
        'Wichita Falls, TX': 76032,
        'Santa Fe, NM': 431857,
        'Bangor, ME': 195864,
        'Traverse City, MI': 296229,
        'Alexandria, LA': 93642,
        'Monroe, MI': 151175,
        'Dothan, AL': 97815,
        'Jefferson City, MO': 140841,
        'Texarkana, TX': 107674,
        'Florence, AL': 108677,
        'Valdosta, GA': 117932,
        'London, KY': 103330,
        'Vineland, NJ': 177599,
        'Rocky Mount, NC': 115589,
        'Albany, GA': 56389,
        'Sioux City, IA': 136944,
        'Rapid City, SD': 260142,
        'Logan, UT': 304279,
        'Morristown, TN': 189305,
        'Dalton, GA': 167038,
        'Flagstaff, AZ': 435242,
        'Winchester, VA': 227097,
        'Lebanon, PA': 204839,
        'Pottsville, PA': 81264,
        'Morgantown, WV': 149793,
        'Sumter, SC': 89276,
        'The Villages, FL': 305332,
        'Sherman, TX': 171651,
        'Wheeling, WV': 84636,
        'La Crosse, WI': 185784,
        'Hammond, LA': 157307,
        'Napa, CA': 755587,
        'Harrisonburg, VA': 220163,
        'Jonesboro, AR': 114117,
        'Carbondale, IL': 74448,
        'Eureka, CA': 376110,
        'Springfield, OH': 112493,
        'Battle Creek, MI': 116648,
        'Albany, OR': 297664,
        'Mount Vernon, WA': 431676,
        'Manhattan, KS': 137577,
        'Lumberton, NC': 65966,
        'Bismarck, ND': 226410,
        'Johnstown, PA': 76745,
        'Sierra Vista, AZ': 194145,
        'Lawton, OK': 56149,
        'Jamestown, NY': 127168,
        'Cleveland, TN': 209323,
        'Pittsfield, MA': 255704,
        'Ames, IA': 167844,
        'Staunton, VA': 202342,
        'Glens Falls, NY': 202462,
        'Goldsboro, NC': 89665,
        'Farmington, NM': 176430,
        'New Bern, NC': 147697,
        'Augusta, ME': 236248,
        'San Angelo, TX': 157328,
        'St. Joseph, MO': 109983,
        'Lawrence, KS': 193359,
        'Missoula, MT': 412198,
        'Wenatchee, WA': 386912,
        'Altoona, PA': 132730,
        'Mansfield, OH': 114837,
        'Owensboro, KY': 123531,
        'Brunswick, GA': 238261,
        'Holland, MI': 229159,
        'Bozeman, MT': 492710,
        'Wooster, OH': 267994,
        'Cookeville, TN': 209457,
        'Sheboygan, WI': 171673,
        'Weirton, WV': 78580,
        'Beckley, WV': 75266,
        'California, MD': 253122,
        'Anniston, AL': 85780,
        'Muncie, IN': 77561,
        'Williamsport, PA': 154565,
        'Twin Falls, ID': 234331,
        'Show Low, AZ': 311178,
        'Longview, WA': 285196,
        'Roseburg, OR': 248557,
        'Michigan City, IN': 150872,
        'Kankakee, IL': 132877,
        'Lewiston, ME': 234369,
        'Richmond, KY': 141975,
        'Watertown, NY': 155485,
        'Ogdensburg, NY': 102440,
        'Sebring, FL': 190875,
        'Tullahoma, TN': 180580,
        'Kalispell, MT': 504256,
        'Bluefield, WV': 73793,
        'Whitewater, WI': 238200,
        'Pinehurst, NC': 245008,
        'LaGrange, GA': 80993,
        'Decatur, IL': 51709,
        'Fond du Lac, WI': 149798,
        'Gettysburg, PA': 214712,
        'Mankato, MN': 219344,
        'Bay City, MI': 114687,
        'Gadsden, AL': 88158,
        'Lima, OH': 93844,
        'Salem, OH': 99149,
        'Ithaca, NY': 233177,
        'Cheyenne, WY': 255202,
        'Grand Forks, ND': 174464,
        'Hot Springs, AR': 163076,
        'Danville, VA': 82756,
        'Truckee, CA': 463249,
        'Victoria, TX': 110601,
        'Moses Lake, WA': 250928,
        'Sevierville, TN': 467167,
        'Shelby, NC': 162703,
        'Rome, GA': 148039,
        'Meridian, MS': 57375,
        'Adrian, MI': 164571,
        'Dubuque, IA': 166899,
        'Cape Girardeau, MO': 136883,
        'Albertville, AL': 150755,
        'Cumberland, MD': 111009,
        'Ashtabula, OH': 120325,
        'Pocatello, ID': 225113,
        'Paducah, KY': 104249,
        'Fairbanks, AK': 218994,
        'Brainerd, MN': 255894,
        'Corning, NY': 121992,
        'Corvallis, OR': 391714,
        'Clarksburg, WV': 88528,
        'New Philadelphia, OH': 133865,
        'Ocean City, NJ': 393696,
        'Sunbury, PA': 117363,
        'Hermiston, OR': 210126,
        'Parkersburg, WV': 102478,
        'Grants Pass, OR': 317023,
        'Beaver Dam, WI': 178666,
        'Lufkin, TX': 140881,
        'Pine Bluff, AR': 70226,
        'Ukiah, CA': 500421,
        'Zanesville, OH': 119880,
        'Oak Harbor, WA': 562350,
        'Russellville, AR': 124149,
        'Orangeburg, SC': 81290,
        'New Castle, PA': 105312,
        'Watertown, WI': 218262,
        'Cullman, AL': 167531,
        'Columbus, IN': 152670,
        'Laurel, MS': 120824,
        'Athens, TX': 211886,
        'Meadville, PA': 120837,
        'Indiana, PA': 105835,
        'Midland, MI': 134975,
        'Hinesville, GA': 119620,
        'Bloomsburg, PA': 161128,
        'Kokomo, IN': 88460,
        'Elmira, NY': 103964,
        'Helena, MT': 337965,
        'Centralia, WA': 328262,
        'Wilson, NC': 106234,
        'Stillwater, OK': 110070,
        'Opelousas, LA': 105603,
        'Great Falls, MT': 217463,
        'Statesboro, GA': 132195,
        'Casper, WY': 195646,
        'Seneca, SC': 167344,
        'Talladega, AL': 123367,
        'Plattsburgh, NY': 153589,
        'Warsaw, IN': 177244,
        'Manitowoc, WI': 141916,
        'Searcy, AR': 113656,
        'Glenwood Springs, CO': 624785,
        'Port Angeles, WA': 400983,
        'Heber, UT': 552897,
        'Minot, ND': 165646,
        'Chillicothe, OH': 142839,
        'Keene, NH': 266774,
        'Jefferson, GA': 230770,
        'Auburn, NY': 152970,
        'Aberdeen, WA': 270039,
        'Olean, NY': 112037,
        'Findlay, OH': 140842,
        'Grand Island, NE': 155514,
        'Danville, IL': 62335,
        'Palatka, FL': 164416,
        'Quincy, IL': 113241,
        'Portsmouth, OH': 67851,
        'Frankfort, KY': 150692,
        'Key West, FL': 755603,
        'Sandusky, OH': 149348,
        'Shawnee, OK': 86975,
        'Somerset, PA': 126946,
        'Lake City, FL': 172299,
        'Wisconsin Rapids, WI': 125644,
        'Huntsville, TX': 167857,
        'Kapaa, HI': 887359,
        'Hobbs, NM': 138846,
        'Mount Airy, NC': 128413,
        'Greenwood, SC': 110830,
        'Stevens Point, WI': 162609,
        'Greeneville, TN': 149256,
        'Morehead City, NC': 318337,
        'Mount Pleasant, MI': 134316,
        'Klamath Falls, OR': 197191,
        'Roanoke Rapids, NC': 55332,
        'Shelton, WA': 412293,
        'North Wilkesboro, NC': 152704,
        'Alamogordo, NM': 148936,
        'Muskogee, OK': 63482,
        'Faribault, MN': 243135,
        'Forest City, NC': 158152,
        'Farmington, MO': 121576,
        'Marquette, MI': 178930,
        'Richmond, IN': 90524,
        'Somerset, KY': 152739,
        'Athens, OH': 115167,
        'Marion, IN': 64235,
        'Marion, OH': 104061,
        'Nacogdoches, TX': 144922,
        'Roswell, NM': 136439,
        'Coos Bay, OR': 275600,
        'Red Bluff, CA': 246760,
        'Clearlake, CA': 273636,
        'Baraboo, WI': 218111,
        'Dublin, GA': 113585,
        'Lewiston, ID': 260221,
        'Georgetown, SC': 254204,
        'Albemarle, NC': 172433,
        'Marinette, WI': 141272,
        'Martinsville, VA': 92037,
        'Mount Vernon, OH': 171586,
        'Sanford, NC': 159819,
        'Hutchinson, KS': 82834,
        'Crossville, TN': 241660,
        'Laconia, NH': 337640,
        'Walla Walla, WA': 286174,
        'Charleston, IL': 70056,
        'Gillette, WY': 222906,
        'Enid, OK': 53602,
        'Sturgis, MI': 138833,
        'Sayre, PA': 152350,
        'Marietta, OH': 119598,
        'Salina, KS': 111786,
        'Hudson, NY': 318368,
        'Starkville, MS': 158245,
        'Calhoun, GA': 170146,
        'Fergus Falls, MN': 231985,
        'Oneonta, NY': 168133,
        'Ardmore, OK': 88499,
        'Carlsbad, NM': 160661,
        'Fremont, OH': 118543,
        'Barre, VT': 271897,
        'Fernley, NV': 292494,
        'Cullowhee, NC': 278902,
        'Norwalk, OH': 122775,
        'Palestine, TX': 143670,
        'Rutland, VT': 230093,
        'Fort Madison, IA': 77773,
        'Gaffney, SC': 130486,
        'Batavia, NY': 151309,
        'Cedar City, UT': 298430,
        'Kearney, NE': 177782,
        'Durango, CO': 481445,
        'Boone, NC': 341412,
        'Point Pleasant, WV': 91178,
        'Branson, MO': 188360,
        'Carson City, NV': 340720,
        'Fairmont, WV': 103235,
        'Picayune, MS': 143235,
        'Ontario, OR': 235593,
        'Kinston, NC': 69905,
        'Poplar Bluff, MO': 104856,
        'St. Marys, GA': 180285,
        'Waycross, GA': 91406,
        'Batesville, AR': 103842,
        'Elko, NV': 216286,
        'Tiffin, OH': 108187,
        'Edwards, CO': 798576,
        'Jasper, IN': 130421,
        'Danville, KY': 128850,
        'Sterling, IL': 99850,
        'Sonora, CA': 328032,
        'Oxford, MS': 190739,
        'Glasgow, KY': 120151,
        'Payson, AZ': 327193,
        'Warrensburg, MO': 152874,
        'Athens, TN': 157730,
        'Elizabeth City, NC': 130430,
        'Milledgeville, GA': 115091,
        'Rexburg, ID': 302826,
        'Ashland, OH': 145808,
        'Enterprise, AL': 130070,
        'Jacksonville, TX': 123694,
        'Kerrville, TX': 274081,
        'Gloversville, NY': 147756,
        'Fort Leonard Wood, MO': 132597,
        'Bartlesville, OK': 88949,
        'Scottsboro, AL': 149503,
        'Greenville, OH': 129605,
        'Platteville, WI': 146356,
        'Corsicana, TX': 144058,
        'Newport, OR': 411516,
        'Winona, MN': 165402,
        'Oil City, PA': 94663,
        'Rochelle, IL': 124771,
        'Shelbyville, TN': 205503,
        'Malone, NY': 144384,
        'Paris, TX': 123449,
        'Pullman, WA': 246684,
        'Mason City, IA': 118485,
        'Ellensburg, WA': 425946,
        'Amsterdam, NY': 144320,
        'Gardnerville Ranchos, NV': 478882,
        'Galesburg, IL': 68816,
        'Del Rio, TX': 159948,
        'Tahlequah, OK': 131042,
        'Durant, OK': 121961,
        'Ozark, AL': 99379,
        'Cadillac, MI': 154533,
        'Clovis, NM': 118888,
        'Sidney, OH': 137825,
        'Morgan City, LA': 102141,
        'Montrose, CO': 345363,
        'Pahrump, NV': 271130,
        'New Castle, IN': 98698,
        'Fort Polk South, LA': 126727,
        'Norfolk, NE': 158145,
        'Cañon City, CO': 253422,
        'Kendallville, IN': 150101,
        'Bemidji, MN': 209932,
        'Blackfoot, ID': 238152,
        'Cortland, NY': 140629,
        'Mount Sterling, KY': 130631,
        'Washington, NC': 125711,
        'Sandpoint, ID': 483625,
        'Nogales, AZ': 236002,
        'Ruston, LA': 147059,
        'Bardstown, KY': 170580,
        'Clinton, IA': 120362,
        'Red Wing, MN': 242291,
        'Plymouth, IN': 160258,
        'Lewistown, PA': 126132,
        'Cornelia, GA': 162546,
        'Mount Pleasant, TX': 172059,
        'Marion, NC': 184476,
        'Bogalusa, LA': 93595,
        'Wapakoneta, OH': 136445,
        'Hillsdale, MI': 150803,
        'Paragould, AR': 99137,
        'Moultrie, GA': 119636,
        'Bedford, IN': 124615,
        'Burley, ID': 202919,
        'Menomonie, WI': 209938,
        'Shawano, WI': 176871,
        'Bellefontaine, OH': 148798,
        'Burlington, IA': 87967,
        'Harrison, AR': 138525,
        'Vicksburg, MS': 113922,
        'Henderson, NC': 97492,
        'Madisonville, KY': 93777,
        'Huntingdon, PA': 132674,
        'Lawrenceburg, TN': 150106,
        'Rolla, MO': 123529,
        'Thomasville, GA': 150036,
        'Rockingham, NC': 127571,
        'Lewisburg, PA': 185856,
        'Seymour, IN': 136556,
        'Big Rapids, MI': 149585,
        'Freeport, IL': 103897,
        'McAlester, OK': 79377,
        'Auburn, IN': 134836,
        'Coldwater, MI': 139367,
        'Ponca City, OK': 54168,
        'Stephenville, TX': 175779,
        'Willmar, MN': 192582,
        'Duncan, OK': 53178,
        'Cedartown, GA': 116842,
        'Clewiston, FL': 185707,
        'Rock Springs, WY': 175294,
        'Aberdeen, SD': 161211,
        'Sedalia, MO': 99317,
        'Muscatine, IA': 123540,
        'Okeechobee, FL': 180015,
        'Mountain Home, AR': 165761,
        'Wilmington, OH': 128085,
        'El Campo, TX': 109272,
        'McMinnville, TN': 161115,
        'Gainesville, TX': 158704,
        'Bucyrus, OH': 96694,
        'Celina, OH': 148254,
        'Big Stone Gap, VA': 59507,
        'Moscow, ID': 299139,
        'Tifton, GA': 134670,
        'Astoria, OR': 414435,
        'Bradford, PA': 86071,
        'Selinsgrove, PA': 188941,
        'Alma, MI': 107657,
        'West Plains, MO': 120881,
        'Austin, MN': 132620,
        'Garden City, KS': 169889,
        'Marshalltown, IA': 96255,
        'Riverton, WY': 236464,
        'Murray, KY': 130297,
        'McComb, MS': 101376,
        'Urbana, OH': 149471,
        'Laramie, WY': 259687,
        'Warren, PA': 105715,
        'Cambridge, OH': 113500,
        'Pittsburg, KS': 70034,
        'Hannibal, MO': 110103,
        'Espa-¦ola, NM': 281726,
        'Arcadia, FL': 194927,
        'Newberry, SC': 130163,
        'Ada, OK': 96096,
        'Crawfordsville, IN': 145073,
        'Alexandria, MN': 250269,
        'Sikeston, MO': 95150,
        'El Dorado, AR': 82864,
        'Lock Haven, PA': 146741,
        'Defiance, OH': 110103,
        'Brownwood, TX': 115690,
        'Greenwood, MS': 63335,
        'Kill Devil Hills, NC': 360186,
        'Logansport, IN': 93389,
        'Scottsbluff, NE': 124816,
        'Houghton, MI': 139846,
        'Sulphur Springs, TX': 158088,
        'Centralia, IL': 60463,
        'Easton, MD': 316696,
        'Sault Ste. Marie, MI': 144037,
        'Mayfield, KY': 100724,
        'Bay City, TX': 176749,
        'Campbellsville, KY': 113716,
        'Dyersburg, TN': 80920,
        'Owatonna, MN': 192195,
        'Big Spring, TX': 95831,
        'Vincennes, IN': 80966,
        'Coshocton, OH': 106289,
        'Huntington, IN': 105633,
        'Newport, TN': 204698,
        'Fremont, NE': 160333,
        'Jackson, WY': 796208,
        'Vidalia, GA': 119828,
        'Vernal, UT': 204298,
        'Lebanon, MO': 111057,
        'Decatur, IN': 141378,
        'Brenham, TX': 251669,
        'Hutchinson, MN': 212689,
        'Emporia, KS': 99281,
        'Escanaba, MI': 106270,
        'Brookings, SD': 210877,
        'North Platte, NE': 112099,
        'Pontiac, IL': 93937,
        'Bennington, VT': 241507,
        'Peru, IN': 86411,
        'Butte, MT': 199276,
        'Lewisburg, TN': 192221,
        'Ottumwa, IA': 75994,
        'Angola, IN': 195267,
        'Laurinburg, NC': 50820,
        'Brevard, NC': 315121,
        'Americus, GA': 70426,
        'Effingham, IL': 112313,
        'Seneca Falls, NY': 145608,
        'Brookhaven, MS': 155865,
        'Malvern, AR': 97902,
        'Dixon, IL': 101623,
        'Washington, IN': 119217,
        'Dayton, TN': 172199,
        'Columbus, NE': 178949,
        'Dodge City, KS': 130223,
        'Dickinson, ND': 176928,
        'Plainview, TX': 73786,
        'Taos, NM': 384752,
        'Jackson, OH': 100082,
        'Frankfort, IN': 123592,
        'Madison, IN': 144731,
        'Taylorville, IL': 65242,
        'Cambridge, MD': 180310,
        'Juneau, AK': 347304,
        'Las Vegas, NM': 216047,
        'Coffeyville, KS': 44572,
        'Hastings, NE': 132401,
        'Berlin, NH': 199712,
        'Miami, OK': 57774,
        'Sheridan, WY': 290633,
        'Wabash, IN': 107093,
        'Kingsville, TX': 111798,
        'Breckenridge, CO': 793655,
        'Albert Lea, MN': 123605,
        'Cleveland, MS': 101964,
        'Union City, TN': 94547,
        'Jesup, GA': 136469,
        'Susanville, CA': 163622,
        'Kirksville, MO': 104558,
        'Iron Mountain, MI': 109622,
        'Mineral Wells, TX': 209099,
        'Macomb, IL': 57096,
        'Ludington, MI': 183083,
        'Fort Morgan, CO': 241876,
        'Hays, KS': 120929,
        'Weatherford, OK': 72027,
        'Washington Court House, OH': 119413,
        'McPherson, KS': 132145,
        'Elkins, WV': 89850,
        'Alpena, MI': 125775,
        'Van Wert, OH': 101120,
        'North Vernon, IN': 132795,
        'Mountain Home, ID': 253350,
        'Silver City, NM': 160282,
        'Fredericksburg, TX': 489026,
        'Wauchula, FL': 129776,
        'Greensburg, IN': 145036,
        'La Grande, OR': 205441,
        'Thomaston, GA': 105992,
        'The Dalles, OR': 303917,
        'Grants, NM': 146436,
        'Spearfish, SD': 273163,
        'Toccoa, GA': 139546,
        'Ottawa, KS': 137000,
        'Great Bend, KS': 64738,
        'Steamboat Springs, CO': 674425,
        'Lexington, NE': 117742,
        'Middlesborough, KY': 71711,
        'Fallon, NV': 236860,
        'Marshall, MN': 118019,
        'Prineville, OR': 332050,
        'New Ulm, MN': 159514,
        'Summerville, GA': 131078,
        'Mexico, MO': 90542,
        'Indianola, MS': 73279,
        'Hailey, ID': 622805,
        'Moberly, MO': 79777,
        'Altus, OK': 40755,
        'Deming, NM': 144547,
        'Woodward, OK': 63222,
        'Brookings, OR': 419237,
        'Mitchell, SD': 146161,
        'Hood River, OR': 521128,
        'Connersville, IN': 83858,
        'Marshall, MO': 95766,
        'Pampa, TX': 59037,
        'Oskaloosa, IA': 103951,
        'Wahpeton, ND': 121373,
        'Arkadelphia, AR': 95129,
        'Cordele, GA': 55730,
        'Sterling, CO': 174972,
        'Maryville, MO': 118572,
        'Clarksdale, MS': 41926,
        'Elk City, OK': 63479,
        'Beatrice, NE': 114271,
        'Worthington, MN': 152254,
        'Liberal, KS': 92601,
        'Port Lavaca, TX': 163812,
        'Price, UT': 180279,
        'Borger, TX': 60153,
        'Grenada, MS': 63434,
        'Huron, SD': 131277,
        'Jamestown, ND': 142822,
        'Pierre, SD': 198842,
        'Evanston, WY': 195191,
        'Othello, WA': 181830,
        'Guymon, OK': 92333,
        'Storm Lake, IA': 116418,
        'Parsons, KS': 49356,
        'Los Alamos, NM': 314964,
        'Portales, NM': 108530,
        'Fairfield, IA': 120755,
        'Spirit Lake, IA': 228925,
        'Vineyard Haven, MA': 955828,
        'Maysville, KY': 74616,
        'Winnemucca, NV': 208846,
        'Snyder, TX': 76266,
        'Fitzgerald, GA': 43091,
        'Atchison, KS': 86863,
        'Spencer, IA': 118379,
        'Vermillion, SD': 168721,
        'Ketchikan, AK': 292602,
        'Craig, CO': 186440,
    },
    '3_BED': {
        'New York, NY': 564227,
        'Los Angeles, CA': 824551,
        'Chicago, IL': 276478,
        'Dallas, TX': 311677,
        'Houston, TX': 257971,
        'Washington, DC': 468689,
        'Miami, FL': 477380,
        'Philadelphia, PA': 282451,
        'Atlanta, GA': 306604,
        'Phoenix, AZ': 412283,
        'Boston, MA': 580481,
        'San Francisco, CA': 1081250,
        'Riverside, CA': 512475,
        'Detroit, MI': 223520,
        'Seattle, WA': 646909,
        'Minneapolis, MN': 332630,
        'San Diego, CA': 787679,
        'Tampa, FL': 362687,
        'Denver, CO': 548907,
        'St. Louis, MO': 234174,
        'Baltimore, MD': 314795,
        'Charlotte, NC': 327715,
        'Orlando, FL': 347977,
        'San Antonio, TX': 258530,
        'Portland, OR': 494461,
        'Sacramento, CA': 500243,
        'Las Vegas, NV': 381834,
        'Pittsburgh, PA': 196102,
        'Austin, TX': 432547,
        'Cincinnati, OH': 235976,
        'Kansas City, MO': 247125,
        'Columbus, OH': 268254,
        'Indianapolis, IN': 241074,
        'Cleveland, OH': 185234,
        'San Jose, CA': 1341179,
        'Nashville, TN': 399416,
        'Virginia Beach, VA': 282479,
        'Providence, RI': 422133,
        'Jacksonville, FL': 311943,
        'Milwaukee, WI': 269379,
        'Oklahoma City, OK': 206603,
        'Raleigh, NC': 358152,
        'Memphis, TN': 197283,
        'Richmond, VA': 304904,
        'New Orleans, LA': 232842,
        'Louisville, KY': 237292,
        'Salt Lake City, UT': 486969,
        'Hartford, CT': 306418,
        'Buffalo, NY': 223002,
        'Birmingham, AL': 206607,
        'Grand Rapids, MI': 278924,
        'Rochester, NY': 200666,
        'Tucson, AZ': 323594,
        'Tulsa, OK': 209118,
        'Fresno, CA': 351587,
        'Urban Honolulu, HI': 936238,
        'Omaha, NE': 246396,
        'Worcester, MA': 387822,
        'Bridgeport, CT': 485123,
        'Greenville, SC': 269837,
        'Albuquerque, NM': 294053,
        'Bakersfield, CA': 305961,
        'Albany, NY': 274247,
        'Knoxville, TN': 312237,
        'McAllen, TX': 165731,
        'Baton Rouge, LA': 225769,
        'North Port, FL': 468027,
        'New Haven, CT': 323315,
        'Columbia, SC': 216159,
        'Allentown, PA': 272371,
        'El Paso, TX': 194517,
        'Oxnard, CA': 733944,
        'Charleston, SC': 358486,
        'Cape Coral, FL': 405160,
        'Greensboro, NC': 233836,
        'Boise City, ID': 419292,
        'Stockton, CA': 463403,
        'Colorado Springs, CO': 408524,
        'Little Rock, AR': 199093,
        'Lakeland, FL': 294211,
        'Des Moines, IA': 251100,
        'Akron, OH': 182913,
        'Springfield, MA': 306390,
        'Ogden, UT': 426100,
        'Deltona, FL': 332316,
        'Winston, NC': 235450,
        'Madison, WI': 348441,
        'Provo, UT': 467767,
        'Durham, NC': 368278,
        'Syracuse, NY': 182846,
        'Wichita, KS': 192029,
        'Toledo, OH': 152359,
        'Augusta, GA': 203324,
        'Palm Bay, FL': 329478,
        'Jackson, MS': 182809,
        'Harrisburg, PA': 241574,
        'Spokane, WA': 394415,
        'Chattanooga, TN': 280202,
        'Scranton, PA': 178529,
        'Modesto, CA': 410894,
        'Fayetteville, AR': 284816,
        'Lansing, MI': 212707,
        'Lancaster, PA': 290910,
        'Portland, ME': 451521,
        'Youngstown, OH': 139499,
        'Fayetteville, NC': 179700,
        'Lexington, KY': 246242,
        'Myrtle Beach, SC': 335206,
        'Pensacola, FL': 276977,
        'Port St. Lucie, FL': 384421,
        'Santa Rosa, CA': 749238,
        'Lafayette, LA': 211848,
        'Huntsville, AL': 267889,
        'Reno, NV': 486309,
        'Springfield, MO': 220297,
        'Visalia, CA': 310015,
        'Killeen, TX': 227869,
        'Asheville, NC': 412299,
        'York, PA': 243327,
        'Vallejo, CA': 529995,
        'Santa Maria, CA': 758534,
        'Salem, OR': 400154,
        'Salinas, CA': 744315,
        'Corpus Christi, TX': 227575,
        'Mobile, AL': 178320,
        'Brownsville, TX': 196070,
        'Salisbury, MD': 384663,
        'Reading, PA': 245694,
        'Gulfport, MS': 187067,
        'Manchester, NH': 429524,
        'Fort Wayne, IN': 194890,
        'Flint, MI': 166180,
        'Anchorage, AK': 350432,
        'Peoria, IL': 139848,
        'Canton, OH': 172199,
        'Savannah, GA': 267718,
        'Naples, FL': 667088,
        'Shreveport, LA': 151900,
        'Beaumont, TX': 187192,
        'Tallahassee, FL': 251899,
        'Eugene, OR': 424980,
        'Davenport, IA': 167050,
        'Ocala, FL': 274792,
        'Montgomery, AL': 165210,
        'Hickory, NC': 243342,
        'Trenton, NJ': 336440,
        'Ann Arbor, MI': 326241,
        'Fort Collins, CO': 509084,
        'Huntington, WV': 138436,
        'Lincoln, NE': 263877,
        'Rockford, IL': 163864,
        'Greeley, CO': 460871,
        'Gainesville, FL': 278212,
        'Boulder, CO': 702256,
        'Lubbock, TX': 194046,
        'Spartanburg, SC': 235467,
        'Green Bay, WI': 262643,
        'South Bend, IN': 191414,
        'Columbus, GA': 152392,
        'Evansville, IN': 197398,
        'Clarksville, TN': 258965,
        'Roanoke, VA': 239827,
        'Kingsport, TN': 212478,
        'Kennewick, WA': 373929,
        'Wilmington, NC': 354621,
        'Olympia, WA': 467969,
        'Hagerstown, MD': 264397,
        'Crestview, FL': 363348,
        'Duluth, MN': 225256,
        'Utica, NY': 181145,
        'Longview, TX': 221292,
        'San Luis Obispo, CA': 802321,
        'Merced, CA': 360439,
        'Laredo, TX': 220339,
        'Waco, TX': 236952,
        'Cedar Rapids, IA': 197027,
        'Sioux Falls, SD': 278211,
        'Bremerton, WA': 518475,
        'Santa Cruz, CA': 1158485,
        'Erie, PA': 167534,
        'College Station, TX': 262682,
        'Kalamazoo, MI': 221006,
        'Amarillo, TX': 198554,
        'Norwich, CT': 321924,
        'Lynchburg, VA': 248736,
        'Atlantic City, NJ': 307917,
        'Charleston, WV': 137858,
        'Tuscaloosa, AL': 225348,
        'Yakima, WA': 326368,
        'Fort Smith, AR': 173288,
        'Fargo, ND': 248062,
        'Appleton, WI': 246913,
        'Binghamton, NY': 153348,
        'Tyler, TX': 268587,
        'Lafayette, IN': 212740,
        'Bellingham, WA': 580808,
        'Topeka, KS': 189359,
        'Macon, GA': 152571,
        'Daphne, AL': 313577,
        'Hilton Head Island, SC': 473247,
        'Champaign, IL': 182289,
        'Rochester, MN': 264041,
        'Medford, OR': 404839,
        'Las Cruces, NM': 252360,
        'Burlington, VT': 423605,
        'Charlottesville, VA': 357421,
        'Yuma, AZ': 248023,
        'Lake Havasu City, AZ': 367926,
        'Athens, GA': 290444,
        'Barnstable Town, MA': 645294,
        'Chico, CA': 401574,
        'Lake Charles, LA': 204121,
        'Columbia, MO': 234439,
        'Houma, LA': 197693,
        'Gainesville, GA': 311915,
        'Elkhart, IN': 218435,
        'Springfield, IL': 166481,
        'Johnson City, TN': 253597,
        'Florence, SC': 164691,
        'Jacksonville, NC': 233082,
        'Hilo, HI': 544052,
        'St. Cloud, MN': 262205,
        'Bend, OR': 591090,
        'Monroe, LA': 153727,
        'Racine, WI': 242784,
        'Punta Gorda, FL': 398901,
        'Saginaw, MI': 147031,
        'Warner Robins, GA': 189592,
        'Terre Haute, IN': 151221,
        'St. George, UT': 450859,
        'Billings, MT': 356150,
        'Midland, TX': 274406,
        'Dover, DE': 296747,
        'Greenville, NC': 216367,
        'Bowling Green, KY': 226663,
        'El Centro, CA': 300321,
        'Joplin, MO': 187096,
        'Torrington, CT': 332701,
        'Jackson, TN': 196593,
        'Redding, CA': 351247,
        'Kingston, NY': 361525,
        'Yuba City, CA': 383121,
        'Iowa City, IA': 255118,
        'Muskegon, MI': 207994,
        'Abilene, TX': 201129,
        'Oshkosh, WI': 230907,
        'Burlington, NC': 256116,
        'Panama City, FL': 313915,
        'Bloomington, IL': 190335,
        "Coeur d'Alene, ID": 502279,
        'East Stroudsburg, PA': 264794,
        'Eau Claire, WI': 255474,
        'Pueblo, CO': 296703,
        'Hattiesburg, MS': 194400,
        'Bloomington, IN': 259731,
        'Waterloo, IA': 176587,
        'Kahului, HI': 968972,
        'Odessa, TX': 221095,
        'Blacksburg, VA': 258829,
        'Auburn, AL': 258416,
        'Tupelo, MS': 190077,
        'Wausau, WI': 197790,
        'Janesville, WI': 220698,
        'Sebastian, FL': 386951,
        'State College, PA': 283074,
        'Madera, CA': 367001,
        'Jackson, MI': 194100,
        'Chambersburg, PA': 241538,
        'Grand Junction, CO': 358450,
        'Idaho Falls, ID': 346802,
        'Elizabethtown, KY': 216610,
        'Niles, MI': 229883,
        'Homosassa Springs, FL': 306178,
        'Decatur, AL': 214588,
        'Hanford, CA': 307805,
        'Concord, NH': 400972,
        'Wichita Falls, TX': 153731,
        'Santa Fe, NM': 493935,
        'Bangor, ME': 239152,
        'Traverse City, MI': 348751,
        'Alexandria, LA': 167288,
        'Monroe, MI': 218710,
        'Dothan, AL': 177136,
        'Jefferson City, MO': 206708,
        'Texarkana, TX': 183323,
        'Florence, AL': 187914,
        'Valdosta, GA': 191609,
        'London, KY': 163469,
        'Vineland, NJ': 232666,
        'Rocky Mount, NC': 176094,
        'Albany, GA': 138422,
        'Sioux City, IA': 198612,
        'Rapid City, SD': 312680,
        'Logan, UT': 373683,
        'Morristown, TN': 268871,
        'Dalton, GA': 223048,
        'Flagstaff, AZ': 575189,
        'Winchester, VA': 311844,
        'Lebanon, PA': 246527,
        'Pottsville, PA': 113282,
        'Morgantown, WV': 207097,
        'Sumter, SC': 176280,
        'The Villages, FL': 431890,
        'Sherman, TX': 261453,
        'Wheeling, WV': 138464,
        'La Crosse, WI': 241697,
        'Hammond, LA': 221531,
        'Napa, CA': 819698,
        'Harrisonburg, VA': 284076,
        'Jonesboro, AR': 190525,
        'Carbondale, IL': 141755,
        'Eureka, CA': 450702,
        'Springfield, OH': 166555,
        'Battle Creek, MI': 170767,
        'Albany, OR': 377972,
        'Mount Vernon, WA': 526650,
        'Manhattan, KS': 203082,
        'Lumberton, NC': 119928,
        'Bismarck, ND': 277113,
        'Johnstown, PA': 114447,
        'Sierra Vista, AZ': 245215,
        'Lawton, OK': 123052,
        'Jamestown, NY': 144143,
        'Cleveland, TN': 280568,
        'Pittsfield, MA': 310326,
        'Ames, IA': 231398,
        'Staunton, VA': 276388,
        'Glens Falls, NY': 245784,
        'Goldsboro, NC': 193815,
        'Farmington, NM': 227830,
        'New Bern, NC': 233201,
        'Augusta, ME': 272150,
        'San Angelo, TX': 239292,
        'St. Joseph, MO': 180178,
        'Lawrence, KS': 253550,
        'Missoula, MT': 502765,
        'Wenatchee, WA': 487410,
        'Altoona, PA': 158250,
        'Mansfield, OH': 160041,
        'Owensboro, KY': 189221,
        'Brunswick, GA': 265311,
        'Holland, MI': 268545,
        'Bozeman, MT': 581619,
        'Wooster, OH': 336784,
        'Cookeville, TN': 281095,
        'Sheboygan, WI': 217453,
        'Weirton, WV': 129593,
        'Beckley, WV': 126513,
        'California, MD': 336299,
        'Anniston, AL': 165989,
        'Muncie, IN': 138579,
        'Williamsport, PA': 195955,
        'Twin Falls, ID': 326614,
        'Show Low, AZ': 409619,
        'Longview, WA': 382093,
        'Roseburg, OR': 332347,
        'Michigan City, IN': 212820,
        'Kankakee, IL': 188295,
        'Lewiston, ME': 275477,
        'Richmond, KY': 230758,
        'Watertown, NY': 186025,
        'Ogdensburg, NY': 126388,
        'Sebring, FL': 258718,
        'Tullahoma, TN': 275223,
        'Kalispell, MT': 593229,
        'Bluefield, WV': 129428,
        'Whitewater, WI': 311864,
        'Pinehurst, NC': 354149,
        'LaGrange, GA': 175044,
        'Decatur, IL': 113942,
        'Fond du Lac, WI': 199319,
        'Gettysburg, PA': 269494,
        'Mankato, MN': 247505,
        'Bay City, MI': 165205,
        'Gadsden, AL': 192580,
        'Lima, OH': 158509,
        'Salem, OH': 145659,
        'Ithaca, NY': 280056,
        'Cheyenne, WY': 333649,
        'Grand Forks, ND': 213389,
        'Hot Springs, AR': 235028,
        'Danville, VA': 165399,
        'Truckee, CA': 607023,
        'Victoria, TX': 205513,
        'Moses Lake, WA': 326304,
        'Sevierville, TN': 406546,
        'Shelby, NC': 237224,
        'Rome, GA': 217723,
        'Meridian, MS': 111606,
        'Adrian, MI': 208214,
        'Dubuque, IA': 221387,
        'Cape Girardeau, MO': 204543,
        'Albertville, AL': 204458,
        'Cumberland, MD': 151987,
        'Ashtabula, OH': 158892,
        'Pocatello, ID': 293147,
        'Paducah, KY': 175467,
        'Fairbanks, AK': 313307,
        'Brainerd, MN': 303320,
        'Corning, NY': 144055,
        'Corvallis, OR': 471765,
        'Clarksburg, WV': 154588,
        'New Philadelphia, OH': 183861,
        'Ocean City, NJ': 532452,
        'Sunbury, PA': 147769,
        'Hermiston, OR': 285253,
        'Parkersburg, WV': 152855,
        'Grants Pass, OR': 408115,
        'Beaver Dam, WI': 232181,
        'Lufkin, TX': 205547,
        'Pine Bluff, AR': 132220,
        'Ukiah, CA': 523331,
        'Zanesville, OH': 184138,
        'Oak Harbor, WA': 563461,
        'Russellville, AR': 176456,
        'Orangeburg, SC': 147403,
        'New Castle, PA': 146247,
        'Watertown, WI': 279908,
        'Cullman, AL': 220516,
        'Columbus, IN': 223340,
        'Laurel, MS': 175636,
        'Athens, TX': 289690,
        'Meadville, PA': 157417,
        'Indiana, PA': 147576,
        'Midland, MI': 178894,
        'Hinesville, GA': 195199,
        'Bloomsburg, PA': 213754,
        'Kokomo, IN': 153983,
        'Elmira, NY': 140294,
        'Helena, MT': 431983,
        'Centralia, WA': 413720,
        'Wilson, NC': 194940,
        'Stillwater, OK': 197031,
        'Opelousas, LA': 165114,
        'Great Falls, MT': 279476,
        'Statesboro, GA': 215691,
        'Casper, WY': 267998,
        'Seneca, SC': 261319,
        'Talladega, AL': 188861,
        'Plattsburgh, NY': 189419,
        'Warsaw, IN': 237425,
        'Manitowoc, WI': 185072,
        'Searcy, AR': 175893,
        'DuBois, PA': 141493,
        'Glenwood Springs, CO': 666144,
        'Port Angeles, WA': 471911,
        'Heber, UT': 734719,
        'Minot, ND': 230717,
        'Chillicothe, OH': 196695,
        'Keene, NH': 318662,
        'Jefferson, GA': 313472,
        'Auburn, NY': 175707,
        'Aberdeen, WA': 349588,
        'Olean, NY': 130658,
        'Findlay, OH': 195288,
        'Grand Island, NE': 223209,
        'Danville, IL': 100423,
        'Palatka, FL': 228783,
        'Quincy, IL': 160987,
        'Portsmouth, OH': 124538,
        'Frankfort, KY': 206768,
        'Key West, FL': 1039047,
        'Sandusky, OH': 189421,
        'Shawnee, OK': 163021,
        'Somerset, PA': 165069,
        'Lake City, FL': 238183,
        'Wisconsin Rapids, WI': 177832,
        'Huntsville, TX': 258753,
        'Kapaa, HI': 880100,
        'Hobbs, NM': 195595,
        'Mount Airy, NC': 202086,
        'Greenwood, SC': 190547,
        'Stevens Point, WI': 226298,
        'Gallup, NM': 206844,
        'Greeneville, TN': 224078,
        'Morehead City, NC': 390554,
        'Mount Pleasant, MI': 179551,
        'Klamath Falls, OR': 297853,
        'Roanoke Rapids, NC': 106597,
        'Shelton, WA': 453117,
        'North Wilkesboro, NC': 217183,
        'Alamogordo, NM': 184157,
        'Muskogee, OK': 146174,
        'Faribault, MN': 291741,
        'Forest City, NC': 214196,
        'Farmington, MO': 190183,
        'Marquette, MI': 221049,
        'Richmond, IN': 144878,
        'Somerset, KY': 210155,
        'Athens, OH': 177444,
        'Marion, IN': 119426,
        'Marion, OH': 149342,
        'Nacogdoches, TX': 222641,
        'Roswell, NM': 196618,
        'Coos Bay, OR': 350177,
        'Red Bluff, CA': 330447,
        'Clearlake, CA': 354956,
        'Baraboo, WI': 280187,
        'Rio Grande City, TX': 164621,
        'Dublin, GA': 194406,
        'Lewiston, ID': 337104,
        'Georgetown, SC': 348567,
        'Albemarle, NC': 271618,
        'Marinette, WI': 180444,
        'Martinsville, VA': 144802,
        'Mount Vernon, OH': 234101,
        'Sanford, NC': 244643,
        'Hutchinson, KS': 143611,
        'Crossville, TN': 310661,
        'Laconia, NH': 431344,
        'Walla Walla, WA': 391483,
        'Charleston, IL': 120920,
        'Gillette, WY': 275479,
        'Enid, OK': 137266,
        'Sturgis, MI': 177050,
        'Sayre, PA': 173162,
        'Marietta, OH': 170317,
        'Salina, KS': 179048,
        'Hudson, NY': 380274,
        'Starkville, MS': 200848,
        'Calhoun, GA': 230302,
        'Fergus Falls, MN': 261399,
        'Oneonta, NY': 189956,
        'Ardmore, OK': 170425,
        'Carlsbad, NM': 238256,
        'Eagle Pass, TX': 207103,
        'Fremont, OH': 155791,
        'Barre, VT': 329161,
        'Fernley, NV': 361106,
        'Columbus, MS': 180578,
        'Cullowhee, NC': 379386,
        'Norwalk, OH': 159206,
        'Palestine, TX': 203038,
        'Rutland, VT': 269889,
        'Fort Madison, IA': 126958,
        'Gaffney, SC': 208487,
        'Batavia, NY': 182317,
        'Cedar City, UT': 363552,
        'Kearney, NE': 234831,
        'Durango, CO': 641596,
        'Boone, NC': 453822,
        'Point Pleasant, WV': 141211,
        'Branson, MO': 238471,
        'Carson City, NV': 417460,
        'Fairmont, WV': 171681,
        'Picayune, MS': 203359,
        'Ontario, OR': 325998,
        'Kinston, NC': 148778,
        'Poplar Bluff, MO': 168977,
        'St. Marys, GA': 243802,
        'Waycross, GA': 168873,
        'Batesville, AR': 159446,
        'Elko, NV': 309018,
        'Tiffin, OH': 147697,
        'Edwards, CO': 1099542,
        'Jasper, IN': 213987,
        'Danville, KY': 189348,
        'Sterling, IL': 136514,
        'Sonora, CA': 394976,
        'Oxford, MS': 276199,
        'Glasgow, KY': 178295,
        'Payson, AZ': 429900,
        'Warrensburg, MO': 228150,
        'Athens, TN': 242114,
        'Elizabeth City, NC': 222260,
        'Milledgeville, GA': 169469,
        'Rexburg, ID': 366887,
        'Ashland, OH': 200038,
        'Enterprise, AL': 189144,
        'Jacksonville, TX': 201564,
        'Kerrville, TX': 377117,
        'Gloversville, NY': 181391,
        'Fort Leonard Wood, MO': 182510,
        'Bartlesville, OK': 153082,
        'Douglas, GA': 183056,
        'Scottsboro, AL': 209772,
        'Alice, TX': 186160,
        'Greenville, OH': 183773,
        'Platteville, WI': 184011,
        'Corsicana, TX': 213931,
        'Newport, OR': 510634,
        'Winona, MN': 218978,
        'Oil City, PA': 120612,
        'Rochelle, IL': 177629,
        'Shelbyville, TN': 292420,
        'Malone, NY': 160381,
        'Paris, TX': 209882,
        'Pullman, WA': 346243,
        'Mason City, IA': 157166,
        'Ellensburg, WA': 496805,
        'Natchez, MS': 155828,
        'Amsterdam, NY': 170021,
        'Gardnerville Ranchos, NV': 571478,
        'Galesburg, IL': 105128,
        'Del Rio, TX': 221388,
        'Tahlequah, OK': 180668,
        'Durant, OK': 210249,
        'Ozark, AL': 158648,
        'Cadillac, MI': 198610,
        'Clovis, NM': 191064,
        'Sidney, OH': 200489,
        'Morgan City, LA': 156263,
        'Montrose, CO': 441282,
        'Pahrump, NV': 341460,
        'New Castle, IN': 165544,
        'Fort Polk South, LA': 169082,
        'Norfolk, NE': 217015,
        'Cañon City, CO': 328442,
        'Kendallville, IN': 202489,
        'Bemidji, MN': 245584,
        'Blackfoot, ID': 293169,
        'Cortland, NY': 165622,
        'Mount Sterling, KY': 182653,
        'Washington, NC': 218262,
        'Sandpoint, ID': 545972,
        'Nogales, AZ': 235476,
        'Ruston, LA': 219080,
        'Bardstown, KY': 233424,
        'Clinton, IA': 169725,
        'Red Wing, MN': 282822,
        'Plymouth, IN': 205053,
        'Lewistown, PA': 155220,
        'Cornelia, GA': 253188,
        'Mount Pleasant, TX': 250832,
        'Marion, NC': 238011,
        'Bogalusa, LA': 154341,
        'Wapakoneta, OH': 194345,
        'Hillsdale, MI': 196400,
        'Paragould, AR': 174688,
        'Moultrie, GA': 174699,
        'Bedford, IN': 179194,
        'Burley, ID': 268704,
        'Menomonie, WI': 254799,
        'Shawano, WI': 222322,
        'Bellefontaine, OH': 210294,
        'Burlington, IA': 131729,
        'Harrison, AR': 190324,
        'Vicksburg, MS': 177017,
        'Henderson, NC': 193104,
        'Madisonville, KY': 167291,
        'Huntingdon, PA': 160271,
        'Lawrenceburg, TN': 232023,
        'Rolla, MO': 182295,
        'Thomasville, GA': 219571,
        'Rockingham, NC': 182913,
        'Lewisburg, PA': 228940,
        'Seymour, IN': 198151,
        'Big Rapids, MI': 204807,
        'Freeport, IL': 146335,
        'McAlester, OK': 139180,
        'Auburn, IN': 194722,
        'Coldwater, MI': 176246,
        'Ponca City, OK': 122539,
        'Stephenville, TX': 265153,
        'Willmar, MN': 211301,
        'Duncan, OK': 140629,
        'Cedartown, GA': 201669,
        'Greenville, MS': 113883,
        'Clewiston, FL': 252200,
        'Rock Springs, WY': 253107,
        'Aberdeen, SD': 204098,
        'Sedalia, MO': 168025,
        'Muscatine, IA': 181547,
        'Okeechobee, FL': 250326,
        'Mountain Home, AR': 219347,
        'Wilmington, OH': 202707,
        'El Campo, TX': 200562,
        'McMinnville, TN': 243317,
        'Gainesville, TX': 314725,
        'Bucyrus, OH': 133881,
        'Celina, OH': 232545,
        'Big Stone Gap, VA': 116135,
        'Moscow, ID': 378746,
        'Tifton, GA': 206681,
        'Astoria, OR': 495437,
        'Bradford, PA': 113613,
        'Selinsgrove, PA': 219142,
        'Alma, MI': 145663,
        'West Plains, MO': 189497,
        'Austin, MN': 171681,
        'Blytheville, AR': 121221,
        'Garden City, KS': 207023,
        'Marshalltown, IA': 148766,
        'Riverton, WY': 304601,
        'Murray, KY': 195960,
        'Safford, AZ': 247467,
        'McComb, MS': 153740,
        'Urbana, OH': 206308,
        'Laramie, WY': 320418,
        'Warren, PA': 135459,
        'Cambridge, OH': 157997,
        'Pittsburg, KS': 132268,
        'Hannibal, MO': 187296,
        'Williston, ND': 280057,
        'Espa-¦ola, NM': 327561,
        'Arcadia, FL': 262849,
        'Newberry, SC': 223663,
        'Ada, OK': 163954,
        'Crawfordsville, IN': 191786,
        'Jacksonville, IL': 127484,
        'Alexandria, MN': 279786,
        'Sikeston, MO': 149368,
        'El Dorado, AR': 142001,
        'Lock Haven, PA': 173878,
        'DeRidder, LA': 192798,
        'Defiance, OH': 157716,
        'Natchitoches, LA': 199976,
        'Brownwood, TX': 195919,
        'Greenwood, MS': 100980,
        'Kill Devil Hills, NC': 468283,
        'Logansport, IN': 140944,
        'Scottsbluff, NE': 176351,
        'Houghton, MI': 152363,
        'Sulphur Springs, TX': 233447,
        'Centralia, IL': 111453,
        'Easton, MD': 405139,
        'Sault Ste. Marie, MI': 175699,
        'Corinth, MS': 154924,
        'Mayfield, KY': 161235,
        'Bay City, TX': 212905,
        'Campbellsville, KY': 165569,
        'Dyersburg, TN': 162691,
        'Owatonna, MN': 224160,
        'Big Spring, TX': 181159,
        'Vincennes, IN': 145996,
        'Coshocton, OH': 155754,
        'Huntington, IN': 163948,
        'Newport, TN': 235115,
        'Fremont, NE': 214387,
        'Selma, AL': 113701,
        'Jackson, WY': 1004939,
        'Vidalia, GA': 182229,
        'Vernal, UT': 261179,
        'Lebanon, MO': 187599,
        'Decatur, IN': 182171,
        'Brenham, TX': 320766,
        'Hutchinson, MN': 237593,
        'Emporia, KS': 160625,
        'Escanaba, MI': 144050,
        'Brookings, SD': 237723,
        'North Platte, NE': 183046,
        'Pontiac, IL': 139961,
        'Bennington, VT': 324507,
        'Peru, IN': 132037,
        'Butte, MT': 274478,
        'Lewisburg, TN': 312993,
        'Ottumwa, IA': 128206,
        'Angola, IN': 248534,
        'Laurinburg, NC': 129491,
        'Brevard, NC': 436673,
        'Americus, GA': 114589,
        'Effingham, IL': 174218,
        'Seneca Falls, NY': 170166,
        'Brookhaven, MS': 204078,
        'Malvern, AR': 171778,
        'Dixon, IL': 145887,
        'Washington, IN': 186671,
        'Dayton, TN': 246332,
        'Columbus, NE': 237947,
        'Martin, TN': 176606,
        'Dodge City, KS': 184917,
        'Dickinson, ND': 232817,
        'Troy, AL': 188209,
        'Plainview, TX': 145239,
        'Taos, NM': 466415,
        'Jackson, OH': 153542,
        'Frankfort, IN': 183669,
        'Madison, IN': 192478,
        'Taylorville, IL': 116881,
        'Paris, TN': 196916,
        'Cambridge, MD': 244576,
        'Juneau, AK': 460100,
        'Las Vegas, NM': 253195,
        'Coffeyville, KS': 97416,
        'Hastings, NE': 194736,
        'Berlin, NH': 234460,
        'Miami, OK': 119219,
        'Sheridan, WY': 398363,
        'Wabash, IN': 153310,
        'Kingsville, TX': 175005,
        'Breckenridge, CO': 1143788,
        'Albert Lea, MN': 161790,
        'Cleveland, MS': 159850,
        'Union City, TN': 159677,
        'Jesup, GA': 195184,
        'Susanville, CA': 250461,
        'Kirksville, MO': 157928,
        'Iron Mountain, MI': 151812,
        'Mineral Wells, TX': 265138,
        'Macomb, IL': 88746,
        'Ludington, MI': 223787,
        'Fort Morgan, CO': 314782,
        'Kennett, MO': 114255,
        'Hays, KS': 189472,
        'Weatherford, OK': 159567,
        'Washington Court House, OH': 179892,
        'McPherson, KS': 187408,
        'Elkins, WV': 139887,
        'Lincoln, IL': 129430,
        'Camden, AR': 132407,
        'Alpena, MI': 156881,
        'Van Wert, OH': 148197,
        'Crescent City, CA': 363106,
        'North Vernon, IN': 184584,
        'Mountain Home, ID': 321498,
        'Silver City, NM': 219017,
        'Fredericksburg, TX': 535177,
        'Wauchula, FL': 193429,
        'Uvalde, TX': 224383,
        'Greensburg, IN': 210641,
        'La Grande, OR': 284302,
        'Thomaston, GA': 181933,
        'Bainbridge, GA': 202691,
        'The Dalles, OR': 377245,
        'Grants, NM': 154413,
        'Spearfish, SD': 359520,
        'Toccoa, GA': 207599,
        'Ottawa, KS': 216302,
        'Great Bend, KS': 113907,
        'Bennettsville, SC': 136971,
        'Steamboat Springs, CO': 957896,
        'Lexington, NE': 171442,
        'Middlesborough, KY': 113486,
        'Fallon, NV': 336612,
        'Marshall, MN': 162332,
        'Prineville, OR': 428276,
        'New Ulm, MN': 180664,
        'Summerville, GA': 186539,
        'Mexico, MO': 149678,
        'Indianola, MS': 89678,
        'Forrest City, AR': 102590,
        'Hailey, ID': 837792,
        'Moberly, MO': 161262,
        'Altus, OK': 109358,
        'Deming, NM': 171678,
        'Woodward, OK': 128380,
        'Magnolia, AR': 166515,
        'Brookings, OR': 475654,
        'Mitchell, SD': 204924,
        'Hood River, OR': 633178,
        'Connersville, IN': 144511,
        'Marshall, MO': 156734,
        'Pampa, TX': 126387,
        'Oskaloosa, IA': 155289,
        'Wahpeton, ND': 179079,
        'Arkadelphia, AR': 161049,
        'Cordele, GA': 142481,
        'Sterling, CO': 239058,
        'Maryville, MO': 188666,
        'Clarksdale, MS': 58989,
        'Elk City, OK': 157671,
        'Beatrice, NE': 171518,
        'Worthington, MN': 200228,
        'Liberal, KS': 146530,
        'Port Lavaca, TX': 210233,
        'Price, UT': 224136,
        'Borger, TX': 123445,
        'Dumas, TX': 186988,
        'Grenada, MS': 119593,
        'Jamestown, ND': 194888,
        'Huron, SD': 177043,
        'Pierre, SD': 247653,
        'Evanston, WY': 271152,
        'Othello, WA': 274637,
        'Guymon, OK': 152450,
        'Storm Lake, IA': 160614,
        'Parsons, KS': 94405,
        'Los Alamos, NM': 445610,
        'Andrews, TX': 223012,
        'Portales, NM': 179303,
        'Fairfield, IA': 169230,
        'Hereford, TX': 183255,
        'Spirit Lake, IA': 342303,
        'Vineyard Haven, MA': 1218700,
        'Maysville, KY': 148149,
        'Winnemucca, NV': 306071,
        'Snyder, TX': 147806,
        'Fitzgerald, GA': 117962,
        'Atchison, KS': 153323,
        'Spencer, IA': 165139,
        'Sweetwater, TX': 146721,
        'Vermillion, SD': 230286,
        'Ketchikan, AK': 403377,
        'Craig, CO': 266213,
    },
    '4_BED': {
        'New York, NY': 694258,
        'Los Angeles, CA': 1023922,
        'Chicago, IL': 394206,
        'Dallas, TX': 468545,
        'Houston, TX': 359819,
        'Washington, DC': 648858,
        'Miami, FL': 651607,
        'Philadelphia, PA': 478699,
        'Atlanta, GA': 421331,
        'Phoenix, AZ': 507110,
        'Boston, MA': 779280,
        'San Francisco, CA': 1370966,
        'Riverside, CA': 617087,
        'Detroit, MI': 388468,
        'Seattle, WA': 858036,
        'Minneapolis, MN': 421679,
        'San Diego, CA': 980108,
        'Tampa, FL': 475500,
        'Denver, CO': 665919,
        'St. Louis, MO': 358853,
        'Baltimore, MD': 486462,
        'Charlotte, NC': 481094,
        'Orlando, FL': 463713,
        'San Antonio, TX': 364887,
        'Portland, OR': 635415,
        'Sacramento, CA': 631954,
        'Las Vegas, NV': 461106,
        'Pittsburgh, PA': 336960,
        'Austin, TX': 560680,
        'Cincinnati, OH': 359312,
        'Kansas City, MO': 394601,
        'Columbus, OH': 398820,
        'Indianapolis, IN': 355959,
        'Cleveland, OH': 299782,
        'San Jose, CA': 1620717,
        'Nashville, TN': 619926,
        'Virginia Beach, VA': 404299,
        'Providence, RI': 552446,
        'Jacksonville, FL': 439676,
        'Milwaukee, WI': 352190,
        'Oklahoma City, OK': 323538,
        'Raleigh, NC': 527053,
        'Memphis, TN': 348197,
        'Richmond, VA': 385546,
        'New Orleans, LA': 328332,
        'Louisville, KY': 352737,
        'Salt Lake City, UT': 549157,
        'Hartford, CT': 411489,
        'Buffalo, NY': 301319,
        'Birmingham, AL': 370019,
        'Grand Rapids, MI': 354953,
        'Rochester, NY': 266487,
        'Tucson, AZ': 401482,
        'Tulsa, OK': 323291,
        'Fresno, CA': 455295,
        'Urban Honolulu, HI': 1121988,
        'Omaha, NE': 366072,
        'Worcester, MA': 526043,
        'Bridgeport, CT': 741409,
        'Greenville, SC': 394133,
        'Albuquerque, NM': 384797,
        'Bakersfield, CA': 397700,
        'Albany, NY': 361442,
        'Knoxville, TN': 465834,
        'McAllen, TX': 266705,
        'Baton Rouge, LA': 330846,
        'North Port, FL': 662009,
        'New Haven, CT': 453081,
        'Columbia, SC': 313141,
        'Allentown, PA': 402335,
        'El Paso, TX': 258320,
        'Oxnard, CA': 873499,
        'Charleston, SC': 488994,
        'Cape Coral, FL': 521843,
        'Greensboro, NC': 368269,
        'Boise City, ID': 523189,
        'Stockton, CA': 605537,
        'Colorado Springs, CO': 497100,
        'Little Rock, AR': 311723,
        'Lakeland, FL': 365348,
        'Des Moines, IA': 350418,
        'Akron, OH': 310557,
        'Springfield, MA': 376068,
        'Ogden, UT': 468427,
        'Deltona, FL': 409968,
        'Winston, NC': 353405,
        'Madison, WI': 450512,
        'Provo, UT': 532718,
        'Durham, NC': 548680,
        'Syracuse, NY': 251907,
        'Wichita, KS': 268398,
        'Toledo, OH': 256286,
        'Augusta, GA': 310144,
        'Palm Bay, FL': 461820,
        'Jackson, MS': 316030,
        'Harrisburg, PA': 360425,
        'Spokane, WA': 451075,
        'Chattanooga, TN': 404561,
        'Scranton, PA': 241864,
        'Modesto, CA': 495830,
        'Fayetteville, AR': 422894,
        'Lansing, MI': 283827,
        'Lancaster, PA': 398096,
        'Portland, ME': 576569,
        'Youngstown, OH': 199310,
        'Fayetteville, NC': 296635,
        'Lexington, KY': 363421,
        'Myrtle Beach, SC': 494381,
        'Pensacola, FL': 392923,
        'Port St. Lucie, FL': 464263,
        'Santa Rosa, CA': 853465,
        'Lafayette, LA': 312912,
        'Huntsville, AL': 384826,
        'Reno, NV': 608311,
        'Springfield, MO': 326659,
        'Visalia, CA': 396365,
        'Killeen, TX': 294627,
        'Asheville, NC': 595036,
        'York, PA': 343698,
        'Vallejo, CA': 626810,
        'Santa Maria, CA': 967348,
        'Salem, OR': 489327,
        'Salinas, CA': 794767,
        'Corpus Christi, TX': 329662,
        'Mobile, AL': 277131,
        'Brownsville, TX': 265517,
        'Salisbury, MD': 536637,
        'Reading, PA': 340397,
        'Gulfport, MS': 271362,
        'Manchester, NH': 547089,
        'Fort Wayne, IN': 280715,
        'Flint, MI': 238276,
        'Anchorage, AK': 446621,
        'Peoria, IL': 212777,
        'Canton, OH': 259260,
        'Savannah, GA': 374944,
        'Naples, FL': 1083072,
        'Shreveport, LA': 289297,
        'Beaumont, TX': 284635,
        'Tallahassee, FL': 400426,
        'Eugene, OR': 527117,
        'Davenport, IA': 253406,
        'Ocala, FL': 354333,
        'Montgomery, AL': 278756,
        'Hickory, NC': 388019,
        'Trenton, NJ': 494007,
        'Ann Arbor, MI': 467456,
        'Fort Collins, CO': 606076,
        'Huntington, WV': 218725,
        'Lincoln, NE': 357319,
        'Rockford, IL': 227623,
        'Greeley, CO': 526904,
        'Gainesville, FL': 396898,
        'Boulder, CO': 897176,
        'Lubbock, TX': 336223,
        'Spartanburg, SC': 323172,
        'Green Bay, WI': 306521,
        'South Bend, IN': 277078,
        'Columbus, GA': 279245,
        'Evansville, IN': 285009,
        'Clarksville, TN': 362452,
        'Roanoke, VA': 328146,
        'Kingsport, TN': 307659,
        'Kennewick, WA': 465201,
        'Wilmington, NC': 540549,
        'Olympia, WA': 552035,
        'Hagerstown, MD': 356432,
        'Crestview, FL': 530201,
        'Duluth, MN': 289360,
        'Utica, NY': 214370,
        'Longview, TX': 326693,
        'San Luis Obispo, CA': 991839,
        'Merced, CA': 429588,
        'Laredo, TX': 287283,
        'Waco, TX': 386427,
        'Cedar Rapids, IA': 282452,
        'Sioux Falls, SD': 345422,
        'Bremerton, WA': 613580,
        'Santa Cruz, CA': 1395466,
        'Erie, PA': 223867,
        'College Station, TX': 357355,
        'Kalamazoo, MI': 301347,
        'Amarillo, TX': 323200,
        'Norwich, CT': 416137,
        'Lynchburg, VA': 336930,
        'Atlantic City, NJ': 414854,
        'Charleston, WV': 199390,
        'Tuscaloosa, AL': 332877,
        'Yakima, WA': 387319,
        'Fort Smith, AR': 274223,
        'Fargo, ND': 317743,
        'Appleton, WI': 310261,
        'Binghamton, NY': 198245,
        'Tyler, TX': 392182,
        'Lafayette, IN': 308627,
        'Bellingham, WA': 699798,
        'Topeka, KS': 263613,
        'Macon, GA': 263462,
        'Daphne, AL': 415831,
        'Hilton Head Island, SC': 708434,
        'Champaign, IL': 280667,
        'Rochester, MN': 339481,
        'Medford, OR': 539252,
        'Las Cruces, NM': 319615,
        'Burlington, VT': 529322,
        'Charlottesville, VA': 525000,
        'Yuma, AZ': 327531,
        'Lake Havasu City, AZ': 446281,
        'Athens, GA': 411400,
        'Barnstable Town, MA': 866178,
        'Chico, CA': 523648,
        'Lake Charles, LA': 274240,
        'Columbia, MO': 326902,
        'Houma, LA': 280334,
        'Gainesville, GA': 435554,
        'Elkhart, IN': 280165,
        'Springfield, IL': 263008,
        'Johnson City, TN': 353729,
        'Florence, SC': 287728,
        'Jacksonville, NC': 315325,
        'Hilo, HI': 760234,
        'St. Cloud, MN': 301194,
        'Bend, OR': 776681,
        'Monroe, LA': 246525,
        'Racine, WI': 297071,
        'Punta Gorda, FL': 476076,
        'Saginaw, MI': 194712,
        'Warner Robins, GA': 298742,
        'Terre Haute, IN': 212544,
        'St. George, UT': 586106,
        'Billings, MT': 404356,
        'Midland, TX': 406327,
        'Dover, DE': 388071,
        'Greenville, NC': 343384,
        'Bowling Green, KY': 352672,
        'El Centro, CA': 358766,
        'Joplin, MO': 259475,
        'Torrington, CT': 464538,
        'Jackson, TN': 309442,
        'Redding, CA': 463138,
        'Kingston, NY': 454822,
        'Yuba City, CA': 458483,
        'Iowa City, IA': 343342,
        'Muskegon, MI': 260905,
        'Abilene, TX': 315890,
        'Oshkosh, WI': 289686,
        'Burlington, NC': 361501,
        'Panama City, FL': 409489,
        'Bloomington, IL': 284458,
        "Coeur d'Alene, ID": 584922,
        'East Stroudsburg, PA': 341824,
        'Eau Claire, WI': 316224,
        'Pueblo, CO': 345983,
        'Hattiesburg, MS': 298522,
        'Bloomington, IN': 374448,
        'Waterloo, IA': 235015,
        'Kahului, HI': 1178748,
        'Odessa, TX': 304233,
        'Blacksburg, VA': 363785,
        'Auburn, AL': 363406,
        'Tupelo, MS': 289237,
        'Wausau, WI': 238640,
        'Janesville, WI': 269348,
        'Sebastian, FL': 516466,
        'State College, PA': 421799,
        'Madera, CA': 429059,
        'Jackson, MI': 250863,
        'Chambersburg, PA': 314713,
        'Grand Junction, CO': 475763,
        'Idaho Falls, ID': 364261,
        'Elizabethtown, KY': 296094,
        'Niles, MI': 324962,
        'Homosassa Springs, FL': 386081,
        'Decatur, AL': 313144,
        'Hanford, CA': 374510,
        'Concord, NH': 495505,
        'Wichita Falls, TX': 255299,
        'Santa Fe, NM': 638790,
        'Bangor, ME': 283296,
        'Traverse City, MI': 482417,
        'Alexandria, LA': 279736,
        'Monroe, MI': 284948,
        'Dothan, AL': 292060,
        'Jefferson City, MO': 269696,
        'Texarkana, TX': 292151,
        'Florence, AL': 289399,
        'Valdosta, GA': 288879,
        'London, KY': 215368,
        'Vineland, NJ': 297658,
        'Rocky Mount, NC': 252837,
        'Albany, GA': 250139,
        'Sioux City, IA': 238816,
        'Rapid City, SD': 365600,
        'Logan, UT': 419816,
        'Morristown, TN': 349275,
        'Dalton, GA': 296280,
        'Flagstaff, AZ': 742388,
        'Winchester, VA': 440134,
        'Lebanon, PA': 358947,
        'Pottsville, PA': 151932,
        'Morgantown, WV': 315860,
        'Sumter, SC': 265968,
        'The Villages, FL': 502676,
        'Sherman, TX': 393227,
        'Wheeling, WV': 186825,
        'La Crosse, WI': 299358,
        'Hammond, LA': 290892,
        'Napa, CA': 939762,
        'Harrisonburg, VA': 374289,
        'Jonesboro, AR': 283553,
        'Carbondale, IL': 203108,
        'Eureka, CA': 527341,
        'Springfield, OH': 229161,
        'Battle Creek, MI': 221226,
        'Albany, OR': 461333,
        'Mount Vernon, WA': 623546,
        'Manhattan, KS': 262431,
        'Lumberton, NC': 187317,
        'Bismarck, ND': 327700,
        'Johnstown, PA': 145087,
        'Sierra Vista, AZ': 320493,
        'Lawton, OK': 239974,
        'Jamestown, NY': 169161,
        'Cleveland, TN': 379831,
        'Pittsfield, MA': 427270,
        'Ames, IA': 281343,
        'Staunton, VA': 351581,
        'Glens Falls, NY': 306550,
        'Goldsboro, NC': 301051,
        'Farmington, NM': 298789,
        'New Bern, NC': 317363,
        'Augusta, ME': 308362,
        'San Angelo, TX': 323427,
        'St. Joseph, MO': 245213,
        'Lawrence, KS': 350420,
        'Missoula, MT': 611410,
        'Wenatchee, WA': 600895,
        'Altoona, PA': 204848,
        'Mansfield, OH': 222683,
        'Owensboro, KY': 284330,
        'Brunswick, GA': 444737,
        'Holland, MI': 332141,
        'Bozeman, MT': 738867,
        'Wooster, OH': 436318,
        'Cookeville, TN': 383856,
        'Sheboygan, WI': 232239,
        'Weirton, WV': 146318,
        'Beckley, WV': 177403,
        'California, MD': 435275,
        'Anniston, AL': 233009,
        'Muncie, IN': 195129,
        'Williamsport, PA': 242556,
        'Twin Falls, ID': 387841,
        'Show Low, AZ': 507537,
        'Longview, WA': 449450,
        'Roseburg, OR': 414411,
        'Michigan City, IN': 283440,
        'Kankakee, IL': 254031,
        'Lewiston, ME': 307216,
        'Richmond, KY': 304979,
        'Watertown, NY': 206605,
        'Ogdensburg, NY': 141973,
        'Sebring, FL': 336438,
        'Tullahoma, TN': 383665,
        'Kalispell, MT': 766475,
        'Bluefield, WV': 164399,
        'Whitewater, WI': 404776,
        'Pinehurst, NC': 482450,
        'LaGrange, GA': 287661,
        'Decatur, IL': 174036,
        'Fond du Lac, WI': 239348,
        'Gettysburg, PA': 348521,
        'Mankato, MN': 300361,
        'Bay City, MI': 183740,
        'Gadsden, AL': 274252,
        'Lima, OH': 210770,
        'Salem, OH': 182291,
        'Ithaca, NY': 376199,
        'Cheyenne, WY': 373660,
        'Grand Forks, ND': 265592,
        'Hot Springs, AR': 382883,
        'Danville, VA': 217872,
        'Truckee, CA': 860788,
        'Victoria, TX': 319191,
        'Moses Lake, WA': 401962,
        'Sevierville, TN': 603564,
        'Shelby, NC': 317946,
        'Rome, GA': 314223,
        'Meridian, MS': 221741,
        'Adrian, MI': 241591,
        'Dubuque, IA': 300170,
        'Cape Girardeau, MO': 263592,
        'Albertville, AL': 308333,
        'Cumberland, MD': 184917,
        'Ashtabula, OH': 185270,
        'Pocatello, ID': 320744,
        'Paducah, KY': 273660,
        'Fairbanks, AK': 368888,
        'Brainerd, MN': 356566,
        'Corning, NY': 168804,
        'Corvallis, OR': 576037,
        'Clarksburg, WV': 228288,
        'New Philadelphia, OH': 232388,
        'Ocean City, NJ': 867491,
        'Sunbury, PA': 182679,
        'Hermiston, OR': 353914,
        'Parkersburg, WV': 217264,
        'Grants Pass, OR': 511360,
        'Beaver Dam, WI': 266546,
        'Lufkin, TX': 301843,
        'Pine Bluff, AR': 199379,
        'Ukiah, CA': 589984,
        'Zanesville, OH': 229858,
        'Oak Harbor, WA': 618371,
        'Russellville, AR': 273287,
        'Orangeburg, SC': 222506,
        'New Castle, PA': 191734,
        'Watertown, WI': 341061,
        'Cullman, AL': 315775,
        'Columbus, IN': 333800,
        'Laurel, MS': 246035,
        'Athens, TX': 437881,
        'Meadville, PA': 184747,
        'Indiana, PA': 179175,
        'Midland, MI': 274268,
        'Hinesville, GA': 263381,
        'Bloomsburg, PA': 301328,
        'Kokomo, IN': 217842,
        'Elmira, NY': 187063,
        'Helena, MT': 474060,
        'Centralia, WA': 461407,
        'Wilson, NC': 305990,
        'Stillwater, OK': 314357,
        'Opelousas, LA': 249460,
        'Great Falls, MT': 307346,
        'Statesboro, GA': 285511,
        'Casper, WY': 321033,
        'Seneca, SC': 501020,
        'Talladega, AL': 272117,
        'Plattsburgh, NY': 227333,
        'Warsaw, IN': 319990,
        'Manitowoc, WI': 213620,
        'Searcy, AR': 271733,
        'DuBois, PA': 175288,
        'Glenwood Springs, CO': 1116433,
        'Port Angeles, WA': 488937,
        'Heber, UT': 940566,
        'Minot, ND': 283782,
        'Chillicothe, OH': 257738,
        'Keene, NH': 379649,
        'Jefferson, GA': 398858,
        'Auburn, NY': 204007,
        'Aberdeen, WA': 368174,
        'Olean, NY': 150623,
        'Findlay, OH': 265489,
        'Grand Island, NE': 267057,
        'Danville, IL': 129770,
        'Palatka, FL': 297633,
        'Quincy, IL': 213250,
        'Portsmouth, OH': 166873,
        'Frankfort, KY': 276952,
        'Key West, FL': 1727358,
        'Sandusky, OH': 258490,
        'Shawnee, OK': 244238,
        'Somerset, PA': 171762,
        'Lake City, FL': 342068,
        'Wisconsin Rapids, WI': 223798,
        'Huntsville, TX': 335945,
        'Kapaa, HI': 1031437,
        'Hobbs, NM': 268478,
        'Mount Airy, NC': 290955,
        'Greenwood, SC': 303155,
        'Stevens Point, WI': 270903,
        'Gallup, NM': 278397,
        'Greeneville, TN': 291624,
        'Morehead City, NC': 615410,
        'Mount Pleasant, MI': 229739,
        'Klamath Falls, OR': 375496,
        'Roanoke Rapids, NC': 192619,
        'Shelton, WA': 495154,
        'North Wilkesboro, NC': 287166,
        'Alamogordo, NM': 302586,
        'Muskogee, OK': 216684,
        'Faribault, MN': 357630,
        'Forest City, NC': 321322,
        'Farmington, MO': 248487,
        'Marquette, MI': 267893,
        'Richmond, IN': 191063,
        'Somerset, KY': 289345,
        'Athens, OH': 229979,
        'Marion, IN': 184080,
        'Marion, OH': 211308,
        'Nacogdoches, TX': 318391,
        'Roswell, NM': 292043,
        'Coos Bay, OR': 409966,
        'Red Bluff, CA': 399097,
        'Clearlake, CA': 435311,
        'Baraboo, WI': 326306,
        'Rio Grande City, TX': 205801,
        'Dublin, GA': 273422,
        'Lewiston, ID': 373423,
        'Georgetown, SC': 569816,
        'Albemarle, NC': 371330,
        'Marinette, WI': 206555,
        'Martinsville, VA': 200628,
        'Mount Vernon, OH': 302589,
        'Sanford, NC': 329290,
        'Hutchinson, KS': 200072,
        'Crossville, TN': 418627,
        'Laconia, NH': 547667,
        'Walla Walla, WA': 463675,
        'Charleston, IL': 169287,
        'Gillette, WY': 317568,
        'Enid, OK': 234371,
        'Sturgis, MI': 209713,
        'Sayre, PA': 193780,
        'Marietta, OH': 224584,
        'Salina, KS': 226100,
        'Hudson, NY': 491108,
        'Starkville, MS': 309991,
        'Calhoun, GA': 303829,
        'Fergus Falls, MN': 312515,
        'Oneonta, NY': 224609,
        'Ardmore, OK': 279146,
        'Carlsbad, NM': 346247,
        'Fremont, OH': 179144,
        'Barre, VT': 390189,
        'Fernley, NV': 436822,
        'Columbus, MS': 274437,
        'Cullowhee, NC': 775171,
        'Norwalk, OH': 182923,
        'Palestine, TX': 289830,
        'Rutland, VT': 321061,
        'Fort Madison, IA': 147630,
        'Gaffney, SC': 264169,
        'Batavia, NY': 193173,
        'Cedar City, UT': 429105,
        'Kearney, NE': 280226,
        'Durango, CO': 827922,
        'Boone, NC': 628073,
        'Point Pleasant, WV': 177129,
        'Branson, MO': 339129,
        'Carson City, NV': 539963,
        'Fairmont, WV': 212056,
        'Picayune, MS': 264086,
        'Ontario, OR': 384711,
        'Kinston, NC': 222996,
        'Poplar Bluff, MO': 220532,
        'St. Marys, GA': 324899,
        'Waycross, GA': 236738,
        'Batesville, AR': 228588,
        'Elko, NV': 371630,
        'Tiffin, OH': 174157,
        'Edwards, CO': 1797070,
        'Jasper, IN': 249902,
        'Danville, KY': 267178,
        'Sterling, IL': 155395,
        'Sonora, CA': 466260,
        'Oxford, MS': 424073,
        'Glasgow, KY': 227126,
        'Payson, AZ': 554742,
        'Warrensburg, MO': 298914,
        'Athens, TN': 318008,
        'Elizabeth City, NC': 308584,
        'Milledgeville, GA': 280117,
        'Rexburg, ID': 434510,
        'Ashland, OH': 251566,
        'Enterprise, AL': 305060,
        'Jacksonville, TX': 371905,
        'Kerrville, TX': 555279,
        'Gloversville, NY': 210310,
        'Fort Leonard Wood, MO': 228932,
        'Bartlesville, OK': 266726,
        'Scottsboro, AL': 314401,
        'Alice, TX': 277778,
        'Greenville, OH': 233891,
        'Platteville, WI': 212442,
        'Corsicana, TX': 319584,
        'Newport, OR': 636507,
        'Winona, MN': 277319,
        'Oil City, PA': 129104,
        'Rochelle, IL': 226633,
        'Shelbyville, TN': 364575,
        'Malone, NY': 171709,
        'Paris, TX': 329148,
        'Pullman, WA': 402466,
        'Mason City, IA': 219303,
        'Ellensburg, WA': 616232,
        'Natchez, MS': 247106,
        'Amsterdam, NY': 183207,
        'Gardnerville Ranchos, NV': 845944,
        'Galesburg, IL': 143615,
        'Del Rio, TX': 315224,
        'Tahlequah, OK': 253657,
        'Durant, OK': 237076,
        'Ozark, AL': 230719,
        'Cadillac, MI': 247348,
        'Clovis, NM': 271393,
        'Sidney, OH': 249987,
        'Morgan City, LA': 213427,
        'Montrose, CO': 535438,
        'Pahrump, NV': 405408,
        'New Castle, IN': 192084,
        'Fort Polk South, LA': 256133,
        'Norfolk, NE': 260363,
        'Cañon City, CO': 382517,
        'Kendallville, IN': 252882,
        'Bemidji, MN': 286424,
        'Blackfoot, ID': 329657,
        'Cortland, NY': 186640,
        'Mount Sterling, KY': 249743,
        'Washington, NC': 325367,
        'Sandpoint, ID': 703092,
        'Nogales, AZ': 322769,
        'Ruston, LA': 322518,
        'Bardstown, KY': 325190,
        'Clinton, IA': 206793,
        'Red Wing, MN': 345173,
        'Plymouth, IN': 259285,
        'Lewistown, PA': 187500,
        'Cornelia, GA': 357314,
        'Mount Pleasant, TX': 343572,
        'Marion, NC': 366098,
        'Bogalusa, LA': 215700,
        'Wapakoneta, OH': 236453,
        'Hillsdale, MI': 222314,
        'Paragould, AR': 249836,
        'Moultrie, GA': 257324,
        'Bedford, IN': 242454,
        'Burley, ID': 335714,
        'Menomonie, WI': 304006,
        'Shawano, WI': 264606,
        'Bellefontaine, OH': 251881,
        'Burlington, IA': 171673,
        'Harrison, AR': 268007,
        'Vicksburg, MS': 266422,
        'Henderson, NC': 282556,
        'Madisonville, KY': 242124,
        'Huntingdon, PA': 184779,
        'Lawrenceburg, TN': 283322,
        'Rolla, MO': 256282,
        'Thomasville, GA': 327613,
        'Rockingham, NC': 248628,
        'Lewisburg, PA': 335740,
        'Seymour, IN': 259592,
        'Big Rapids, MI': 243310,
        'Freeport, IL': 183577,
        'McAlester, OK': 240753,
        'Auburn, IN': 250209,
        'Coldwater, MI': 202763,
        'Ponca City, OK': 197777,
        'Stephenville, TX': 396391,
        'Willmar, MN': 265843,
        'Duncan, OK': 250642,
        'Cedartown, GA': 276868,
        'Clewiston, FL': 300140,
        'Rock Springs, WY': 290428,
        'Aberdeen, SD': 246633,
        'Sedalia, MO': 204225,
        'Muscatine, IA': 236883,
        'Okeechobee, FL': 330100,
        'Mountain Home, AR': 328429,
        'Wilmington, OH': 267006,
        'El Campo, TX': 301686,
        'McMinnville, TN': 319447,
        'Gainesville, TX': 477259,
        'Bucyrus, OH': 161102,
        'Celina, OH': 257756,
        'Big Stone Gap, VA': 168754,
        'Moscow, ID': 460770,
        'Tifton, GA': 305753,
        'Astoria, OR': 594484,
        'Bradford, PA': 129624,
        'Alma, MI': 178277,
        'West Plains, MO': 257141,
        'Austin, MN': 241335,
        'Blytheville, AR': 187101,
        'Garden City, KS': 252946,
        'Marshalltown, IA': 181724,
        'Riverton, WY': 349467,
        'Murray, KY': 265301,
        'Safford, AZ': 306946,
        'McComb, MS': 216643,
        'Urbana, OH': 249585,
        'Laramie, WY': 376241,
        'Warren, PA': 147749,
        'Cambridge, OH': 192405,
        'Pittsburg, KS': 192581,
        'Hannibal, MO': 233208,
        'Williston, ND': 332389,
        'Arcadia, FL': 353194,
        'Newberry, SC': 371244,
        'Ada, OK': 256765,
        'Crawfordsville, IN': 239026,
        'Alexandria, MN': 347743,
        'Sikeston, MO': 197355,
        'El Dorado, AR': 261167,
        'Lock Haven, PA': 196710,
        'Defiance, OH': 186899,
        'Brownwood, TX': 303351,
        'Greenwood, MS': 198251,
        'Kill Devil Hills, NC': 647620,
        'Logansport, IN': 155066,
        'Scottsbluff, NE': 207151,
        'Houghton, MI': 199687,
        'Sulphur Springs, TX': 324462,
        'Easton, MD': 592075,
        'Sault Ste. Marie, MI': 206453,
        'Corinth, MS': 242422,
        'Mayfield, KY': 223722,
        'Bay City, TX': 283012,
        'Campbellsville, KY': 205776,
        'Owatonna, MN': 280965,
        'Big Spring, TX': 255563,
        'Vincennes, IN': 209246,
        'Coshocton, OH': 201467,
        'Huntington, IN': 213557,
        'Newport, TN': 287847,
        'Fremont, NE': 251025,
        'Selma, AL': 173932,
        'Jackson, WY': 1707604,
        'Vidalia, GA': 277923,
        'Vernal, UT': 311291,
        'Lebanon, MO': 260628,
        'Decatur, IN': 228336,
        'Brenham, TX': 494415,
        'Hutchinson, MN': 284109,
        'Emporia, KS': 209002,
        'Escanaba, MI': 177519,
        'Brookings, SD': 279498,
        'North Platte, NE': 225367,
        'Pontiac, IL': 173808,
        'Bennington, VT': 462833,
        'Peru, IN': 156798,
        'Butte, MT': 336996,
        'Lewisburg, TN': 389956,
        'Ottumwa, IA': 164047,
        'Angola, IN': 379488,
        'Laurinburg, NC': 233078,
        'Brevard, NC': 639991,
        'Americus, GA': 206639,
        'Effingham, IL': 254785,
        'Seneca Falls, NY': 202564,
        'Brookhaven, MS': 305785,
        'Malvern, AR': 244488,
        'Dixon, IL': 182634,
        'Washington, IN': 240949,
        'Dayton, TN': 324411,
        'Columbus, NE': 278597,
        'Dodge City, KS': 204919,
        'Dickinson, ND': 287703,
        'Plainview, TX': 194490,
        'Taos, NM': 552455,
        'Jackson, OH': 194415,
        'Frankfort, IN': 217529,
        'Madison, IN': 266781,
        'Taylorville, IL': 140654,
        'Cambridge, MD': 325326,
        'Juneau, AK': 563533,
        'Coffeyville, KS': 138808,
        'Hastings, NE': 227676,
        'Berlin, NH': 254118,
        'Miami, OK': 201056,
        'Sheridan, WY': 493374,
        'Wabash, IN': 187330,
        'Kingsville, TX': 225926,
        'Breckenridge, CO': 1728502,
        'Albert Lea, MN': 216119,
        'Cleveland, MS': 314136,
        'Union City, TN': 229141,
        'Jesup, GA': 279512,
        'Susanville, CA': 309026,
        'Kirksville, MO': 218653,
        'Iron Mountain, MI': 184373,
        'Mineral Wells, TX': 485730,
        'Macomb, IL': 121193,
        'Ludington, MI': 272599,
        'Fort Morgan, CO': 361296,
        'Hays, KS': 228487,
        'Weatherford, OK': 209136,
        'Washington Court House, OH': 237097,
        'McPherson, KS': 251914,
        'Elkins, WV': 161719,
        'Camden, AR': 192779,
        'Alpena, MI': 184154,
        'Van Wert, OH': 169917,
        'North Vernon, IN': 231640,
        'Mountain Home, ID': 365043,
        'Silver City, NM': 284834,
        'Fredericksburg, TX': 714374,
        'Wauchula, FL': 267944,
        'Greensburg, IN': 275508,
        'La Grande, OR': 348581,
        'Thomaston, GA': 276260,
        'The Dalles, OR': 430426,
        'Grants, NM': 220544,
        'Spearfish, SD': 444269,
        'Toccoa, GA': 313715,
        'Ottawa, KS': 259451,
        'Great Bend, KS': 154053,
        'Steamboat Springs, CO': 1527098,
        'Lexington, NE': 208652,
        'Middlesborough, KY': 159018,
        'Fallon, NV': 400076,
        'Marshall, MN': 216909,
        'Prineville, OR': 558335,
        'New Ulm, MN': 218418,
        'Summerville, GA': 266405,
        'Mexico, MO': 183082,
        'Indianola, MS': 110227,
        'Hailey, ID': 1610764,
        'Moberly, MO': 201552,
        'Altus, OK': 240843,
        'Woodward, OK': 203768,
        'Brookings, OR': 598098,
        'Mitchell, SD': 250162,
        'Hood River, OR': 751740,
        'Connersville, IN': 179651,
        'Pampa, TX': 190448,
        'Oskaloosa, IA': 201160,
        'Wahpeton, ND': 225095,
        'Arkadelphia, AR': 220717,
        'Cordele, GA': 267421,
        'Sterling, CO': 296459,
        'Maryville, MO': 230918,
        'Clarksdale, MS': 91570,
        'Elk City, OK': 236422,
        'Beatrice, NE': 225045,
        'Worthington, MN': 255271,
        'Liberal, KS': 171129,
        'Port Lavaca, TX': 314402,
        'Borger, TX': 185525,
        'Grenada, MS': 253678,
        'Jamestown, ND': 249823,
        'Pierre, SD': 282269,
        'Evanston, WY': 337234,
        'Othello, WA': 314206,
        'Guymon, OK': 224105,
        'Storm Lake, IA': 204051,
        'Parsons, KS': 120231,
        'Los Alamos, NM': 564231,
        'Andrews, TX': 340195,
        'Portales, NM': 217404,
        'Fairfield, IA': 205403,
        'Spirit Lake, IA': 436850,
        'Vineyard Haven, MA': 1714444,
        'Maysville, KY': 234408,
        'Winnemucca, NV': 398503,
        'Snyder, TX': 225127,
        'Fitzgerald, GA': 204564,
        'Atchison, KS': 192394,
        'Spencer, IA': 200778,
        'Vermillion, SD': 259803,
        'Ketchikan, AK': 468977,
        'Craig, CO': 316276,
    },
    '5_BED': {
        'New York, NY': 972332,
        'Los Angeles, CA': 1472534,
        'Chicago, IL': 524537,
        'Dallas, TX': 674710,
        'Houston, TX': 534372,
        'Washington, DC': 846323,
        'Miami, FL': 1069405,
        'Philadelphia, PA': 595962,
        'Atlanta, GA': 585638,
        'Phoenix, AZ': 690837,
        'Boston, MA': 1098579,
        'San Francisco, CA': 1743408,
        'Riverside, CA': 737027,
        'Detroit, MI': 452591,
        'Seattle, WA': 1039182,
        'Minneapolis, MN': 540629,
        'San Diego, CA': 1352501,
        'Tampa, FL': 635199,
        'Denver, CO': 805130,
        'St. Louis, MO': 464498,
        'Baltimore, MD': 663137,
        'Charlotte, NC': 634306,
        'Orlando, FL': 648972,
        'San Antonio, TX': 477761,
        'Portland, OR': 756617,
        'Sacramento, CA': 783366,
        'Las Vegas, NV': 596935,
        'Pittsburgh, PA': 410433,
        'Austin, TX': 823633,
        'Cincinnati, OH': 487660,
        'Kansas City, MO': 524722,
        'Columbus, OH': 549875,
        'Indianapolis, IN': 517473,
        'Cleveland, OH': 361465,
        'San Jose, CA': 2198914,
        'Nashville, TN': 905325,
        'Virginia Beach, VA': 576127,
        'Providence, RI': 650191,
        'Jacksonville, FL': 628144,
        'Milwaukee, WI': 371639,
        'Oklahoma City, OK': 472008,
        'Raleigh, NC': 716958,
        'Memphis, TN': 471876,
        'Richmond, VA': 505700,
        'New Orleans, LA': 512854,
        'Louisville, KY': 508348,
        'Salt Lake City, UT': 675612,
        'Hartford, CT': 514118,
        'Buffalo, NY': 310861,
        'Birmingham, AL': 541626,
        'Grand Rapids, MI': 465173,
        'Rochester, NY': 319256,
        'Tucson, AZ': 535444,
        'Tulsa, OK': 448495,
        'Fresno, CA': 571499,
        'Urban Honolulu, HI': 1255095,
        'Omaha, NE': 454855,
        'Worcester, MA': 546610,
        'Bridgeport, CT': 1661876,
        'Greenville, SC': 523204,
        'Albuquerque, NM': 478915,
        'Bakersfield, CA': 484018,
        'Albany, NY': 388553,
        'Knoxville, TN': 630883,
        'McAllen, TX': 378419,
        'Baton Rouge, LA': 465682,
        'North Port, FL': 900323,
        'New Haven, CT': 511463,
        'Columbia, SC': 422920,
        'Allentown, PA': 359211,
        'El Paso, TX': 357924,
        'Oxnard, CA': 1115101,
        'Charleston, SC': 715659,
        'Cape Coral, FL': 744835,
        'Greensboro, NC': 464790,
        'Boise City, ID': 662605,
        'Stockton, CA': 711956,
        'Colorado Springs, CO': 604690,
        'Little Rock, AR': 454587,
        'Lakeland, FL': 470964,
        'Des Moines, IA': 471303,
        'Akron, OH': 356530,
        'Springfield, MA': 422057,
        'Ogden, UT': 603900,
        'Deltona, FL': 544139,
        'Winston, NC': 474460,
        'Madison, WI': 588258,
        'Provo, UT': 640302,
        'Durham, NC': 741623,
        'Syracuse, NY': 289585,
        'Wichita, KS': 363074,
        'Toledo, OH': 303075,
        'Augusta, GA': 420589,
        'Palm Bay, FL': 674375,
        'Jackson, MS': 469151,
        'Harrisburg, PA': 334841,
        'Spokane, WA': 556078,
        'Chattanooga, TN': 550813,
        'Scranton, PA': 257155,
        'Modesto, CA': 581124,
        'Fayetteville, AR': 615014,
        'Lansing, MI': 348764,
        'Lancaster, PA': 520523,
        'Portland, ME': 785060,
        'Youngstown, OH': 234359,
        'Fayetteville, NC': 383871,
        'Lexington, KY': 510693,
        'Myrtle Beach, SC': 662135,
        'Pensacola, FL': 547746,
        'Port St. Lucie, FL': 710781,
        'Santa Rosa, CA': 1077414,
        'Lafayette, LA': 434836,
        'Huntsville, AL': 521566,
        'Reno, NV': 801257,
        'Springfield, MO': 431874,
        'Visalia, CA': 488012,
        'Killeen, TX': 359130,
        'Asheville, NC': 789347,
        'York, PA': 310551,
        'Vallejo, CA': 756904,
        'Santa Maria, CA': 1596104,
        'Salem, OR': 548451,
        'Salinas, CA': 906232,
        'Corpus Christi, TX': 486792,
        'Mobile, AL': 371360,
        'Brownsville, TX': 354490,
        'Salisbury, MD': 826427,
        'Reading, PA': 194903,
        'Gulfport, MS': 380681,
        'Manchester, NH': 591489,
        'Fort Wayne, IN': 397636,
        'Flint, MI': 273433,
        'Anchorage, AK': 542705,
        'Peoria, IL': 294264,
        'Canton, OH': 330462,
        'Savannah, GA': 458837,
        'Naples, FL': 1829573,
        'Shreveport, LA': 439775,
        'Beaumont, TX': 358136,
        'Tallahassee, FL': 565101,
        'Eugene, OR': 582664,
        'Davenport, IA': 360043,
        'Ocala, FL': 490043,
        'Montgomery, AL': 433821,
        'Hickory, NC': 490537,
        'Trenton, NJ': 783133,
        'Ann Arbor, MI': 607745,
        'Fort Collins, CO': 725427,
        'Huntington, WV': 302562,
        'Lincoln, NE': 443879,
        'Rockford, IL': 263252,
        'Greeley, CO': 603085,
        'Gainesville, FL': 570883,
        'Boulder, CO': 1128813,
        'Lubbock, TX': 499173,
        'Spartanburg, SC': 403210,
        'Green Bay, WI': 379153,
        'South Bend, IN': 370160,
        'Columbus, GA': 381873,
        'Evansville, IN': 371358,
        'Clarksville, TN': 409403,
        'Roanoke, VA': 473367,
        'Kingsport, TN': 422240,
        'Kennewick, WA': 539436,
        'Wilmington, NC': 767808,
        'Olympia, WA': 608956,
        'Hagerstown, MD': 420280,
        'Crestview, FL': 1393494,
        'Duluth, MN': 357672,
        'Utica, NY': 239321,
        'Longview, TX': 424877,
        'San Luis Obispo, CA': 1253763,
        'Merced, CA': 508134,
        'Waco, TX': 506431,
        'Cedar Rapids, IA': 379104,
        'Sioux Falls, SD': 508863,
        'Bremerton, WA': 658146,
        'Santa Cruz, CA': 1636600,
        'Erie, PA': 258470,
        'College Station, TX': 493363,
        'Kalamazoo, MI': 411326,
        'Amarillo, TX': 423247,
        'Norwich, CT': 512719,
        'Lynchburg, VA': 446891,
        'Atlantic City, NJ': 763027,
        'Charleston, WV': 288235,
        'Tuscaloosa, AL': 470275,
        'Yakima, WA': 436896,
        'Fort Smith, AR': 362431,
        'Fargo, ND': 443523,
        'Appleton, WI': 367817,
        'Binghamton, NY': 211033,
        'Tyler, TX': 611165,
        'Lafayette, IN': 403373,
        'Bellingham, WA': 786098,
        'Topeka, KS': 352006,
        'Macon, GA': 374760,
        'Daphne, AL': 588259,
        'Hilton Head Island, SC': 1254124,
        'Champaign, IL': 370877,
        'Rochester, MN': 480137,
        'Medford, OR': 649663,
        'Las Cruces, NM': 405817,
        'Burlington, VT': 553069,
        'Charlottesville, VA': 720705,
        'Yuma, AZ': 333576,
        'Lake Havasu City, AZ': 632357,
        'Athens, GA': 578319,
        'Barnstable Town, MA': 1425872,
        'Chico, CA': 543964,
        'Columbia, MO': 462432,
        'Gainesville, GA': 573013,
        'Elkhart, IN': 395450,
        'Springfield, IL': 364297,
        'Johnson City, TN': 521147,
        'Florence, SC': 357106,
        'Jacksonville, NC': 429091,
        'Hilo, HI': 922798,
        'St. Cloud, MN': 364593,
        'Bend, OR': 1077725,
        'Monroe, LA': 349629,
        'Racine, WI': 243637,
        'Punta Gorda, FL': 652962,
        'Saginaw, MI': 225383,
        'Warner Robins, GA': 389405,
        'Terre Haute, IN': 241506,
        'St. George, UT': 715692,
        'Billings, MT': 504149,
        'Midland, TX': 592223,
        'Dover, DE': 426504,
        'Greenville, NC': 416354,
        'Bowling Green, KY': 447598,
        'Joplin, MO': 369192,
        'Torrington, CT': 643441,
        'Jackson, TN': 405334,
        'Redding, CA': 565008,
        'Kingston, NY': 495765,
        'Yuba City, CA': 524387,
        'Iowa City, IA': 465568,
        'Muskegon, MI': 320682,
        'Abilene, TX': 453020,
        'Oshkosh, WI': 328560,
        'Burlington, NC': 450841,
        'Panama City, FL': 547015,
        'Bloomington, IL': 383537,
        "Coeur d'Alene, ID": 686708,
        'East Stroudsburg, PA': 375302,
        'Eau Claire, WI': 373171,
        'Pueblo, CO': 426876,
        'Hattiesburg, MS': 198081,
        'Bloomington, IN': 484872,
        'Waterloo, IA': 346595,
        'Kahului, HI': 1268903,
        'Odessa, TX': 380382,
        'Blacksburg, VA': 471351,
        'Auburn, AL': 487437,
        'Tupelo, MS': 393033,
        'Wausau, WI': 292917,
        'Janesville, WI': 305340,
        'Sebastian, FL': 882334,
        'State College, PA': 499224,
        'Madera, CA': 499586,
        'Jackson, MI': 293944,
        'Chambersburg, PA': 361188,
        'Grand Junction, CO': 585642,
        'Idaho Falls, ID': 477687,
        'Elizabethtown, KY': 370230,
        'Niles, MI': 450053,
        'Homosassa Springs, FL': 514604,
        'Decatur, AL': 404214,
        'Hanford, CA': 458017,
        'Concord, NH': 577423,
        'Wichita Falls, TX': 345207,
        'Santa Fe, NM': 978373,
        'Bangor, ME': 302709,
        'Traverse City, MI': 634833,
        'Alexandria, LA': 360375,
        'Monroe, MI': 308225,
        'Dothan, AL': 435648,
        'Jefferson City, MO': 343172,
        'Florence, AL': 381572,
        'Valdosta, GA': 421162,
        'London, KY': 287510,
        'Vineland, NJ': 297356,
        'Rocky Mount, NC': 299499,
        'Albany, GA': 341862,
        'Sioux City, IA': 349246,
        'Rapid City, SD': 473634,
        'Logan, UT': 519729,
        'Morristown, TN': 464853,
        'Dalton, GA': 371988,
        'Flagstaff, AZ': 929769,
        'Winchester, VA': 520189,
        'Lebanon, PA': 386445,
        'Pottsville, PA': 109946,
        'Morgantown, WV': 426740,
        'Sumter, SC': 312274,
        'The Villages, FL': 472584,
        'Sherman, TX': 533599,
        'Wheeling, WV': 252698,
        'La Crosse, WI': 358412,
        'Hammond, LA': 384427,
        'Napa, CA': 989001,
        'Harrisonburg, VA': 477215,
        'Jonesboro, AR': 423622,
        'Eureka, CA': 565909,
        'Springfield, OH': 270318,
        'Battle Creek, MI': 273789,
        'Albany, OR': 525473,
        'Mount Vernon, WA': 698625,
        'Manhattan, KS': 339777,
        'Lumberton, NC': 229982,
        'Bismarck, ND': 434833,
        'Sierra Vista, AZ': 403337,
        'Lawton, OK': 314312,
        'Jamestown, NY': 229460,
        'Cleveland, TN': 486790,
        'Pittsfield, MA': 616714,
        'Ames, IA': 370488,
        'Staunton, VA': 445103,
        'Glens Falls, NY': 365228,
        'Goldsboro, NC': 334455,
        'Farmington, NM': 355830,
        'New Bern, NC': 394226,
        'Augusta, ME': 349889,
        'St. Joseph, MO': 310726,
        'Lawrence, KS': 478733,
        'Missoula, MT': 714866,
        'Wenatchee, WA': 696516,
        'Altoona, PA': 259795,
        'Mansfield, OH': 289295,
        'Owensboro, KY': 379772,
        'Brunswick, GA': 905493,
        'Holland, MI': 429248,
        'Bozeman, MT': 880855,
        'Wooster, OH': 541315,
        'Cookeville, TN': 508305,
        'Sheboygan, WI': 202585,
        'Weirton, WV': 178206,
        'Beckley, WV': 234966,
        'California, MD': 518455,
        'Anniston, AL': 340136,
        'Muncie, IN': 224155,
        'Williamsport, PA': 271467,
        'Twin Falls, ID': 471748,
        'Show Low, AZ': 626336,
        'Longview, WA': 494564,
        'Roseburg, OR': 476069,
        'Michigan City, IN': 380754,
        'Kankakee, IL': 312957,
        'Lewiston, ME': 329776,
        'Richmond, KY': 404463,
        'Watertown, NY': 238590,
        'Ogdensburg, NY': 160002,
        'Sebring, FL': 469306,
        'Tullahoma, TN': 490308,
        'Kalispell, MT': 960167,
        'Bluefield, WV': 206210,
        'Whitewater, WI': 615175,
        'Pinehurst, NC': 578184,
        'LaGrange, GA': 371211,
        'Decatur, IL': 244693,
        'Fond du Lac, WI': 267254,
        'Gettysburg, PA': 397894,
        'Mankato, MN': 373026,
        'Bay City, MI': 205784,
        'Gadsden, AL': 356684,
        'Lima, OH': 258630,
        'Salem, OH': 217062,
        'Ithaca, NY': 438182,
        'Grand Forks, ND': 346782,
        'Hot Springs, AR': 535199,
        'Danville, VA': 309752,
        'Truckee, CA': 1019493,
        'Victoria, TX': 421317,
        'Moses Lake, WA': 476566,
        'Sevierville, TN': 960671,
        'Shelby, NC': 387733,
        'Rome, GA': 131127,
        'Meridian, MS': 311514,
        'Adrian, MI': 286248,
        'Dubuque, IA': 392476,
        'Cape Girardeau, MO': 376242,
        'Albertville, AL': 442738,
        'Cumberland, MD': 205834,
        'Ashtabula, OH': 232830,
        'Pocatello, ID': 413910,
        'Paducah, KY': 364861,
        'Fairbanks, AK': 413456,
        'Brainerd, MN': 442121,
        'Corning, NY': 200892,
        'Corvallis, OR': 629342,
        'Clarksburg, WV': 293438,
        'New Philadelphia, OH': 310233,
        'Ocean City, NJ': 1594004,
        'Hermiston, OR': 388931,
        'Parkersburg, WV': 290156,
        'Grants Pass, OR': 590477,
        'Beaver Dam, WI': 307841,
        'Pine Bluff, AR': 275971,
        'Zanesville, OH': 288852,
        'Oak Harbor, WA': 730644,
        'Russellville, AR': 351087,
        'Orangeburg, SC': 266811,
        'New Castle, PA': 192249,
        'Watertown, WI': 390853,
        'Cullman, AL': 446044,
        'Columbus, IN': 454598,
        'Athens, TX': 798024,
        'Meadville, PA': 219371,
        'Indiana, PA': 213470,
        'Midland, MI': 322166,
        'Hinesville, GA': 321083,
        'Bloomsburg, PA': 352615,
        'Kokomo, IN': 265973,
        'Elmira, NY': 227393,
        'Helena, MT': 569162,
        'Centralia, WA': 522162,
        'Wilson, NC': 358054,
        'Stillwater, OK': 457440,
        'Great Falls, MT': 397549,
        'Statesboro, GA': 385984,
        'Casper, WY': 406429,
        'Seneca, SC': 845620,
        'Talladega, AL': 384735,
        'Plattsburgh, NY': 239728,
        'Warsaw, IN': 435584,
        'Manitowoc, WI': 240030,
        'Searcy, AR': 354164,
        'Glenwood Springs, CO': 4443910,
        'Port Angeles, WA': 543592,
        'Heber, UT': 1092083,
        'Minot, ND': 364251,
        'Chillicothe, OH': 312594,
        'Keene, NH': 486032,
        'Jefferson, GA': 488461,
        'Auburn, NY': 231173,
        'Aberdeen, WA': 397451,
        'Olean, NY': 184693,
        'Findlay, OH': 329910,
        'Grand Island, NE': 332767,
        'Palatka, FL': 386403,
        'Quincy, IL': 325321,
        'Portsmouth, OH': 226558,
        'Frankfort, KY': 342230,
        'Key West, FL': 2538986,
        'Sandusky, OH': 311788,
        'Shawnee, OK': 265444,
        'Somerset, PA': 220852,
        'Lake City, FL': 420739,
        'Huntsville, TX': 456948,
        'Kapaa, HI': 1186596,
        'Hobbs, NM': 325651,
        'Mount Airy, NC': 368505,
        'Greenwood, SC': 412636,
        'Stevens Point, WI': 287611,
        'Greeneville, TN': 388373,
        'Morehead City, NC': 1046909,
        'Mount Pleasant, MI': 245529,
        'Klamath Falls, OR': 424434,
        'Roanoke Rapids, NC': 250265,
        'Shelton, WA': 571809,
        'North Wilkesboro, NC': 331808,
        'Alamogordo, NM': 328374,
        'Muskogee, OK': 255483,
        'Faribault, MN': 402433,
        'Forest City, NC': 455696,
        'Farmington, MO': 317751,
        'Marquette, MI': 261214,
        'Richmond, IN': 242236,
        'Somerset, KY': 390719,
        'Athens, OH': 277831,
        'Marion, IN': 212339,
        'Marion, OH': 252721,
        'Roswell, NM': 324589,
        'Coos Bay, OR': 463861,
        'Red Bluff, CA': 449397,
        'Clearlake, CA': 517729,
        'Baraboo, WI': 377532,
        'Dublin, GA': 358501,
        'Lewiston, ID': 431876,
        'Georgetown, SC': 1056270,
        'Albemarle, NC': 428142,
        'Marinette, WI': 266527,
        'Mount Vernon, OH': 379282,
        'Sanford, NC': 406249,
        'Hutchinson, KS': 281769,
        'Crossville, TN': 528583,
        'Laconia, NH': 798269,
        'Walla Walla, WA': 518662,
        'Charleston, IL': 202067,
        'Gillette, WY': 400368,
        'Enid, OK': 264478,
        'Sturgis, MI': 265376,
        'Sayre, PA': 224119,
        'Marietta, OH': 255189,
        'Salina, KS': 291820,
        'Hudson, NY': 643816,
        'Calhoun, GA': 390285,
        'Fergus Falls, MN': 394237,
        'Oneonta, NY': 268815,
        'Ardmore, OK': 394188,
        'Fremont, OH': 203768,
        'Barre, VT': 447757,
        'Fernley, NV': 527834,
        'Cullowhee, NC': 1592360,
        'Norwalk, OH': 213062,
        'Palestine, TX': 338328,
        'Rutland, VT': 384041,
        'Fort Madison, IA': 177489,
        'Batavia, NY': 219227,
        'Cedar City, UT': 525876,
        'Durango, CO': 1054692,
        'Boone, NC': 824004,
        'Point Pleasant, WV': 243327,
        'Branson, MO': 468943,
        'Carson City, NV': 716908,
        'Fairmont, WV': 231094,
        'Picayune, MS': 344779,
        'Ontario, OR': 437316,
        'Kinston, NC': 268522,
        'Poplar Bluff, MO': 295555,
        'St. Marys, GA': 357644,
        'Waycross, GA': 295025,
        'Elko, NV': 434683,
        'Tiffin, OH': 209221,
        'Edwards, CO': 3252866,
        'Jasper, IN': 277492,
        'Danville, KY': 353903,
        'Sterling, IL': 173304,
        'Sonora, CA': 572746,
        'Oxford, MS': 594076,
        'Glasgow, KY': 292180,
        'Payson, AZ': 657651,
        'Warrensburg, MO': 359741,
        'Athens, TN': 374918,
        'Elizabeth City, NC': 341456,
        'Milledgeville, GA': 381193,
        'Rexburg, ID': 510164,
        'Ashland, OH': 308808,
        'Enterprise, AL': 369401,
        'Jacksonville, TX': 371707,
        'Kerrville, TX': 841562,
        'Gloversville, NY': 242583,
        'Fort Leonard Wood, MO': 275036,
        'Bartlesville, OK': 340144,
        'Scottsboro, AL': 400209,
        'Greenville, OH': 282763,
        'Corsicana, TX': 476944,
        'Newport, OR': 742090,
        'Winona, MN': 313014,
        'Oil City, PA': 147695,
        'Rochelle, IL': 272611,
        'Shelbyville, TN': 472041,
        'Malone, NY': 213304,
        'Paris, TX': 420752,
        'Pullman, WA': 439263,
        'Mason City, IA': 328200,
        'Ellensburg, WA': 763279,
        'Amsterdam, NY': 191242,
        'Gardnerville Ranchos, NV': 1434605,
        'Tahlequah, OK': 324042,
        'Durant, OK': 422774,
        'Cadillac, MI': 288880,
        'Sidney, OH': 284937,
        'Montrose, CO': 714850,
        'Pahrump, NV': 429034,
        'New Castle, IN': 221859,
        'Norfolk, NE': 338977,
        'Cañon City, CO': 488922,
        'Kendallville, IN': 354999,
        'Bemidji, MN': 313829,
        'Blackfoot, ID': 444626,
        'Cortland, NY': 210578,
        'Mount Sterling, KY': 324527,
        'Washington, NC': 398027,
        'Sandpoint, ID': 848435,
        'Nogales, AZ': 444042,
        'Ruston, LA': 425688,
        'Bardstown, KY': 408336,
        'Clinton, IA': 236593,
        'Red Wing, MN': 414607,
        'Plymouth, IN': 367184,
        'Lewistown, PA': 225974,
        'Cornelia, GA': 475754,
        'Marion, NC': 452586,
        'Wapakoneta, OH': 286127,
        'Hillsdale, MI': 259998,
        'Paragould, AR': 327148,
        'Bedford, IN': 284180,
        'Burley, ID': 434089,
        'Menomonie, WI': 308080,
        'Shawano, WI': 293467,
        'Bellefontaine, OH': 330114,
        'Burlington, IA': 250416,
        'Madisonville, KY': 313294,
        'Huntingdon, PA': 196076,
        'Lawrenceburg, TN': 339882,
        'Rolla, MO': 337205,
        'Thomasville, GA': 502902,
        'Lewisburg, PA': 377508,
        'Seymour, IN': 346068,
        'Big Rapids, MI': 286805,
        'Freeport, IL': 219269,
        'McAlester, OK': 313486,
        'Auburn, IN': 327983,
        'Coldwater, MI': 257571,
        'Ponca City, OK': 248110,
        'Willmar, MN': 346378,
        'Duncan, OK': 301002,
        'Cedartown, GA': 336558,
        'Clewiston, FL': 399549,
        'Rock Springs, WY': 376633,
        'Aberdeen, SD': 330509,
        'Sedalia, MO': 267650,
        'Muscatine, IA': 319114,
        'Okeechobee, FL': 517307,
        'Wilmington, OH': 320374,
        'El Campo, TX': 419672,
        'McMinnville, TN': 445295,
        'Gainesville, TX': 700298,
        'Bucyrus, OH': 176665,
        'Celina, OH': 313752,
        'Big Stone Gap, VA': 189401,
        'Astoria, OR': 693649,
        'Alma, MI': 200992,
        'Austin, MN': 321904,
        'Garden City, KS': 300612,
        'Marshalltown, IA': 227749,
        'Riverton, WY': 385435,
        'Murray, KY': 332199,
        'Urbana, OH': 300488,
        'Laramie, WY': 483736,
        'Warren, PA': 172077,
        'Cambridge, OH': 232198,
        'Pittsburg, KS': 266331,
        'Hannibal, MO': 289202,
        'Arcadia, FL': 454435,
        'Newberry, SC': 416506,
        'Ada, OK': 329026,
        'Crawfordsville, IN': 273664,
        'Alexandria, MN': 423063,
        'Sikeston, MO': 237966,
        'Lock Haven, PA': 227239,
        'Defiance, OH': 216584,
        'Brownwood, TX': 386105,
        'Greenwood, MS': 270124,
        'Kill Devil Hills, NC': 1039557,
        'Logansport, IN': 166343,
        'Scottsbluff, NE': 275946,
        'Easton, MD': 1218860,
        'Mayfield, KY': 287261,
        'Campbellsville, KY': 271673,
        'Owatonna, MN': 351415,
        'Vincennes, IN': 218224,
        'Coshocton, OH': 292069,
        'Huntington, IN': 254253,
        'Fremont, NE': 297950,
        'Jackson, WY': 1806706,
        'Vernal, UT': 398759,
        'Lebanon, MO': 368158,
        'Decatur, IN': 307158,
        'Brenham, TX': 740604,
        'Hutchinson, MN': 340966,
        'Emporia, KS': 244352,
        'Brookings, SD': 358221,
        'North Platte, NE': 279689,
        'Pontiac, IL': 189689,
        'Bennington, VT': 666413,
        'Peru, IN': 209837,
        'Butte, MT': 442428,
        'Ottumwa, IA': 224204,
        'Angola, IN': 532537,
        'Laurinburg, NC': 321201,
        'Brevard, NC': 814342,
        'Americus, GA': 275195,
        'Effingham, IL': 331669,
        'Seneca Falls, NY': 247567,
        'Dixon, IL': 212532,
        'Washington, IN': 299462,
        'Dayton, TN': 428546,
        'Columbus, NE': 410477,
        'Dodge City, KS': 244428,
        'Dickinson, ND': 346474,
        'Jackson, OH': 268007,
        'Frankfort, IN': 249990,
        'Madison, IN': 340510,
        'Taylorville, IL': 156841,
        'Cambridge, MD': 417099,
        'Juneau, AK': 615729,
        'Coffeyville, KS': 152745,
        'Hastings, NE': 287618,
        'Berlin, NH': 338199,
        'Miami, OK': 244740,
        'Sheridan, WY': 597891,
        'Wabash, IN': 214616,
        'Breckenridge, CO': 2493935,
        'Albert Lea, MN': 263354,
        'Susanville, CA': 371301,
        'Kirksville, MO': 297035,
        'Iron Mountain, MI': 204076,
        'Mineral Wells, TX': 1079868,
        'Macomb, IL': 141462,
        'Ludington, MI': 337092,
        'Fort Morgan, CO': 420311,
        'Hays, KS': 287799,
        'Weatherford, OK': 228081,
        'Washington Court House, OH': 286008,
        'McPherson, KS': 300735,
        'Elkins, WV': 188574,
        'Van Wert, OH': 204037,
        'North Vernon, IN': 278350,
        'Mountain Home, ID': 429102,
        'Silver City, NM': 339337,
        'Fredericksburg, TX': 1104795,
        'Wauchula, FL': 350284,
        'Greensburg, IN': 338372,
        'La Grande, OR': 397820,
        'Thomaston, GA': 348599,
        'The Dalles, OR': 471059,
        'Spearfish, SD': 569414,
        'Toccoa, GA': 398398,
        'Ottawa, KS': 331003,
        'Great Bend, KS': 176121,
        'Steamboat Springs, CO': 2444336,
        'Lexington, NE': 264534,
        'Middlesborough, KY': 190388,
        'Fallon, NV': 488564,
        'Marshall, MN': 287761,
        'Prineville, OR': 667839,
        'New Ulm, MN': 280038,
        'Indianola, MS': 129217,
        'Hailey, ID': 2844043,
        'Moberly, MO': 261359,
        'Mitchell, SD': 370407,
        'Hood River, OR': 949979,
        'Connersville, IN': 189035,
        'Oskaloosa, IA': 282486,
        'Wahpeton, ND': 296188,
        'Sterling, CO': 352050,
        'Beatrice, NE': 236142,
        'Liberal, KS': 204602,
        'Pierre, SD': 381844,
        'Evanston, WY': 411832,
        'Othello, WA': 367483,
        'Storm Lake, IA': 255302,
        'Parsons, KS': 147718,
        'Los Alamos, NM': 652996,
        'Fairfield, IA': 285604,
        'Spirit Lake, IA': 641698,
        'Vineyard Haven, MA': 2858766,
        'Maysville, KY': 307397,
        'Winnemucca, NV': 437365,
        'Atchison, KS': 259661,
        'Spencer, IA': 285577,
        'Vermillion, SD': 327033,
        'Ketchikan, AK': 519594,
        'Craig, CO': 373376,
    },
};

export const zhviByStateByHomeSize = {
    CONDO: {
        CA: 638595,
        TX: 246907,
        FL: 299544,
        NY: 456933,
        PA: 240044,
        IL: 218964,
        OH: 194800,
        GA: 284659,
        NC: 288878,
        MI: 247508,
        NJ: 366671,
        VA: 314733,
        WA: 430808,
        AZ: 290319,
        MA: 472908,
        TN: 321327,
        IN: 215494,
        MO: 205078,
        MD: 273318,
        WI: 244373,
        CO: 402730,
        MN: 216159,
        SC: 270647,
        AL: 325088,
        LA: 181554,
        KY: 200876,
        OR: 350470,
        OK: 130589,
        CT: 235341,
        IA: 174872,
        UT: 400294,
        AR: 223000,
        MS: 209626,
        NV: 248203,
        KS: 181219,
        NM: 257851,
        NE: 222710,
        WV: 158307,
        ID: 413324,
        HI: 566027,
        NH: 339491,
        ME: 378050,
        RI: 327048,
        MT: 402509,
        DE: 396312,
        SD: 232270,
        ND: 179945,
        AK: 233647,
        DC: 440946,
        VT: 313285,
        WY: 406761,
    },
    '1_BED': {
        CA: 506344,
        TX: 168410,
        FL: 214781,
        NY: 418610,
        PA: 173873,
        IL: 175488,
        OH: 110924,
        GA: 240711,
        NC: 210270,
        MI: 165212,
        NJ: 286746,
        VA: 259838,
        WA: 387687,
        AZ: 245514,
        MA: 384423,
        TN: 260242,
        IN: 116464,
        MO: 123470,
        MD: 215460,
        WI: 160891,
        CO: 340142,
        MN: 180043,
        SC: 204128,
        AL: 172100,
        LA: 157410,
        KY: 112653,
        OR: 324079,
        OK: 93637,
        CT: 184287,
        UT: 344738,
        AR: 137633,
        MS: 113745,
        NV: 208384,
        KS: 83262,
        NM: 214334,
        NE: 132570,
        WV: 88830,
        ID: 337871,
        HI: 487746,
        NH: 227613,
        ME: 252949,
        RI: 275634,
        MT: 314016,
        DE: 189266,
        SD: 155348,
        ND: 124899,
        AK: 179492,
        DC: 401287,
        VT: 236344,
        WY: 232048,
    },
    '2_BED': {
        CA: 606607,
        TX: 188384,
        FL: 288366,
        NY: 282508,
        PA: 184051,
        IL: 196064,
        OH: 140028,
        GA: 218706,
        NC: 213650,
        MI: 169622,
        NJ: 342403,
        VA: 245612,
        WA: 440156,
        AZ: 339708,
        MA: 437671,
        TN: 227192,
        IN: 141509,
        MO: 148023,
        MD: 264435,
        WI: 200202,
        CO: 413613,
        MN: 249038,
        SC: 201236,
        AL: 143037,
        LA: 142420,
        KY: 141001,
        OR: 376085,
        OK: 99800,
        CT: 256839,
        IA: 137686,
        UT: 378744,
        AR: 150255,
        MS: 114785,
        NV: 306156,
        KS: 111348,
        NM: 233456,
        NE: 168948,
        WV: 95292,
        ID: 340386,
        HI: 617621,
        NH: 329378,
        ME: 309223,
        RI: 339693,
        MT: 335760,
        DE: 243243,
        SD: 216393,
        ND: 181371,
        AK: 243095,
        DC: 584639,
        VT: 292644,
        WY: 238791,
    },
    '3_BED': {
        CA: 680278,
        TX: 272053,
        FL: 375722,
        NY: 280680,
        PA: 235626,
        IL: 239245,
        OH: 193005,
        GA: 273705,
        NC: 291980,
        MI: 222987,
        NJ: 433334,
        VA: 314313,
        WA: 532755,
        AZ: 396798,
        MA: 521615,
        TN: 300806,
        IN: 212653,
        MO: 225548,
        MD: 345344,
        WI: 264542,
        CO: 506482,
        MN: 305749,
        SC: 271714,
        AL: 211141,
        LA: 204758,
        KY: 207797,
        OR: 460438,
        OK: 187085,
        CT: 339245,
        IA: 199104,
        UT: 462336,
        AR: 216408,
        MS: 178618,
        NV: 394192,
        KS: 199942,
        NM: 288784,
        NE: 239440,
        WV: 154369,
        ID: 414398,
        HI: 879148,
        NH: 428401,
        ME: 359778,
        RI: 405289,
        MT: 449124,
        DE: 311506,
        SD: 273012,
        ND: 241578,
        AK: 347852,
        DC: 677922,
        VT: 367515,
        WY: 311293,
    },
    '4_BED': {
        CA: 841901,
        TX: 400335,
        FL: 495952,
        NY: 435963,
        PA: 385098,
        IL: 354974,
        OH: 311132,
        GA: 394787,
        NC: 453408,
        MI: 344324,
        NJ: 592964,
        VA: 483103,
        WA: 694105,
        AZ: 489944,
        MA: 706295,
        TN: 452862,
        IN: 308969,
        MO: 349509,
        MD: 501940,
        WI: 333921,
        CO: 626928,
        MN: 387216,
        SC: 397788,
        AL: 339259,
        LA: 310937,
        KY: 318882,
        OR: 600602,
        OK: 304065,
        CT: 488944,
        IA: 272658,
        UT: 527067,
        AR: 336940,
        MS: 295410,
        NV: 480543,
        KS: 326281,
        NM: 377351,
        NE: 334592,
        WV: 224793,
        ID: 487969,
        HI: 1097449,
        NH: 554609,
        ME: 433841,
        RI: 540391,
        MT: 498768,
        DE: 441136,
        SD: 332527,
        ND: 302005,
        AK: 444503,
        DC: 968708,
        VT: 449891,
        WY: 363803,
    },
    '5_BED': {
        CA: 1109443,
        TX: 594513,
        FL: 744072,
        NY: 671407,
        PA: 438189,
        IL: 464300,
        OH: 383033,
        GA: 554077,
        NC: 636684,
        MI: 412263,
        NJ: 896332,
        VA: 701507,
        WA: 820215,
        AZ: 672850,
        MA: 979683,
        TN: 610688,
        IN: 423131,
        MO: 439187,
        MD: 658771,
        WI: 383099,
        CO: 751398,
        MN: 495465,
        SC: 531280,
        AL: 481949,
        LA: 456207,
        KY: 428376,
        OR: 701740,
        OK: 422715,
        CT: 799898,
        IA: 369123,
        UT: 648791,
        AR: 469861,
        MS: 394251,
        NV: 616354,
        KS: 391118,
        NM: 481290,
        NE: 396830,
        WV: 291047,
        ID: 556519,
        HI: 1239980,
        NH: 630788,
        ME: 525875,
        RI: 682635,
        MT: 585779,
        DE: 588420,
        SD: 458577,
        ND: 397722,
        AK: 527638,
        DC: 1530100,
        VT: 506937,
        WY: 460126,
    },
};

export const zhviByCountryByHomeSize = {
    CONDO: { 'United States': 334972 },
    '1_BED': { 'United States': 249944 },
    '2_BED': { 'United States': 258234 },
    '3_BED': { 'United States': 310840 },
    '4_BED': { 'United States': 457044 },
    '5_BED': { 'United States': 640871 },
};
